<template>
    <div class="container-fluid">
        <div class="row">
            <!-- 타이틀 + 창고관리 버튼 -->
            <div class="col-lg-12">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                        <h4 class="mb-3">재고관리</h4>
                        <p class="mb-0">해외/국내 창고의 재고 현황을 확인하고 관리할 수 있습니다.</p>
                    </div>

                </div>
            </div>

            <!-- 로딩 오버레이 -->
            <div class="col-lg-12 text-center py-5" v-if="showspinner">
                <img style="max-width:100%;" :src="require('../../../assets/images/small/spinner.gif')">
                <p class="text-muted mt-2">재고 데이터를 불러오는 중...</p>
            </div>

            <!-- 📊 대시보드: 전체 현황 요약 -->
            <div class="col-lg-12" v-if="showreqlist">
                <b-card class="mb-3">
                    <div class="d-flex flex-wrap align-items-center" style="gap: 24px;">
                        <!-- 🇨🇳 쿠패스 -->
                        <div class="d-flex align-items-center" style="gap: 8px;">
                            <span class="font-weight-bold" style="font-size: 14px;">🇨🇳 쿠패스</span>
                            <span class="badge badge-light border px-2 py-1">배송완료 <b class="text-info">{{ statusCounts.배송완료 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">입고작업 <b class="text-warning">{{ statusCounts.입고작업 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">출고요청 <b class="text-warning">{{ statusCounts.출고요청 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">출고대기 <b class="text-primary">{{ statusCounts.출고대기 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">중국재고 <b class="text-dark">{{ statusCounts.중국재고 }}</b></span>
                        </div>
                        <!-- 🚢 이동중 -->
                        <div class="d-flex align-items-center" style="gap: 8px;">
                            <span class="font-weight-bold" style="font-size: 14px;">🚢 이동중</span>
                            <span class="badge badge-light border px-2 py-1">출고완료 <b class="text-success">{{ statusCounts.출고완료 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">해외입고중 <b class="text-secondary">{{ statusCounts.해외입고중 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">국내입고중 <b class="text-secondary">{{ statusCounts.국내입고중 }}</b></span>
                            <span class="badge badge-light border px-2 py-1">국내창고입고중 <b class="text-info">{{ statusCounts.국내창고입고중 }}</b></span>
                        </div>
                        <!-- 🇰🇷 국내 -->
                        <div class="d-flex align-items-center" style="gap: 8px;">
                            <span class="font-weight-bold" style="font-size: 14px;">🇰🇷 국내</span>
                            <span class="badge badge-light border px-2 py-1">국내창고입고완료 <b class="text-success">{{ statusCounts.국내창고입고완료 }}</b></span>
                        </div>
                    </div>
                </b-card>
            </div>

            <!-- 탭 전환 -->
            <div class="col-lg-12" v-if="showreqlist">
                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'overseas' }" href="#" @click.prevent="switchTab('overseas')">
                            🇨🇳 해외재고 <span class="badge badge-dark ml-1">{{ statusCounts.중국재고 }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'domestic' }" href="#" @click.prevent="switchTab('domestic')">
                            🇰🇷 국내재고 <span class="badge badge-success ml-1">{{ inventoryList.length || statusCounts.국내창고입고완료 }}</span>
                            <span v-if="pendingInboundList.length > 0" class="badge badge-warning ml-1">입고대기 {{ pendingInboundList.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'history' }" href="#" @click.prevent="switchTab('history')">
                            📋 입출고이력
                        </a>
                    </li>
                </ul>

                <!-- 해외재고 탭: 출고요청 버튼 -->
                <div v-if="activeTab === 'overseas'" class="mb-3">
                    <button type="button" class="btn btn-warning btn-sm" @click="requestShipment" :disabled="tableSelectedItem.length === 0">
                        <i class="fas fa-shipping-fast mr-1"></i>출고요청 ({{ tableSelectedItem.length }}건)
                    </button>
                    <small class="text-muted ml-2">선택한 중국재고 물건의 출고를 요청합니다 (중국재고 → 출고요청)</small>
                </div>

                <!-- 국내재고 탭: 창고관리 + 위치설정 + 수동입고/출고/재고수정 버튼 -->
                <div v-if="activeTab === 'domestic'" class="mb-3">
                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="openWarehouseModal">
                        <i class="fas fa-warehouse mr-1"></i>창고 레이아웃 관리
                    </button>
                    <button type="button" class="btn btn-info btn-sm mr-2" @click="showLocationChange = !showLocationChange" :disabled="tableSelectedItem.length === 0">
                        <i class="fas fa-map-marker-alt mr-1"></i>위치설정
                        <b-badge variant="light" class="ml-1" v-if="tableSelectedItem.length > 0">{{ tableSelectedItem.length }}</b-badge>
                    </button>
                    <button type="button" class="btn btn-success btn-sm mr-2" @click="showManualInboundModal = true">
                        <i class="fas fa-plus-circle mr-1"></i>수동 입고
                    </button>
                    <button type="button" class="btn btn-danger btn-sm mr-2" @click="openOutboundModal" :disabled="tableSelectedItem.length === 0">
                        <i class="fas fa-minus-circle mr-1"></i>출고 ({{ tableSelectedItem.length }}건)
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="openAuditModal" :disabled="inventoryList.length === 0">
                        <i class="fas fa-clipboard-check mr-1"></i>재고 수정
                    </button>
                    <!-- 정본 §5 Phase 4. 쿠팡센터로 다시 보내는 건 '출고요청'이 아니라 새 선적이다.
                         쿠팡 말고 폐기·기부·다른 마켓으로도 빠지므로 버튼 이름에 쿠팡을 박지 않는다
                         (2026-08-30: 행선지 선택이 생기기 전 이름이 '쿠팡센터로 출고' 였다). -->
                    <button type="button" class="btn btn-primary btn-sm mr-2" @click="openDomesticShipModal" :disabled="tableSelectedItem.length === 0">
                        <i class="fas fa-truck mr-1"></i>국내창고 출고 ({{ tableSelectedItem.length }}건)
                    </button>
                    <button type="button" class="btn btn-outline-success btn-sm" @click="openDomesticReceiptModal">
                        <i class="fas fa-box-open mr-1"></i>국내창고 입고
                    </button>
                    <!-- 위치설정 Collapse 패널 -->
                    <b-collapse v-model="showLocationChange" class="mt-2">
                        <b-card>
                            <div class="row align-items-end">
                                <div class="col-md-3">
                                    <label class="form-label font-weight-bold mb-1">창고</label>
                                    <b-form-select v-model="batchLocationWarehouse" :options="warehouseOptions" size="sm"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label font-weight-bold mb-1">구역</label>
                                    <b-form-select v-model="batchLocationArea" :options="areaOptions" size="sm" :disabled="!batchLocationWarehouse"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label font-weight-bold mb-1">층</label>
                                    <b-form-select v-model="batchLocationLevel" :options="levelOptions" size="sm" :disabled="!batchLocationArea"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <b-button variant="info" size="sm" @click="executeBatchLocationChange" :disabled="!batchLocationLevel || batchLocationProcessing || tableSelectedItem.length === 0">
                                        <b-spinner small v-if="batchLocationProcessing"></b-spinner>
                                        {{ batchLocationProcessing ? '설정중...' : '위치 설정' }}
                                    </b-button>
                                </div>
                            </div>
                            <small class="text-muted mt-2 d-block">
                                선택된 {{ tableSelectedItem.length }}개 항목의 위치를 일괄 설정합니다.
                                <span v-if="batchLocationWarehouse && batchLocationArea && batchLocationLevel" class="text-info">
                                    → {{ batchLocationWarehouse }} > {{ batchLocationArea }} > {{ batchLocationLevel }}
                                </span>
                            </small>
                        </b-card>
                    </b-collapse>

                    <!-- 📥 입고대기 섹션 -->
                    <div v-if="pendingInboundList.length > 0" class="mt-2">
                        <b-button variant="outline-warning" size="sm" @click="showPendingInbound = !showPendingInbound">
                            📥 입고대기 {{ pendingInboundList.length }}건
                            <i :class="showPendingInbound ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-1"></i>
                        </b-button>
                        <b-collapse v-model="showPendingInbound" class="mt-2">
                            <b-card border-variant="warning">
                                <p class="text-muted small mb-2">출고완료 후 국내창고로 이동중인 물건입니다. 실물 확인 후 입고 승인해주세요.</p>
                                <b-table-simple small hover responsive>
                                    <b-thead>
                                        <b-tr>
                                            <b-th style="width:50px">이미지</b-th>
                                            <b-th>상품명</b-th>
                                            <b-th style="width:120px">바코드</b-th>
                                            <b-th style="width:80px" class="text-center">수량</b-th>
                                            <b-th style="width:100px" class="text-center">액션</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="pi in pendingInboundList" :key="pi._id">
                                            <b-td><img :src="pi.등록이미지" class="rounded" style="width:40px;height:40px;object-fit:cover;" alt=""></b-td>
                                            <b-td>
                                                <div>{{ pi.상품명 }}</div>
                                                <small class="text-muted">{{ pi.SKUID }}</small>
                                            </b-td>
                                            <b-td><small>{{ pi.바코드 }}</small></b-td>
                                            <b-td class="text-center">{{ pi.구매요청수량 || 1 }}</b-td>
                                            <b-td class="text-center">
                                                <b-button variant="success" size="sm" @click="openInboundModal(pi)">
                                                    <i class="fas fa-check mr-1"></i>입고승인
                                                </b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>
            </div>
            <!-- 입출고이력 탭 전용 UI -->
            <div class="col-lg-12" v-if="showreqlist && activeTab === 'history'">
                <!-- 날짜 필터 -->
                <div class="d-flex align-items-center mb-3" style="gap: 8px;">
                    <b-form-input type="date" v-model="historyStartDate" size="sm" style="max-width: 160px;"></b-form-input>
                    <span>~</span>
                    <b-form-input type="date" v-model="historyEndDate" size="sm" style="max-width: 160px;"></b-form-input>
                    <b-button variant="primary" size="sm" @click="loadHistoryData">
                        <i class="fas fa-search mr-1"></i>조회
                    </b-button>
                    <div class="btn-group btn-group-sm ml-2">
                        <b-button variant="outline-secondary" @click="setHistoryRange('week')">1주</b-button>
                        <b-button variant="outline-secondary" @click="setHistoryRange('month')">1개월</b-button>
                        <b-button variant="outline-secondary" @click="setHistoryRange('3month')">3개월</b-button>
                    </div>
                    <b-spinner small v-if="historyLoading" class="ml-2"></b-spinner>
                </div>
                <!-- 수불부 요약 카드 -->
                <b-card class="mb-3" v-if="historySummary">
                    <div class="d-flex flex-wrap align-items-center" style="gap: 20px;">
                        <div class="text-center">
                            <small class="text-muted d-block">기초재고</small>
                            <b class="text-dark" style="font-size: 18px;">{{ historySummary.opening }}</b>
                        </div>
                        <span style="font-size: 20px; color: #28a745;">+</span>
                        <div class="text-center">
                            <small class="text-muted d-block">입고</small>
                            <b class="text-success" style="font-size: 18px;">{{ historySummary.incoming }}</b>
                        </div>
                        <span style="font-size: 20px; color: #dc3545;">−</span>
                        <div class="text-center">
                            <small class="text-muted d-block">출고</small>
                            <b class="text-danger" style="font-size: 18px;">{{ historySummary.outgoing }}</b>
                        </div>
                        <span style="font-size: 20px;">=</span>
                        <div class="text-center">
                            <small class="text-muted d-block">기말재고</small>
                            <b class="text-primary" style="font-size: 18px;">{{ historySummary.closing }}</b>
                        </div>
                    </div>
                </b-card>
                <!-- 검색 -->
                <div class="mb-2">
                    <b-input-group size="sm" style="max-width: 350px;">
                        <b-input-group-prepend is-text><i class="fas fa-search"></i></b-input-group-prepend>
                        <b-form-input v-model="historySearchKeyword" placeholder="상품명, SKU, 바코드 검색..."></b-form-input>
                        <b-input-group-append v-if="historySearchKeyword">
                            <b-button variant="outline-secondary" @click="historySearchKeyword = ''"><i class="fas fa-times"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <CDataTable
                    storage-key="stockManagement.1" :headers="historyHeaders" :items="filteredHistoryList" itemKey="_id">
                    <template v-slot:상품명="{ item }">
                        <div class="d-flex align-items-center p-1">
                            <img :src="item.이미지" class="img-fluid rounded avatar-40 mr-2" alt="">
                            <div>
                                <span>{{ item.상품명 }}</span>
                                <p class="mb-0 text-muted"><small>{{ item.SKUID || item.barcode }}</small></p>
                            </div>
                        </div>
</template>
                    <template v-slot:changeDate="{ item }">
                        {{ getTimeDate(item.changeDate).split(' ')[0] }}
                    </template>
                    <template v-slot:구분="{ item }">
                        <span :class="getHistoryTypeBadge(item.type)">{{ getHistoryTypeLabel(item.type) }}</span>
                    </template>
                </CDataTable>
            </div>

            <!-- 해외/국내 재고 테이블 (기존) -->
            <div class="col-lg-12" v-if="showreqlist && activeTab !== 'history'">
                <!-- 검색 -->
                <div class="mb-2">
                    <b-input-group size="sm" style="max-width: 350px;">
                        <b-input-group-prepend is-text><i class="fas fa-search"></i></b-input-group-prepend>
                        <b-form-input v-model="searchKeyword" placeholder="상품명, SKU, 바코드 검색..." @input="searchKeyword = $event"></b-form-input>
                        <b-input-group-append v-if="searchKeyword">
                            <b-button variant="outline-secondary" @click="searchKeyword = ''"><i class="fas fa-times"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>

                <CDataTable
                    storage-key="stockManagement.2" :headers="currentHeaders" :items="filteredReqlists" v-model="tableSelectedItem" :show-select="true"
                    itemKey="_id">
                    <!-- 보관위치 관련 슬롯들 -->
                    <template v-slot:창고="{ item }">
                        <span v-if="item.위치정보 && item.위치정보.창고"
                              class="badge badge-primary"
                              style="cursor: pointer;"
                              @click="filterByLocation('창고', item.위치정보.창고)"
                              :title="`${item.위치정보.창고} 클릭하여 필터링`">
                            <i class="fas fa-warehouse mr-1"></i>{{ item.위치정보.창고 }}
                        </span>
                        <span v-else class="text-muted small">미설정</span>
                    </template>

                    <template v-slot:구역="{ item }">
                        <span v-if="item.위치정보 && item.위치정보.구역"
                              class="badge badge-info"
                              style="cursor: pointer;"
                              @click="showLocationOnCanvas(item.위치정보)"
                              :title="`${item.위치정보.구역} 클릭하여 레이아웃에서 보기`">
                            <i class="fas fa-map-marker-alt mr-1"></i>{{ item.위치정보.구역 }}
                        </span>
                        <span v-else class="text-muted small">미설정</span>
                    </template>

                    <template v-slot:층="{ item }">
                        <span v-if="item.위치정보 && item.위치정보.층"
                              class="badge badge-success"
                              style="cursor: pointer;"
                              @click="showLocationOnCanvas(item.위치정보)"
                              :title="`${item.위치정보.층} 클릭하여 레이아웃에서 보기`">
                            <i class="fas fa-layer-group mr-1"></i>{{ item.위치정보.층 }}
                        </span>
                        <span v-else class="text-muted small">미설정</span>
                    </template>

                    <template v-slot:요청일="{ item }">
                        {{ getTimeDate(item.요청일) }}
                    </template>
                    <template v-slot:입고일="{ item }">
                        {{ getIngoDate(item) }}
                    </template>
                    <template v-slot:최종입고일="{ item }">
                        {{ item.최종입고일 ? item.최종입고일.substring(0, 10) : '-' }}
                    </template>
                    <template v-slot:reqtype="{ item }">
                        {{ item.reqtype == '제트배송' ? '로켓그로스' : item.reqtype }}
                    </template>
                    <template v-slot:요청변경="{ item }">
                        <div v-if="item.changeHistory && item.changeHistory.length > 0">
                            <b-icon icon="journal-text" font-scale="1.2" class="text-primary"
                                v-b-tooltip.hover.html="getChangeHistoryTooltip(item)"></b-icon>
                        </div>
                    </template>
                    <template v-slot:history="{ item }">
                        <div v-if="item.statusHistory && item.statusHistory.length > 0">
                            <b-icon icon="clock-history" font-scale="1.2" class="text-info"
                                v-b-tooltip.hover.html="getStatusHistoryTooltip(item)"></b-icon>
                        </div>
                    </template>
                    <template v-slot:묶음구성여부="{ item }">
                        {{ item.묶음구성여부 ? item.묶음구성수량 + '개' : "" }}<br><small>{{ item.묶음구성여부 ? '(' + item.바코드 + ")" :
                            "" }}</small>
                    </template>
                    <template v-slot:상품명="{ item }">
                        <div class="d-flex align-items-center p-1">
                            <img :src="item.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
                            <div>
                                {{ item.상품명 }}
                                <p class="mb-0" style="color: #676E8A"><small>{{ item.SKUID }}</small></p>
                                <p class="mb-0" style="color: #676E8A"><small>{{ item.바코드 }}</small></p>
                            </div>
                        </div>
                        <b-modal :id="getModalId(item)" :ref="'modalRef-' + item._id" title="상품 정보 편집"
                            @show="handleModalShow(item)" @ok="handleModalOk($event, item)"
                            @hidden="handleModalHidden(item)" ok-title="저장" cancel-title="취소" centered size="md">
                            <form ref="editForm" @submit.stop.prevent="submitViaOk(item)">
                                <b-form-group label="상품명" :label-for="'edit-name-' + item._id">
                                    <b-form-input :id="'edit-name-' + item._id" v-model="item.상품명"
                                        required></b-form-input>
                                </b-form-group>
                                <b-form-group label="바코드" :label-for="'edit-barcode-' + item._id">
                                    <b-form-input :id="'edit-barcode-' + item._id" v-model="item.바코드"
                                        required></b-form-input>
                                </b-form-group>
                                <!-- 다른 필드 필요 시 추가 -->
                            </form>
                            <template #modal-footer="{ ok, cancel }">
                                <b-button size="sm" variant="secondary" @click="cancel()">
                                    취소
                                </b-button>
                                <b-button size="sm" variant="primary" @click="ok()">
                                    저장
                                </b-button>
                            </template>
                        </b-modal>
                    </template>
                    <template v-slot:구매링크="{ item }">
                        <a :href="item.구매링크" target="_blank"><b-icon icon="link" scale="2"
                                variant="secondary"></b-icon></a>
                    </template>
                    <template v-slot:action="{ item, index }">
                        <div class="d-flex align-items-center list-action">
                            <a v-if="changeoption" class="badge bg-success mr-2" data-toggle="tooltip" v-b-tooltip.top
                                title="옵션재매칭" href="javascript:void(0)" @click="rematching(item)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-pencil-line mr-0"></i>
                            </a>
                            <a class="badge badge-secondary mr-2" data-toggle="tooltip" v-b-tooltip.top title="확인"
                                href="javascript:void(0)" v-b-modal="'modalDetail' + item._id"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-eye-line mr-0"></i>
                            </a>
                            <a class="badge badge-info mr-2" data-toggle="tooltip" v-b-tooltip.top title="편집"
                                href="javascript:void(0)" v-b-modal="modalID(item._id)"
                                style="width: 30px; height: 30px; display: flex; justify-content: center; align-items: center">
                                <i class="ri-eye-line mr-0"></i>
                            </a>

                            <b-modal :id="'modalDetail' + item._id" size="xl" scrollable title="제품상세" ok-title="OK"
                                cancel-title="Close" class="detail-modal">
                                <div class="row">
                                    <div class="col-md-6">
                                        <img class="w-100 d-block" :src="item.등록이미지"
                                            style="border:1px solid silver; border-radius: 30px">
                                    </div>
                                    <div class="col-md-6">
                                        <p style="font-size:100%">주문수량 : {{ parseInt(item.구매요청수량) * item.판매구성수량 }}</p>
                                        <p style="font-size:100%">구매요청수량 : {{ parseInt(item.구매요청수량) }}</p>
                                        <p style="font-size:100%">판매구성 : {{ item.판매구성수량 }}</p>
                                        <!-- <div class="mb-4">
                                            <div class="row text-center ml-1" id="printMe" style="border:1px solid silver;width:300px">
                                                <div class="col-12 text-center mb-0">
                                                    <p class="mb-0" style="font-size:90%;">Made in China&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>SKU : {{purchase.SKUID}}</span></p>
                                                </div>
                                                <div class="col-12 text-center mb-0">
                                                    <barcode :value="purchase.바코드" :tag="bctag" :options="{ lineColor: '#0275d8', text: 'Scan'}"></barcode>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <button class="btn btn-primary" type="button" @click="print">바코드출력</button>
                                            </div>
                                        </div> -->
                                        <p>상품명 : {{ item.상품명 }}</p>
                                        <p v-if="item.SKUID">SKU ID : {{ item.SKUID }}</p>
                                        <p>바코드 : {{ item.바코드 }}</p>
                                        <p>구매링크 : <a :href="item.구매링크">{{ item.구매링크.slice(0,
                                            item.구매링크.search('.html') + 5) }}</a></p>
                                        <p>옵션1_중국어 : {{ item.옵션1_중국어 }}</p>
                                        <p>옵션2_중국어 : {{ item.옵션2_중국어 }}</p>
                                        <p>[배송 요청사항]</p>
                                        <card style="color:blue;">
                                            <div class="ml-1 mt-1 mb-1 mr-1 row">
                                                <div class="col-5">
                                                    <span><b>[출고작업]</b></span><br>
                                                    <span v-if="item.selectpo">배치 : {{ item.selectpo ? '발주배치' :
                                                        '해당없음' }}</span><br v-if="item.selectpo">
                                                    <span v-if="item.selectpo">배치발주번호 : {{ item.selectpo }}</span><br
                                                        v-if="item.selectpo">
                                                    <span>출고유형 : {{ item.요청내역.exportType.toUpperCase() }}</span><br>
                                                    <br>
                                                    <span><b>[검수 및 포장 작업]</b></span><br>
                                                    <span>기본검수 : {{ item.요청내역.default ? 'Y' : 'N' }}</span><br>
                                                    <span>OPP봉투 : {{ item.요청내역.opp ? 'Y' : 'N' }}</span><br>
                                                    <span>택배봉투(LDPE) : {{ item.요청내역.LDPE ? 'Y' : 'N' }}</span><br>
                                                    <span>에어캡 : {{ item.요청내역.airpacking ? 'Y' : 'N' }}</span><br>
                                                    <br>
                                                </div>
                                                <div class="col-7">
                                                    <span><b>[라벨 및 원산지 작업]</b></span><br>
                                                    <span>바코드 : {{ item.요청내역.barcode ? 'Y' : 'N' }}</span><br>
                                                    <span>한글표시사항 : {{ item.요청내역.한글표시사항 ? 'Y' : 'N' }}</span><br>
                                                    <span>원산지스티커 : {{ item.요청내역.sticker ? 'Y' : 'N' }}</span><br>
                                                    <span>도장 : {{ item.요청내역.stamp ? 'Y' : 'N' }}</span><br>
                                                    <span>택총 : {{ item.요청내역.tag ? 'Y' : 'N' }}</span><br>
                                                    <br>
                                                    <span><b>[통관 정보]</b></span><br>
                                                    <span>신고영문명 : {{ item.신고영문명 ? item.신고영문명 : '' }}</span><br>
                                                    <span>신고단가(USD) : {{ item.주문정보 ?
                                                        Math.ceil(item.주문정보.총금액 / item.구매요청수량 / 7.4 * 100) / 100 :
                                                        '' }}</span><br>
                                                    <span>HS-CODE : {{ item.HSCODE ? item.HSCODE : '' }}</span><br>
                                                    <br>
                                                    <span><b>[기타 요청사항] - 물류</b></span><br>
                                                    <span>{{ item.요청내역.reqcontent }}</span><br>
                                                    <span><b>[기타 요청사항] - 구매</b></span><br>
                                                    <span>{{ item.요청내역?.reqcontentPurchase }}</span><br>
                                                </div>
                                            </div>
                                        </card>
                                        <!-- <p :style="item.입고오류유형 == '' ? 'font-size:120%;font-weight:bold;color:black' : 'font-size:120%;font-weight:bold;color:red'">입고오류유형 : {{item.입고오류유형 ? item.입고오류유형 : ''}}</p>
                                        <p style="font-size:120%;font-weight:bold;color:red" v-if="item.입고오류유형 == '수량불일치'">입고수량 : {{item.입고수량}}</p>
                                        <p style="font-size:120%;font-weight:bold;color:red" v-if="item.입고오류유형 != '' && item.입고오류유형 != '수량불일치'">입고오류내용 : {{item.입고오류내용}}</p>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <button :class="importerrorbutton == '입고처리' ? 'btn btn-secondary' : 'btn btn-danger'" type="button" @click="importerror(item)">{{importerrorbutton}}</button>
                                            </div>
                                            <div class="col-md-8" v-if="showimporterror">
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="customRadio15" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="입고완료처리">
                                                    <label class="custom-control-label" for="customRadio15">입고완료처리</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="customRadio16" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="반품">
                                                    <label class="custom-control-label" for="customRadio16">반품</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="customRadio17" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="폐기">
                                                    <label class="custom-control-label" for="customRadio17">폐기</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="customRadio18" name="customRadio-4" class="custom-control-input" @change="changeimporterror(item)" v-model="item.처리방법" value="입고대기">
                                                    <label class="custom-control-label" for="customRadio18">입고대기</label>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-2" v-if="showimporterror && showimporterror1">
                                                <div class="form-group">
                                                    <label for="exampleFormControlTextarea1">반품정보</label>
                                                    <input type="text" class="form-control" placeholder="반품수취인" v-model="item.반품수취인">
                                                    <input type="text" class="form-control" placeholder="반품연락처" v-model="item.반품연락처">
                                                    <textarea class="form-control" placeholder="반품주소" id="exampleFormControlTextarea1" rows="3" v-model="item.반품주소"></textarea>
                                                    <input type="text" class="form-control" placeholder="반품운송장번호" v-model="item.반품운송장번호">
                                                </div>
                                            </div>
                                            <div class="col-md-12 mt-2" v-if="showimporterror && showimporterror2">
                                                <div class="form-group">
                                                    <label for="exampleFormControlTextarea1">입고대기 사유</label>
                                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="item.입고대기사유"></textarea>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </b-modal>

                            <b-modal :id="'modal' + item._id" @shown="showModal(item)" size="xl" title="구매요청사항"
                                ok-title="Save Changes" cancel-title="Close" @ok="saverequest(item)">
                                <div class="row" v-if="item.reqtype == '제트배송'">
                                    <div class="reqpo-purchase-request-form">
                                        <div class="row">
                                            <!-- Row 1: Items 1-2 -->
                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">1. 구매요청수량</div>
                                                    <div class="reqpo-input-wrapper">
                                                        <div class="d-flex align-items-center">
                                                            <input type="number" :min="0"
                                                                class="form-control text-center" style="width: 120px;"
                                                                v-model="item.구매요청수량"
                                                                @keyup.enter="validateQuantity(item)">
                                                            <div class="reqpo-stock-info ml-3">
                                                                <span class="reqpo-info-label">최소주문:</span>
                                                                <span class="reqpo-info-value">{{
                                                                    getMinOrderQuantity(item) }}개</span>
                                                                <span class="reqpo-separator">/</span>
                                                                <span class="reqpo-info-label">재고:</span>
                                                                <span class="reqpo-info-value">{{
                                                                    getAvailableStock(item) }}개</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">2. 판매구성수량</div>
                                                    <div class="reqpo-input-wrapper">
                                                        <input type="number" :min="0" class="form-control"
                                                            style="width: 120px;" v-model="item.판매구성수량"
                                                            v-b-tooltip.hover="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Row 2: Items 3-4 -->
                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">3. A-B번들 묶음구성여부</div>
                                                    <div class="bundle-options">
                                                        <div class="custom-control custom-switch d-inline-block">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'bundleSwitch' + index" v-model="item.묶음구성여부"
                                                                @change="confirmBarcode(item)">
                                                            <label class="custom-control-label"
                                                                :for="'bundleSwitch' + index">묶음구성</label>
                                                        </div>
                                                        <div v-if="item.묶음구성여부" class="bundle-count mt-2">
                                                            <input type="number" :min="0" class="form-control"
                                                                style="width: 120px;" placeholder="종류갯수"
                                                                v-model="item.묶음구성수량"
                                                                v-b-tooltip.hover="'3종의 제품을 묶음 구성하는 경우 3으로 작성'">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">4. 도착지</div>
                                                    <div class="destination-options">
                                                        <div class="btn-group w-100">
                                                            <button type="button" class="btn"
                                                                :class="{ 'btn-primary': item.요청내역.destination === 'coupang', 'btn-outline-primary': item.요청내역.destination !== 'coupang' }"
                                                                @click="item.요청내역.destination = 'coupang'">
                                                                쿠팡센터
                                                            </button>
                                                            <button type="button" class="btn"
                                                                :class="{ 'btn-primary': item.요청내역.destination === 'customer', 'btn-outline-primary': item.요청내역.destination !== 'customer' }"
                                                                @click="item.요청내역.destination = 'customer'">
                                                                화주
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Row 3: Items 5-7 -->
                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">5. 출고형태</div>
                                                    <div class="export-options">
                                                        <div class="custom-control custom-radio mb-2">
                                                            <input type="radio" :id="'exportBox' + index"
                                                                name="exportType" class="custom-control-input"
                                                                v-model="item.요청내역.exportType" value="box">
                                                            <label class="custom-control-label"
                                                                :for="'exportBox' + index">
                                                                <span
                                                                    v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                                    밀크런 택배
                                                                </span>
                                                                <span v-else>택배</span>
                                                            </label>
                                                        </div>
                                                        <div class="custom-control custom-radio">
                                                            <input type="radio" :id="'exportPallet' + index"
                                                                name="exportType" class="custom-control-input"
                                                                v-model="item.요청내역.exportType" value="pallet">
                                                            <label class="custom-control-label"
                                                                :for="'exportPallet' + index">
                                                                <span
                                                                    v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                                    밀크런 파렛트 <small
                                                                        class="reqpo-text-muted">(￦35,000/pallet)</small>
                                                                </span>
                                                                <span v-else>
                                                                    파렛트 <small
                                                                        class="reqpo-text-muted">(￦20,000/pallet)</small>
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- </div>

                                                <div class="col-md-6"> -->
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">6. 통관정보</div>
                                                    <div class="row">
                                                        <div class="col-12 mb-3">
                                                            <div class="form-group">
                                                                <label>신고영문명</label>
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) shoes" v-model="item.신고영문명">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>HS-CODE</label>
                                                                <div class="d-flex">
                                                                    <input type="text" class="form-control"
                                                                        placeholder="예) 6401.10-1000"
                                                                        v-model="item.HSCODE">
                                                                    <div class="w-25 d-flex align-items-center"><a
                                                                            href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                            target="_blank"
                                                                            class="btn btn-outline-secondary ml-2">
                                                                            검색
                                                                        </a></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">7. 통관형태</div>
                                                    <div class="customs-options">
                                                        <div class="reqpo-custom-radio-card mb-2"
                                                            :class="{ 'active': item.요청내역.customsType === 'integrated' }"
                                                            @click="item.요청내역.customsType = 'integrated'">
                                                            <div class="reqpo-card-title">쿠패스통합통관</div>
                                                            <div class="reqpo-card-desc">위안화x280, 검수/포장비용 제외 모든비용 포함
                                                            </div>
                                                        </div>
                                                        <div class="reqpo-custom-radio-card mb-2"
                                                            :class="{ 'active': item.요청내역.customsType === 'client' }"
                                                            @click="item.요청내역.customsType = 'client'">
                                                            <div class="reqpo-card-title">화주단독통관</div>
                                                            <div class="reqpo-card-desc">구매대행수수료3%, 자재, 관부가세, 해운비, 통관비,
                                                                통관서류 비용 등 별도</div>
                                                        </div>
                                                        <div class="reqpo-custom-radio-card"
                                                            :class="{ 'active': item.요청내역.customsType === 'kupass' }"
                                                            @click="item.요청내역.customsType = 'kupass'">
                                                            <div class="reqpo-card-title">쿠패스단독통관</div>
                                                            <div class="reqpo-card-desc">식검제품만 신청가능, 구매대행수수료3%, 자재,
                                                                관부가세, 해운비, 통관비, 통관서류 비용 등 별도</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Full width sections -->
                                            <div class="col-md-6">
                                                <!-- 검수 및 포장 섹션 -->
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">8. 검수 및 포장</div>
                                                    <div class="inspection-options">

                                                        <!-- 패키징 옵션 -->
                                                        <div v-if="item.요청내역.default" class="packaging-options mb-3">
                                                            <div class="reqpo-option-title mb-2">포장 방법 선택:</div>
                                                            <div class="custom-control custom-radio mb-2">
                                                                <input type="radio" :id="'packageAuto' + index"
                                                                    name="packageMethod" class="custom-control-input"
                                                                    value="auto" v-model="packageMethod"
                                                                    @change="changePackage(item)">
                                                                <label class="custom-control-label"
                                                                    :for="'packageAuto' + index">
                                                                    포장 방법 위임
                                                                </label>
                                                            </div>
                                                            <div class="custom-control custom-radio mb-2">
                                                                <input type="radio" :id="'packageNo' + index"
                                                                    name="packageMethod" class="custom-control-input"
                                                                    value="noPackage" v-model="packageMethod"
                                                                    @change="changePackage(item)">
                                                                <label class="custom-control-label"
                                                                    :for="'packageNo' + index">
                                                                    재포장 생략
                                                                </label>
                                                            </div>
                                                            <div class="custom-control custom-radio mb-2">
                                                                <input type="radio" :id="'packageOPP' + index"
                                                                    name="packageMethod" class="custom-control-input"
                                                                    value="opp" v-model="packageMethod"
                                                                    @change="changePackage(item)">
                                                                <label class="custom-control-label"
                                                                    :for="'packageOPP' + index">
                                                                    투명 OPP 봉투 포장 (무료)
                                                                </label>
                                                            </div>
                                                            <div class="custom-control custom-radio">
                                                                <input type="radio" :id="'packageLDPE' + index"
                                                                    name="packageMethod" class="custom-control-input"
                                                                    value="LDPE" v-model="packageMethod"
                                                                    @change="changePackage(item)">
                                                                <label class="custom-control-label"
                                                                    :for="'packageLDPE' + index">
                                                                    불투명 LDPE 봉투 포장 (무료)
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="reqpo-option-group mb-3">
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'defaultCheck' + index"
                                                                v-model="item.요청내역.default">
                                                            <label class="custom-control-label"
                                                                :for="'defaultCheck' + index">
                                                                기본검수/분류/포장/포장자재 (￦200)
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <!-- 라벨링 옵션 -->
                                                    <div class="labeling-options mb-3">
                                                        <div class="custom-control custom-switch mb-2">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'barcodeCheck' + index" v-model="item.요청내역.barcode"
                                                                @change="changeBarcode(item)">
                                                            <label class="custom-control-label"
                                                                :for="'barcodeCheck' + index">
                                                                바코드라벨 (Made in China,한글표시사항 기본포함) (￦100)
                                                            </label>
                                                        </div>

                                                        <div v-if="!item.요청내역.barcode"
                                                            class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'stickerCheck' + index"
                                                                v-model="item.요청내역.sticker">
                                                            <label class="custom-control-label"
                                                                :for="'stickerCheck' + index">
                                                                원산지스티커 (￦100)
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <!-- 추가 작업 옵션 -->
                                                    <div class="additional-options">
                                                        <div class="custom-control custom-switch mb-2">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'maskingCheck' + index"
                                                                v-model="item.요청내역.masking">
                                                            <label class="custom-control-label"
                                                                :for="'maskingCheck' + index">
                                                                중국어 마스킹 (무료)
                                                            </label>
                                                        </div>

                                                        <div class="custom-control custom-switch mb-2">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'airpackingCheck' + index"
                                                                v-model="item.요청내역.airpacking">
                                                            <label class="custom-control-label"
                                                                :for="'airpackingCheck' + index">
                                                                에어캡 포장 (실비)
                                                            </label>
                                                        </div>
                                                        <div class="custom-control custom-switch mb-2">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'sewingCheck' + index" v-model="item.요청내역.sewing">
                                                            <label class="custom-control-label"
                                                                :for="'sewingCheck' + index">
                                                                원산지라벨 봉제 (6000원/시간)
                                                            </label>
                                                            <div class="reqpo-warning-text">* 의류 수입 시 원산지 라벨봉제는 필수
                                                                사항입니다.</div>
                                                        </div>

                                                        <div class="custom-control custom-switch mb-2">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'stampCheck' + index" v-model="item.요청내역.stamp">
                                                            <label class="custom-control-label"
                                                                :for="'stampCheck' + index">
                                                                원산지 도장 (6000원/시간)
                                                            </label>
                                                            <div class="reqpo-warning-text">* 신발류 수입 시 제품에 원산지 라벨봉제 또는
                                                                원산지 도장은 필수 사항입니다.</div>
                                                        </div>

                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input"
                                                                :id="'tagCheck' + index" v-model="item.요청내역.tag">
                                                            <label class="custom-control-label"
                                                                :for="'tagCheck' + index">
                                                                원산지 택(태그) (6000원/시간)
                                                            </label>
                                                            <div class="reqpo-warning-text">* 가방류 수입 시 원산지 라벨봉제 또는 원산지 택
                                                                표기가 필수 사항입니다.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-6">

                                                <!-- 한글표시사항 섹션 -->
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">9. 한글표시사항</div>

                                                    <!-- 바코드라벨 미부착 시 경고 -->
                                                    <div v-if="!item.요청내역.barcode" class="reqpo-warning-box mb-3">
                                                        <div class="warning-content">
                                                            <div class="warning-title">※ 바코드라벨을 부착하지 않는 경우,</div>
                                                            <div class="reqpo-warning-text"
                                                                v-if="item.요청내역.destination === 'coupang'">
                                                                쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가 부착되거나 새겨져 있어야 합니다.
                                                            </div>
                                                            <div class="reqpo-warning-text"
                                                                v-if="item.요청내역.destination === 'customer'">
                                                                반드시 원산지표시가 되어 있어야 합니다.
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- 한글표시사항 입력 폼 -->
                                                    <div v-if="item.요청내역.barcode" class="korean-label-form">
                                                        <!-- 바코드 -->
                                                        <div class="form-group">
                                                            <label class="col-form-label">바코드번호</label>
                                                            <input type="text" class="form-control"
                                                                placeholder="예) S00012341234" v-model="item.바코드">
                                                        </div>

                                                        <!-- 제품명 (별도 상단 배치) -->
                                                        <div class="form-group">
                                                            <label>제품명</label>
                                                            <input type="text" class="form-control"
                                                                placeholder="예) 쿠플러스 예쁜접시, 10인치" v-model="item.상품명">
                                                            <small class="reqpo-warning-text">* 쿠팡에 등록한 상품명 + 옵션명을 같이
                                                                입력해주세요</small>
                                                        </div>

                                                        <!-- 기타 한글표시사항 -->
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">수입원/판매원</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 쿠플러스"
                                                                    v-model="item.한글표시사항['수입원/판매원']">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">제조원</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 중국OEM" v-model="item.한글표시사항.제조원">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">제조국</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 중국" v-model="item.한글표시사항.제조국">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">내용량</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 300ml" v-model="item.한글표시사항.내용량">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">원료명및성분명(재질)</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 도자기제"
                                                                    v-model="item.한글표시사항['원료명및성분명(재질)']">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">상품유형</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 주방용품" v-model="item.한글표시사항.상품유형">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">사용시주의사항</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 용도 이외에 사용금지"
                                                                    v-model="item.한글표시사항.사용시주의사항">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-3 col-form-label">사용기준</label>
                                                            <div class="col-sm-9">
                                                                <input type="text" class="form-control"
                                                                    placeholder="예) 14세 이상" v-model="item.한글표시사항.사용기준">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">

                                                <!-- 기존 판매자 협의 금액 섹션 -->
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">10. 기존 판매자 협의 금액 (선택)</div>
                                                    <div class="price-info-form">
                                                        <div class="form-group row">
                                                            <label class="col-sm-4 col-form-label">협의단가(CNY)</label>
                                                            <div class="col-sm-8">
                                                                <input type="number" :min="0" class="form-control"
                                                                    v-model="item.협의단가">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-4 col-form-label">
                                                                총금액(CNY)<br>
                                                                <small>(중국 내륙배송비 포함 전체 결제금액)</small>
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input type="number" :min="0" class="form-control"
                                                                    v-model="item.협의총금액">
                                                            </div>
                                                        </div>

                                                        <div class="form-group row">
                                                            <label class="col-sm-4 col-form-label">협의1688 ID</label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control"
                                                                    v-model="item.협의ID">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <!-- 기타요청사항 섹션 -->
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">
                                                        <div>기타요청사항 - 물류요청사항</div>
                                                        <small class="reqpo-text-muted ml-3">
                                                            (예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용, 실사,
                                                            사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                                            OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의 작업은
                                                            6000/시간의 작업비 발생)
                                                        </small>
                                                    </div>
                                                    <textarea class="form-control mt-3" rows="3"
                                                        v-model="item.요청내역.reqcontent">
                                                    </textarea>
                                                </div>
                                                <div class="reqpo-form-section">
                                                    <div class="reqpo-section-title">
                                                        <div>기타요청사항 - 구매요청사항</div>
                                                    </div>
                                                    <textarea class="form-control mt-3" rows="3"
                                                        v-model="item.요청내역.reqcontentPurchase">
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row" v-else-if="item.reqtype == '샘플검증'">
                                    <div class="col-md-6">
                                        <div class="form-section">
                                            <div class="section-title">1. 구매요청수량</div>
                                            <div class="input-wrapper">
                                                <div class="d-flex justify-content-start flex-column">
                                                    <input type="number" :min="0" class="form-control text-center"
                                                        style="width: 120px;" v-model="item.구매요청수량"
                                                        @keyup.enter="validateQuantity(item)">
                                                    <div class="stock-info ml-3">
                                                        <span class="info-label">최소주문:</span>
                                                        <span class="info-value">{{
                                                            getMinOrderQuantity(item)
                                                        }}개</span>
                                                        <span class="separator">/</span>
                                                        <span class="info-label">재고:</span>
                                                        <span class="info-value">{{
                                                            getAvailableStock(item)
                                                        }}개</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-section">
                                            <div class="section-title">2. 검증 후 처리</div>
                                            <div class="destination-options">
                                                <div class="btn-group w-100">
                                                    <button type="button" class="btn"
                                                        :class="{ 'btn-primary': item.요청내역.destination === 'distroy', 'btn-outline-primary': item.요청내역.destination !== 'distroy' }"
                                                        @click="item.요청내역.destination = 'distroy'">
                                                        폐기
                                                    </button>
                                                    <button type="button" class="btn"
                                                        :class="{ 'btn-primary': item.요청내역.destination === 'customer', 'btn-outline-primary': item.요청내역.destination !== 'customer' }"
                                                        @click="item.요청내역.destination = 'customer'">
                                                        화주
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-6" v-if="item.요청내역.destination == 'customer'">
                                        <div class="form-section">
                                            <div class="section-title">3. 통관정보</div>
                                            <div class="row">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label>신고영문명</label>
                                                        <input type="text" class="form-control" placeholder="예) shoes"
                                                            v-model="item.신고영문명">
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <label>HS-CODE</label>
                                                        <div class="d-flex">
                                                            <input type="text" class="form-control"
                                                                placeholder="예) 6401.10-1000" v-model="item.HSCODE">
                                                            <div class="w-25 d-flex align-items-center">
                                                                <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                    target="_blank"
                                                                    class="btn btn-outline-secondary ml-2">
                                                                    검색
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6" v-if="item.요청내역.destination == 'customer'">
                                        <div class="form-section">
                                            <div class="section-title">4. 통관형태</div>
                                            <div class="customs-options">
                                                <div class="custom-radio-card mb-2"
                                                    :class="{ 'active': item.요청내역.customsType === 'integrated' }"
                                                    @click="item.요청내역.customsType = 'integrated'">
                                                    <div class="card-title">쿠패스통합통관</div>
                                                    <div class="card-desc">위안화x280, 검수/포장비용
                                                        제외 모든비용 포함</div>
                                                </div>
                                                <div class="custom-radio-card mb-2"
                                                    :class="{ 'active': item.요청내역.customsType === 'client' }"
                                                    @click="item.요청내역.customsType = 'client'">
                                                    <div class="card-title">화주단독통관</div>
                                                    <div class="card-desc">구매대행수수료3%, 자재,
                                                        관부가세, 해운비, 통관비, 통관서류 비용 등 별도</div>
                                                </div>
                                                <div class="custom-radio-card"
                                                    :class="{ 'active': item.요청내역.customsType === 'kupass' }"
                                                    @click="item.요청내역.customsType = 'kupass'">
                                                    <div class="card-title">쿠패스단독통관</div>
                                                    <div class="card-desc">식검제품만 신청가능,
                                                        구매대행수수료3%, 자재, 관부가세, 해운비, 통관비, 통관서류
                                                        비용 등 별도</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- 기존 요청내역 섹션 내에 추가 -->
                                    <div class="col-md-12">
                                        <div class="form-section">
                                            <!-- 체크리스트 헤더 섹션 수정 -->
                                            <div
                                                class="section-title text-primary d-flex justify-content-between align-items-center">
                                                <span>샘플 검사 체크리스트</span>
                                            </div>
                                            <div class="inspection-checklist">
                                                <div v-for="(group, groupIndex) in item.요청내역.checklist?.groups || checklistGroups"
                                                    :key="groupIndex" class="checklist-group">
                                                    <div class="d-flex justify-content-between align-items-center"
                                                        v-if="group.items.find(e => e.checked)">
                                                        <h6 class="group-title">{{ group.title }}</h6>
                                                    </div>

                                                    <div class="checklist-items">
                                                        <div v-for="(list, itemIndex) in group.items" :key="itemIndex"
                                                            class="d-flex align-items-center mb-2">
                                                            <div class="custom-control custom-checkbox d-flex align-items-center w-75"
                                                                v-if="list.checked">
                                                                <input type="checkbox" class="custom-control-input"
                                                                    :id="'check-' + groupIndex + '-' + itemIndex"
                                                                    v-model="list.checked"
                                                                    @change="updateInspectionResults(group, list, item)">
                                                                <label class="custom-control-label w-100"
                                                                    :for="'check-' + groupIndex + '-' + itemIndex"
                                                                    style="margin-bottom: 0; padding-top: 0;">
                                                                    <input type="text"
                                                                        class="form-control d-inline-block ml-2"
                                                                        style="width: calc(100% - 20px); margin-top: -2px;"
                                                                        v-model="list.content"
                                                                        @input="updateInspectionResults(group, list, item)">
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-section">
                                                        <div class="section-title">
                                                            <div>기타 검사요청사항</div>
                                                        </div>
                                                        <textarea class="form-control mt-3" rows="5"
                                                            v-model="item.요청내역.reqcontent">
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-md-12">
                                        <h6 class="mt-2 mb-1">[ 출고유형 ]</h6>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                                v-model="item.요청내역.poarrange">
                                            <label class="custom-control-label" for="customSwitch1">발주센터/입고예정일에 따라 박스
                                                분류</label>
                                        </div>
                                        <span v-if="!item.요청내역.poarrange">※제품/발주 구분없이 적재되어 출고됩니다.</span>
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <div class="input-group" v-if="item.요청내역.poarrange">
                                                <input type="text" class="form-control" placeholder="발주서선택"
                                                    aria-label="" v-model="item.selectpo" style="text-align:center;">
                                                <div class="input-group-append">
                                                    <b-dropdown class="my-class" variant="primary" type="button"
                                                        text="">
                                                        <b-dropdown-item @click="polistchange(b, item)"
                                                            v-for="b, j in item.polists" :key="j">발주번호 : {{ b.발주번호 }}
                                                            ({{ b.발주센터 }}/{{ b.입고예정일 }}) - {{ b.sku수량
                                                            }}개</b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadio1" name="customRadio-3"
                                                class="custom-control-input" v-model="item.요청내역.exportType"
                                                value="pallet">
                                            <label class="custom-control-label" for="customRadio1">파렛트출고</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadio2" name="customRadio-3"
                                                class="custom-control-input" v-model="item.요청내역.exportType" value="box">
                                            <label class="custom-control-label" for="customRadio2">박스출고</label>
                                        </div>
                                        <span>※최대 박스 사이즈는 60cm(가로) x 40cm(세로) x 50cm(높이)이며, 상황에 따라 변경될 수 있습니다.</span>
                                    </div>

                                    <div class="col-md-12 mt-4 mb-1">
                                        <h6>[ 구매요청수량 ]</h6>
                                        <div class="custom-control-inline">
                                            <input type="number" :min="0" class="form-control" placeholder="구매요청수량"
                                                aria-label="" v-model="item.구매요청수량" style="text-align:center;">
                                        </div>
                                    </div>
                                    <div class="col-md-12"
                                        v-if="item.구매요청수량 > item.발주수량 && item.발주수량 > 0 && item.요청내역.poarrange">
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadio3" name="customRadio-13"
                                                class="custom-control-input" v-model="item.재고동봉" value=true>
                                            <label class="custom-control-label" for="customRadio3">나머지 수량 출고</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="customRadio4" name="customRadio-13"
                                                class="custom-control-input" v-model="item.재고동봉" value=false>
                                            <label class="custom-control-label" for="customRadio4">나머지 수량 재고보관</label>
                                        </div>
                                        <span>※나머지 수량 출고 시 별도의 박스로 함께 출고됩니다.</span>
                                    </div>
                                    <div class="col-md-12 mt-4 mb-1">
                                        <h6 v-b-tooltip.left="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">[ 판매구성수량 ]</h6>
                                        <div class="custom-control-inline">
                                            <input type="number" :min="0" class="form-control" placeholder="판매구성수량"
                                                aria-label="" v-model="item.판매구성수량" style="text-align:center;">
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-4 mb-1">
                                        <h6
                                            v-b-tooltip.left="'통관 시 필요한 정보를 기입해주세요 ex. 신고영문명 : shoes, 신고가격(USD) : 3.5, HS-CODE : 6401.10-0000'">
                                            [ 통관정보 ]</h6>
                                        <div class="custom-control-inline">
                                            <input type="text" class="form-control" placeholder="신고영문명" aria-label=""
                                                v-model="item.신고영문명" style="text-align:center;"
                                                v-b-tooltip.left="'제품의 신고영문명을 간단히 작성해주세요.'">
                                        </div>
                                        <div class="custom-control-inline">
                                            <input type="number" :min="0" class="form-control" placeholder="신고가격(USD)"
                                                aria-label="" v-model="item.신고가격" style="text-align:center;"
                                                v-b-tooltip.left="'제품의 신고가격(USD)를 작성해주세요. 원/위안화는 달러로 환산해서 작성해주세요.'">
                                        </div>
                                        <div class="custom-control-inline">
                                            <input type="text" class="form-control" placeholder="HS-CODE" aria-label=""
                                                v-model="item.HSCODE" style="text-align:center;"
                                                v-b-tooltip.left="'통관할 제품의 HS-CODE를 작성해주세요 ex : 6401.10-1000'">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 class="mt-4 mb-1">[ 원산지작업 ]</h6>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch2"
                                                v-model="item.요청내역.barcode" @change="labelling(item.요청내역)">
                                            <label class="custom-control-label" for="customSwitch2">바코드라벨(원산지,한글표시사항
                                                포함)</label>
                                        </div>
                                        <div class="custom-control custom-switch custom-control-inline"
                                            v-if="item.요청내역.barcode">
                                            <input type="text" class="form-control" placeholder="바코드입력" aria-label=""
                                                v-model="item.바코드" style="text-align:center;">
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch3"
                                                v-model="item.요청내역.sticker">
                                            <label class="custom-control-label" for="customSwitch3">원산지스티커</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch4"
                                                v-model="item.요청내역.stamp">
                                            <label class="custom-control-label" for="customSwitch4">원산지도장</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch5"
                                                v-model="item.요청내역.tag">
                                            <label class="custom-control-label" for="customSwitch5">원산지택총</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 class="mt-4 mb-1">[ 검수 및 포장작업 ]</h6>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch6"
                                                v-model="item.요청내역.default" @change="qadefault(item.요청내역)">
                                            <label class="custom-control-label" for="customSwitch6">기본검수</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch7"
                                                v-model="item.요청내역.opp">
                                            <label class="custom-control-label" for="customSwitch7">투명 OPP 봉투 (견적서
                                                참조)</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch8"
                                                v-model="item.요청내역.LDPE">
                                            <label class="custom-control-label" for="customSwitch8">불투명 LDPE 봉투 (견적서
                                                참조)</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch9"
                                                v-model="item.요청내역.airpacking">
                                            <label class="custom-control-label" for="customSwitch9">에어캡 포장 (견적서
                                                참조)</label>
                                        </div>
                                        <p>※큰 부피의 제품(최대박스 사이즈의 1/5이상 사이즈)인 경우 별도 협의</p>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 class="mt-4 mb-1">[ 기타요청사항 ] - 물류</h6>
                                    </div>
                                    <div class="col-md-12">
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                            v-model="item.요청내역.reqcontent"></textarea>
                                    </div>
                                    <div class="col-md-12">
                                        <h6 class="mt-4 mb-1">[ 기타요청사항 ] - 구매매</h6>
                                    </div>
                                    <div class="col-md-12">
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                            v-model="item.요청내역.reqcontentPurchase"></textarea>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <div class="custom-control custom-switch custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch222"
                                                v-model="item.구매취소" @change="cancelpo(item)">
                                            <label class="custom-control-label" for="customSwitch222">구매취소</label>
                                        </div>
                                        <div class="custom-control">
                                            <textarea v-if="item.구매취소" class="form-control"
                                                id="exampleFormControlTextarea122" v-model="item.구매취소내용"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </div>
                    </template>
                </CDataTable>
            </div>
            <div class="d-flex justify-content-end" v-if="showreqlist"></div>
        </div>

        <!-- 창고관리 모달 -->
        <b-modal id="warehouseModal" title="창고 레이아웃 관리" size="xl" hide-footer
                 modal-class="wl-modal-dark" header-class="wl-modal-header" body-class="p-0">
            <div class="wl-modern">
                <!-- 상단 툴바 -->
                <div class="wl-toolbar">
                    <div class="wl-toolbar-left">
                        <select class="wl-select" v-model="currentWarehouseId"
                                @change="selectWarehouse(currentWarehouseId)" v-if="warehouses.length > 0">
                            <option v-for="w in warehouses" :key="w.id" :value="w.id">{{ w.name }}</option>
                        </select>
                        <span v-else class="wl-muted">창고 없음</span>
                        <button class="wl-btn wl-btn-ghost" @click="showAddWarehouseForm" title="새 창고">
                            <i class="fas fa-plus"></i>
                        </button>
                        <button class="wl-btn wl-btn-ghost wl-btn-danger" v-if="currentWarehouseId"
                                @click="deleteWarehouse(currentWarehouseId)" title="창고 삭제">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                    <div class="wl-toolbar-right" v-if="currentWarehouseId">
                        <button class="wl-btn" :class="isLayoutEditMode ? 'wl-btn-active' : 'wl-btn-ghost'"
                                @click="toggleLayoutEditMode">
                            <i class="fas fa-edit"></i>
                            <span>{{ isLayoutEditMode ? '편집중' : '편집' }}</span>
                        </button>
                        <template v-if="isLayoutEditMode">
                            <div class="wl-divider"></div>
                            <button class="wl-btn wl-btn-ghost" @click="addLayoutArea" title="구역 추가">
                                <i class="fas fa-vector-square"></i><span>구역</span>
                            </button>
                            <button class="wl-btn wl-btn-ghost" @click="addStorageArea" title="보관위치 추가">
                                <i class="fas fa-cube"></i><span>보관위치</span>
                            </button>
                        </template>
                        <div class="wl-divider"></div>
                        <button class="wl-btn wl-btn-primary" @click="saveLayout">
                            <i class="fas fa-save"></i><span>저장</span>
                        </button>
                    </div>
                </div>

                <!-- 메인 컨텐츠 -->
                <div class="wl-main">
                    <!-- 좌측: 캔버스 -->
                    <div class="wl-canvas-wrap" ref="canvasWrap">
                        <div class="wl-canvas-inner">
                            <canvas id="warehouseCanvas"></canvas>
                            <!-- 층별 정보 툴팁 -->
                            <div v-if="showLevelTooltip && hoveredStorageArea" class="wl-tooltip"
                                 @mouseenter="onTooltipMouseEnter" @mouseleave="onTooltipMouseLeave"
                                 :style="{ left: levelTooltipPosition.x+'px', top: levelTooltipPosition.y+'px' }">
                                <div class="wl-tooltip-title">
                                    <i class="fas fa-cube mr-2"></i>{{ hoveredStorageArea.name }}
                                </div>
                                <div v-for="(lvl, idx) in hoveredStorageArea.levels" :key="idx"
                                     class="wl-tooltip-item" @click="selectStorageLevel(hoveredStorageArea, lvl, idx)">
                                    <i class="fas fa-layer-group mr-2" style="color:rgba(16,185,129,0.8)"></i>{{ lvl }}
                                    <span class="wl-badge">{{ getItemCountForLevel(hoveredStorageArea.id, idx) }}</span>
                                </div>
                                <div class="wl-tooltip-footer">
                                    <i class="fas fa-mouse-pointer mr-1"></i>클릭하여 아이템 조회
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 우측: 사이드바 -->
                    <div class="wl-sidebar">
                        <!-- 창고 추가 폼 -->
                        <div v-if="showWarehouseForm" class="wl-card">
                            <div class="wl-card-title">새 창고 추가</div>
                            <div class="wl-field">
                                <label>창고명 *</label>
                                <input type="text" class="wl-input" v-model="warehouseForm.name" placeholder="창고명">
                            </div>
                            <div class="wl-field">
                                <label>주소</label>
                                <input type="text" class="wl-input" v-model="warehouseForm.address" placeholder="주소">
                            </div>
                            <div class="wl-field">
                                <label>설명</label>
                                <input type="text" class="wl-input" v-model="warehouseForm.description" placeholder="설명">
                            </div>
                            <div class="wl-card-actions">
                                <button class="wl-btn wl-btn-primary" @click="saveWarehouse">
                                    <i class="fas fa-check mr-1"></i>저장
                                </button>
                                <button class="wl-btn wl-btn-ghost" @click="cancelWarehouseForm">취소</button>
                            </div>
                        </div>

                        <!-- 창고 정보 카드 -->
                        <div class="wl-card" v-if="currentWarehouseId && !showWarehouseForm">
                            <div class="wl-card-title"><i class="fas fa-warehouse mr-2"></i>{{ getCurrentWarehouseName() }}</div>
                            <div class="wl-stat-row">
                                <div class="wl-stat">
                                    <span class="wl-stat-num">{{ layoutAreas.length }}</span>
                                    <span class="wl-stat-label">구역</span>
                                </div>
                                <div class="wl-stat">
                                    <span class="wl-stat-num">{{ storageAreas.length }}</span>
                                    <span class="wl-stat-label">보관위치</span>
                                </div>
                            </div>
                        </div>

                        <!-- 레이아웃 구역 편집 -->
                        <div v-if="selectedLayoutArea && isLayoutEditMode" class="wl-card wl-card-indigo">
                            <div class="wl-card-title"><i class="fas fa-vector-square mr-2"></i>구역 편집</div>
                            <div class="wl-field">
                                <label>구역명</label>
                                <input type="text" class="wl-input" v-model="selectedLayoutArea.name" placeholder="구역명">
                            </div>
                            <div class="wl-card-actions">
                                <button class="wl-btn wl-btn-primary" @click="updateLayoutArea">적용</button>
                                <button class="wl-btn wl-btn-danger" @click="deleteLayoutArea">
                                    <i class="fas fa-trash mr-1"></i>삭제
                                </button>
                            </div>
                        </div>

                        <!-- 보관위치 편집 -->
                        <div v-if="selectedStorageArea && isLayoutEditMode" class="wl-card wl-card-emerald">
                            <div class="wl-card-title"><i class="fas fa-cube mr-2"></i>보관위치 편집</div>
                            <div class="wl-field">
                                <label>보관위치명</label>
                                <input type="text" class="wl-input" v-model="selectedStorageArea.name" placeholder="보관위치명">
                            </div>
                            <div class="wl-field">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <label class="mb-0">보관층수</label>
                                    <div>
                                        <button class="wl-btn wl-btn-ghost wl-btn-xs" @click="addLevel"><i class="fas fa-plus"></i></button>
                                        <button class="wl-btn wl-btn-ghost wl-btn-xs" @click="removeLevel"
                                                :disabled="selectedStorageArea.levels.length <= 1"><i class="fas fa-minus"></i></button>
                                    </div>
                                </div>
                                <div class="wl-levels">
                                    <div v-for="(level, index) in selectedStorageArea.levels" :key="index" class="wl-level-row">
                                        <span class="wl-level-num">{{ index + 1 }}층</span>
                                        <input type="text" class="wl-input wl-input-sm"
                                               v-model="selectedStorageArea.levels[index]"
                                               :placeholder="`${index + 1}층 이름`" @blur="updateStorageAreaDisplay">
                                    </div>
                                </div>
                            </div>
                            <div class="wl-card-actions">
                                <button class="wl-btn wl-btn-primary" @click="updateStorageArea">적용</button>
                                <button class="wl-btn wl-btn-danger" @click="deleteStorageArea">
                                    <i class="fas fa-trash mr-1"></i>삭제
                                </button>
                            </div>
                        </div>

                        <!-- 안내 (편집모드 아닐 때) -->
                        <div v-if="!selectedLayoutArea && !selectedStorageArea && !showWarehouseForm && currentWarehouseId" class="wl-card wl-card-hint">
                            <i class="fas fa-info-circle mr-2"></i>
                            <span v-if="!isLayoutEditMode">보관위치 위에 마우스를 올려 층별 정보를 확인하세요</span>
                            <span v-else>캔버스에서 객체를 클릭하여 편집하세요</span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- 선택된 층 정보 표시 (창고관리에서 층 클릭 시) -->
        <div v-if="selectedStorageInfo" class="selected-storage-info mt-4 p-3 border rounded"
             style="background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%); border-left: 4px solid #2196f3;">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h5 class="mb-1">
                        <i class="fas fa-filter mr-2 text-primary"></i>
                        창고관리 위치 필터
                    </h5>
                    <p class="mb-0 text-muted">
                        <i class="fas fa-warehouse mr-1"></i>{{ selectedStorageInfo.warehouseName }}
                        <i class="fas fa-chevron-right mx-2"></i>
                        <i class="fas fa-map-marker-alt mr-1"></i>{{ selectedStorageInfo.storageName }}
                        <i class="fas fa-chevron-right mx-2"></i>
                        <i class="fas fa-layer-group mr-1"></i>{{ selectedStorageInfo.levelName }}
                    </p>
                </div>
                <div>
                    <span class="badge badge-primary mr-2" style="font-size: 0.9rem;">{{ selectedStorageInfo.itemCount }}개 아이템</span>
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearStorageSelection">
                        <i class="fas fa-times mr-1"></i>전체 보기
                    </button>
                </div>
            </div>
        </div>

        <!-- 위치별 필터 정보 표시 (테이블 배지 클릭 시) -->
        <div v-if="selectedLocationFilter" class="selected-location-filter mt-4 p-3 border rounded"
             style="background: linear-gradient(135deg, #fff3e0 0%, #fce4ec 100%); border-left: 4px solid #ff9800;">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h5 class="mb-1">
                        <i class="fas fa-search mr-2 text-warning"></i>
                        {{ selectedLocationFilter.type }} 필터
                    </h5>
                    <p class="mb-0 text-muted">
                        <i class="fas fa-tag mr-1"></i>{{ selectedLocationFilter.value }}
                    </p>
                </div>
                <div>
                    <span class="badge badge-warning mr-2" style="font-size: 0.9rem;">{{ selectedLocationFilter.itemCount }}개 아이템</span>
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearLocationFilter">
                        <i class="fas fa-times mr-1"></i>전체 보기
                    </button>
                </div>
            </div>
        </div>

        <!-- 입고승인 모달 -->
        <b-modal v-model="showInboundModal" title="📥 입고 승인" ok-title="입고 승인" cancel-title="취소"
                 @ok="confirmInbound" centered size="md">
            <div v-if="inboundEditItem">
                <div class="d-flex align-items-center mb-3">
                    <img :src="inboundEditItem.등록이미지" class="rounded mr-3" style="width:60px;height:60px;object-fit:cover;" alt="">
                    <div>
                        <strong>{{ inboundEditItem.상품명 }}</strong>
                        <p class="mb-0 text-muted small">{{ inboundEditItem.SKUID }}</p>
                        <p class="mb-0 text-muted small">바코드: {{ inboundEditItem.바코드 }}</p>
                    </div>
                </div>
                <b-form-group label="상품명 (수정 가능)" label-for="inbound-name">
                    <b-form-input id="inbound-name" v-model="inboundEditName" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="입고 수량 (수정 가능)" label-for="inbound-qty">
                    <b-form-input id="inbound-qty" v-model.number="inboundEditQty" type="number" min="1" size="sm"></b-form-input>
                </b-form-group>
                <small class="text-muted">실물 확인 후 수량이나 상품명이 다르면 수정해주세요.</small>
            </div>
        </b-modal>

        <!-- 📥 수동입고 모달 -->
        <b-modal v-model="showManualInboundModal" title="📥 수동 입고" ok-title="입고 등록" cancel-title="취소"
                 @ok="submitManualInbound" @hidden="resetManualInbound" centered size="md">
            <b-form-group label="바코드" label-for="mi-barcode">
                <b-input-group size="sm">
                    <b-form-input id="mi-barcode" v-model="manualInbound.barcode" placeholder="바코드 스캔 또는 입력"
                                  @keyup.enter="searchBarcode"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="searchBarcode">
                            <i class="fas fa-search"></i> 검색
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <div v-if="manualInboundMatched" class="alert alert-success py-2 small">
                <i class="fas fa-check-circle mr-1"></i>매칭됨: <strong>{{ manualInboundMatched.상품명 }}</strong>
                <span v-if="manualInboundMatched.SKUID" class="ml-2 text-muted">SKU: {{ manualInboundMatched.SKUID }}</span>
            </div>
            <b-form-group label="상품명" label-for="mi-name">
                <b-form-input id="mi-name" v-model="manualInbound.상품명" size="sm" placeholder="상품명 입력"></b-form-input>
            </b-form-group>
            <div class="row">
                <div class="col-6">
                    <b-form-group label="수량" label-for="mi-qty">
                        <b-form-input id="mi-qty" v-model.number="manualInbound.수량" type="number" min="1" size="sm"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-6">
                    <b-form-group label="사유" label-for="mi-reason">
                        <b-form-select id="mi-reason" v-model="manualInbound.사유" size="sm"
                                       :options="['직접입고', '반품입고', '교환입고', '기타']"></b-form-select>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="메모 (선택)" label-for="mi-memo">
                <b-form-input id="mi-memo" v-model="manualInbound.메모" size="sm" placeholder="메모"></b-form-input>
            </b-form-group>
            <template #modal-ok>
                <b-spinner small v-if="manualInboundProcessing" class="mr-1"></b-spinner>
                {{ manualInboundProcessing ? '처리중...' : '입고 등록' }}
            </template>
        </b-modal>

        <!-- 📤 출고 모달 -->
        <b-modal v-model="showOutboundModal" title="📤 출고 처리" ok-title="출고 확인" cancel-title="취소"
                 @ok="submitOutbound" centered size="lg">
            <p class="small text-muted mb-2">선택된 {{ outboundItems.length }}건의 재고를 출고합니다. 수량과 사유를 확인해주세요.</p>
            <div v-for="ob in outboundItems" :key="ob._id" class="border rounded p-2 mb-2">
                <div class="d-flex align-items-center mb-1">
                    <img :src="ob.등록이미지" class="rounded mr-2" style="width:36px;height:36px;object-fit:cover;" alt="">
                    <div class="flex-grow-1">
                        <strong class="small">{{ ob.상품명 }}</strong>
                        <small class="text-muted d-block">현재 재고: {{ ob.수량 }}개</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <label class="small mb-0">출고 수량</label>
                        <b-form-input v-model.number="ob.outQty" type="number" min="1" :max="ob.수량" size="sm"></b-form-input>
                    </div>
                    <div class="col-4">
                        <label class="small mb-0">사유</label>
                        <b-form-select v-model="ob.사유" size="sm"
                                       :options="['직접출고', '판매출고', '반품출고', '폐기', '기타']"></b-form-select>
                    </div>
                    <div class="col-4">
                        <label class="small mb-0">메모</label>
                        <b-form-input v-model="ob.메모" size="sm" placeholder="메모"></b-form-input>
                    </div>
                </div>
            </div>
            <template #modal-ok>
                <b-spinner small v-if="outboundProcessing" class="mr-1"></b-spinner>
                {{ outboundProcessing ? '처리중...' : '출고 확인' }}
            </template>
        </b-modal>

        <!-- 🔍 재고수정 모달 -->
        <b-modal v-model="showAuditModal" title="🔍 재고 수정" ok-title="수정 반영" cancel-title="취소"
                 @ok="submitAudit" centered size="lg" scrollable>
            <p class="small text-muted mb-2">수정할 항목의 수량을 입력해주세요. 변경된 항목만 반영됩니다.</p>
            <b-table-simple small hover responsive>
                <b-thead>
                    <b-tr>
                        <b-th style="width:50px">이미지</b-th>
                        <b-th>상품명</b-th>
                        <b-th style="width:80px" class="text-center">시스템</b-th>
                        <b-th style="width:100px" class="text-center">수정수량</b-th>
                        <b-th style="width:80px" class="text-center">차이</b-th>
                        <b-th style="width:150px">메모</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="a in auditItems" :key="a._id">
                        <b-td><img :src="a.등록이미지" class="rounded" style="width:36px;height:36px;object-fit:cover;" alt=""></b-td>
                        <b-td>
                            <div class="small">{{ a.상품명 }}</div>
                            <small class="text-muted">{{ a.barcode }}</small>
                        </b-td>
                        <b-td class="text-center">{{ a.수량 }}</b-td>
                        <b-td class="text-center">
                            <b-form-input v-model.number="a.실사수량" type="number" min="0" size="sm" style="width:80px;"></b-form-input>
                        </b-td>
                        <b-td class="text-center">
                            <span v-if="a.실사수량 !== null && a.실사수량 !== a.수량"
                                  :class="a.실사수량 > a.수량 ? 'text-success' : 'text-danger'">
                                {{ a.실사수량 > a.수량 ? '+' : '' }}{{ a.실사수량 - a.수량 }}
                            </span>
                            <span v-else class="text-muted">-</span>
                        </b-td>
                        <b-td><b-form-input v-model="a.메모" size="sm" placeholder="메모"></b-form-input></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <template #modal-ok>
                <b-spinner small v-if="auditProcessing" class="mr-1"></b-spinner>
                {{ auditProcessing ? '처리중...' : '수정 반영' }}
            </template>
        </b-modal>


        <!-- ── 쿠팡센터로 출고 (정본 §5 Phase 4-10) ────────────────────────── -->
        <b-modal v-model="showDomesticShipModal" size="lg" title="국내창고 출고" hide-footer>
            <b-form-group label="어디로 나가나요?" class="mb-2">
                <b-form-radio-group v-model="domesticShip.행선지" :options="출고행선지" buttons
                    button-variant="outline-primary" size="sm"></b-form-radio-group>
            </b-form-group>
            <p class="small text-muted" v-if="domesticShip.행선지 === '쿠팡센터'">
                화주창고에서 쿠팡센터로 보내는 <b>새 선적</b>을 만듭니다. 진행현황은 <b>국내입고중</b>이 됩니다.
                보관비가 이 시점에 확정되므로 국내창고비를 같이 입력합니다.
            </p>
            <p class="small text-muted" v-else>
                재고에서 빼고 <b>{{ domesticShip.행선지 }}</b>로 기록합니다.
                쿠팡으로 가는 게 아니므로 진행현황은 그대로 두고 입고를 기다리지 않습니다.
            </p>
            <p class="small text-muted mb-2">
                재고 칸이 <b>–</b> 인 상품은 아직 재고 기록이 없어 수량을 확인할 수 없습니다.
                그런 상품은 입력한 수량 그대로 출고되니 직접 확인해 주세요.
                <b>국내창고 입고</b>에서 <b>기초재고</b>로 현재 수량을 한 번 넣어두시면 그 뒤로는 자동으로 확인됩니다.
            </p>
            <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th>상품명</th>
                            <th style="width:110px">이 발주 몫</th>
                            <th style="width:110px">출고수량</th>
                            <th v-if="쿠팡센터출고" style="width:150px">입고ID</th>
                            <th v-if="쿠팡센터출고" style="width:150px">입고예정일</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(it, i) in domesticShip.items" :key="'ds-' + i">
                            <td class="text-truncate" style="max-width:260px">{{ it.상품명 }}</td>
                            <td class="text-center">
                                <span v-if="it.재고 === null || it.재고 === undefined" class="text-muted small">–</span>
                                <b v-else :class="it.수량 > it.재고 ? 'text-danger' : ''">{{ it.재고.toLocaleString() }}</b>
                            </td>
                            <td>
                                <input type="number" min="0" class="form-control form-control-sm text-center"
                                    :class="{ 'is-invalid': it.재고 !== null && it.재고 !== undefined && it.수량 > it.재고 }"
                                    v-model.number="it.수량">
                            </td>
                            <td v-if="쿠팡센터출고"><input type="text" class="form-control form-control-sm" v-model="it.입고ID" placeholder="있으면 입력"></td>
                            <td v-if="쿠팡센터출고"><input type="date" class="form-control form-control-sm" v-model="it.입고예정일"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="구매정보없음재고.length" class="alert alert-light border small py-2 mb-3">
                <b>구매정보가 없는 재고</b>도 창고에 있습니다 — 국내에서 직접 사들였거나 기초재고로 넣은 몫입니다.
                어느 발주 것인지 기록이 없어 여기 목록에는 안 나옵니다.
                <div class="mt-1">
                    <span v-for="(u, i) in 구매정보없음재고" :key="'u' + i" class="mr-2">
                        {{ u.상품명 || u.바코드 }} <b>{{ u.잔량.toLocaleString() }}개</b>
                    </span>
                </div>
            </div>

            <!-- 국내창고비는 쿠팡으로 보낼 때만 받는다 — 폐기·기부는 얹을 매입가 자리가 없다 -->
            <template v-if="쿠팡센터출고">
            <h6 class="mb-2">국내창고비 <small class="text-muted">(화주 본인 비용 기록입니다. 쿠패스 청구가 아닙니다)</small></h6>
            <div class="table-responsive mb-2">
                <table class="table table-sm table-bordered">
                    <tbody>
                        <tr v-for="(c, i) in domesticShip.비용" :key="'dc-' + i">
                            <td><input type="text" class="form-control form-control-sm" v-model="c.name" placeholder="항목명"></td>
                            <td style="width:160px"><input type="number" min="0" class="form-control form-control-sm text-right" v-model.number="c.amount"></td>
                            <td style="width:44px" class="text-center">
                                <a href="javascript:void(0)" class="text-danger" @click="removeDomesticCostRow(i)"><i class="ri-delete-bin-line"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <b-button size="sm" variant="outline-secondary" @click="addDomesticCostRow">+ 항목 추가</b-button>
                <div><b>합계 {{ domesticCostTotal.toLocaleString() }}원</b></div>
            </div>
            </template>
            <div class="text-right mt-3">
                <b-button variant="secondary" class="mr-2" @click="showDomesticShipModal = false">취소</b-button>
                <b-button variant="primary" :disabled="domesticShip.busy" @click="confirmDomesticShipment">
                    {{ domesticShip.busy ? '처리 중...' : (쿠팡센터출고 ? '쿠팡센터로 출고' : domesticShip.행선지 + '로 기록') }}
                </b-button>
            </div>
        </b-modal>

        <!-- ── 국내창고 입고 (정본 §5 Phase 4-18) ─────────────────────────── -->
        <b-modal v-model="showDomesticReceiptModal" title="국내창고 입고" hide-footer>
            <p class="small text-muted">
                통관 반출·회송·반품·국내사입·기초재고를 한 화면에서 받습니다.
                사유는 이력에 남는 라벨이고, 원가 처리는 <b>앞 lot 이 있느냐</b>로만 갈립니다.
            </p>
            <b-form-group label="바코드">
                <b-form-input v-model="domesticReceipt.바코드" placeholder="바코드"></b-form-input>
            </b-form-group>
            <b-form-group label="상품명 (선택)">
                <b-form-input v-model="domesticReceipt.상품명"></b-form-input>
            </b-form-group>
            <b-form-group label="수량">
                <b-form-input type="number" min="1" v-model.number="domesticReceipt.수량"></b-form-input>
            </b-form-group>
            <b-form-group label="구분">
                <b-form-select v-model="domesticReceipt.사유" :options="국내입고사유"></b-form-select>
                <small class="text-muted d-block mt-1">
                    중국에서 보내 통관까지 마친 물건은 여기 말고 <b>입고대기 목록</b>에서
                    입고승인을 눌러주세요. 어느 발주 것인지가 자동으로 연결됩니다.
                </small>
            </b-form-group>
            <b-form-group :label="needsPurchasePrice ? '매입가 (필수)' : '매입가 (앞 lot 원가를 이어받으므로 비워두세요)'">
                <b-form-input type="number" min="0" v-model.number="domesticReceipt.매입가"
                    :disabled="!needsPurchasePrice"></b-form-input>
                <small v-if="needsPurchasePrice" class="text-danger">
                    앞 lot 이 없는 구분이라 매입가를 입력해야 원가가 잡힙니다.
                </small>
            </b-form-group>
            <b-form-group label="추가비용 (회송비 등, 없으면 비움)">
                <b-form-input type="number" min="0" v-model.number="domesticReceipt.추가비용"></b-form-input>
            </b-form-group>
            <b-form-group label="메모">
                <b-form-input v-model="domesticReceipt.메모"></b-form-input>
            </b-form-group>
            <div class="text-right">
                <b-button variant="secondary" class="mr-2" @click="showDomesticReceiptModal = false">취소</b-button>
                <b-button variant="success" :disabled="domesticReceipt.busy" @click="confirmDomesticReceipt">
                    {{ domesticReceipt.busy ? '처리 중...' : '입고' }}
                </b-button>
            </div>
        </b-modal>
    </div>

</template>

<style scoped>
.warehouse-layout-editor {
    position: relative;
    width: 100%;
}

.canvas-container-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 0;
}

.canvas-container {
    position: relative;
    display: inline-block;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.area-dropdown {
    min-width: 120px;
    max-width: 200px;
}

.dropdown-item:hover {
    background-color: #f8f9fa !important;
}

/* 층별 툴팁 스타일 */
.level-tooltip {
    font-size: 13px;
    max-width: 220px;
    pointer-events: auto;
    backdrop-filter: blur(10px);
    animation: tooltipFadeIn 0.2s ease-out;
}

@keyframes tooltipFadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.level-item {
    transition: all 0.2s ease;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
}

.level-item:hover {
    background: rgba(255,255,255,0.25) !important;
    transform: translateX(2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.level-item:active {
    transform: translateX(1px);
    background: rgba(255,255,255,0.3) !important;
}

/* 선택된 층 정보 스타일 */
.selected-storage-info {
    border-left: 4px solid #007bff;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.selected-storage-info .table {
    margin-bottom: 0;
}

.selected-storage-info .table th {
    border-top: none;
    font-weight: 600;
    color: #495057;
}

.selected-storage-info .table td {
    vertical-align: middle;
}

.toolbar {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 10px;
}

.area-settings {
    background-color: #f8f9fa;
}

.badge {
    font-size: 0.8em;
}

.badge .fa-times {
    cursor: pointer;
}

.badge .fa-times:hover {
    color: #dc3545;
}

/* ===== 창고 레이아웃 모달 (라이트 모던 UI) ===== */
.wl-modal-dark .modal-dialog { max-width: 95vw; margin: 1rem auto; }
.wl-modal-dark .modal-content { background: #f8fafc; border: 1px solid #e2e8f0; color: #1e293b; }
.wl-modal-header { background: #fff !important; border-bottom: 1px solid #e2e8f0 !important; }
.wl-modal-header .modal-title { color: #1e293b; font-size: 15px; font-weight: 700; }
.wl-modal-header .close { color: #64748b; text-shadow: none; opacity: 0.7; }

.wl-modern { display: flex; flex-direction: column; height: calc(85vh - 60px); min-height: 500px; }

/* 툴바 */
.wl-toolbar { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; background: #fff; border-bottom: 1px solid #e2e8f0; flex-shrink: 0; }
.wl-toolbar-left, .wl-toolbar-right { display: flex; align-items: center; gap: 6px; }
.wl-select { background: #fff; border: 1px solid #cbd5e1; color: #1e293b; border-radius: 6px; padding: 6px 12px; font-size: 13px; outline: none; min-width: 160px; }
.wl-select:focus { border-color: #6366f1; box-shadow: 0 0 0 2px rgba(99,102,241,0.15); }
.wl-divider { width: 1px; height: 20px; background: #e2e8f0; margin: 0 4px; }
.wl-muted { color: #94a3b8; font-size: 13px; }

/* 버튼 */
.wl-btn { display: inline-flex; align-items: center; gap: 5px; padding: 6px 12px; border: none; border-radius: 6px; font-size: 12px; font-weight: 500; cursor: pointer; transition: all 0.15s; white-space: nowrap; color: #475569; background: transparent; }
.wl-btn span { display: inline; }
.wl-btn:hover { background: #f1f5f9; }
.wl-btn-ghost { background: transparent; }
.wl-btn-ghost:hover { background: #f1f5f9; }
.wl-btn-primary { background: #6366f1; color: #fff; }
.wl-btn-primary:hover { background: #4f46e5; }
.wl-btn-active { background: #eef2ff; color: #4338ca; box-shadow: inset 0 0 0 1px #a5b4fc; }
.wl-btn-danger { color: #ef4444; }
.wl-btn-danger:hover { background: #fef2f2; }
.wl-btn-xs { padding: 3px 7px; font-size: 11px; }

/* 메인 컨텐츠 */
.wl-main { display: flex; gap: 12px; padding: 12px; flex: 1; overflow: hidden; }
.wl-canvas-wrap { flex: 1; background: #1e1e2e; border-radius: 10px; border: 1px solid #e2e8f0; overflow: hidden; position: relative; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
.wl-canvas-inner { width: 100%; height: 100%; position: relative; }
.wl-canvas-inner .canvas-container { width: 100% !important; height: 100% !important; }
#warehouseCanvas { display: block; cursor: default; }

/* 사이드바 */
.wl-sidebar { width: 280px; flex-shrink: 0; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }

/* 카드 */
.wl-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px; box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
.wl-card-title { font-size: 13px; font-weight: 700; color: #1e293b; margin-bottom: 12px; }
.wl-card-indigo { border-color: #c7d2fe; background: #eef2ff; }
.wl-card-indigo .wl-card-title { color: #4338ca; }
.wl-card-emerald { border-color: #a7f3d0; background: #ecfdf5; }
.wl-card-emerald .wl-card-title { color: #065f46; }
.wl-card-hint { display: flex; align-items: center; font-size: 12px; color: #94a3b8; border-style: dashed; background: #f8fafc; }
.wl-card-actions { display: flex; gap: 6px; margin-top: 10px; }

/* 통계 */
.wl-stat-row { display: flex; gap: 10px; }
.wl-stat { flex: 1; background: #f8fafc; border-radius: 8px; padding: 10px; text-align: center; border: 1px solid #f1f5f9; }
.wl-stat-num { display: block; font-size: 20px; font-weight: 700; color: #1e293b; }
.wl-stat-label { font-size: 11px; color: #94a3b8; }

/* 폼 필드 */
.wl-field { margin-bottom: 10px; }
.wl-field label { display: block; font-size: 11px; color: #64748b; margin-bottom: 4px; font-weight: 600; }
.wl-input { width: 100%; background: #fff; border: 1px solid #cbd5e1; color: #1e293b; border-radius: 6px; padding: 6px 10px; font-size: 13px; outline: none; }
.wl-input:focus { border-color: #6366f1; box-shadow: 0 0 0 2px rgba(99,102,241,0.15); }
.wl-input-sm { padding: 4px 8px; font-size: 12px; }

/* 층 관리 */
.wl-levels { display: flex; flex-direction: column-reverse; gap: 4px; max-height: 160px; overflow-y: auto; }
.wl-level-row { display: flex; align-items: center; gap: 6px; }
.wl-level-num { font-size: 12px; color: #64748b; min-width: 30px; font-weight: 600; }

/* 툴팁 (캔버스 위 오버레이이므로 다크 유지) */
.wl-tooltip { position: absolute; z-index: 1000; background: rgba(15,23,42,0.95); color: #f1f5f9; padding: 12px; border-radius: 10px; min-width: 160px; box-shadow: 0 8px 24px rgba(0,0,0,0.3); border: 1px solid rgba(255,255,255,0.1); backdrop-filter: blur(8px); }
.wl-tooltip-title { font-size: 13px; font-weight: 700; margin-bottom: 8px; color: #f1f5f9; }
.wl-tooltip-item { cursor: pointer; padding: 7px 8px; margin: 2px 0; background: rgba(255,255,255,0.08); border-radius: 6px; font-size: 12px; transition: all 0.15s; display: flex; align-items: center; color: #e2e8f0; }
.wl-tooltip-item:hover { background: rgba(255,255,255,0.15); transform: translateX(2px); }
.wl-badge { margin-left: auto; background: rgba(255,255,255,0.15); padding: 1px 6px; border-radius: 4px; font-size: 11px; }
.wl-tooltip-footer { margin-top: 8px; padding-top: 6px; border-top: 1px solid rgba(255,255,255,0.1); font-size: 11px; color: #94a3b8; }
</style>

<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import { validationMixin } from 'vuelidate'
import { required, integer } from 'vuelidate/lib/validators'
import CDataTable from "@/components/common/CDataTable";
import { fabric } from 'fabric';
// import { arrayMax } from 'highcharts';
// import { VueEditor } from 'vue2-editor'
export default {
    name: 'LogisReqPurchase',
    mixins: [validationMixin],
    validations: {
        purchaseno: { required },
        payment: { required, integer },
    },
    components: {
        //    VueEditor,
        CDataTable
    },
    data() {
        return {
            // 해외재고 탭 전용 헤더
            overseasHeaders: [
                { text: '제품정보', value: '상품명', align: 'left', width: 400, isSlot: true },
                { text: '상태', value: 'processStatus', align: 'center', width: 100, isSlot: false },
                { text: '수량', value: '구매요청수량', align: 'center', width: 80, isSlot: false },
                { text: '구매링크', value: '구매링크', align: 'center', width: 80, isSlot: true },
                { text: '옵션1', value: '옵션1_중국어', align: 'center', width: 120, isSlot: false },
                { text: '옵션2', value: '옵션2_중국어', align: 'center', width: 120, isSlot: false },
                { text: '요청일', value: '요청일', align: 'center', width: 100, isSlot: true },
                { text: 'History', value: 'history', align: 'center', width: 80, isSlot: true },
            ],
            // 국내재고 탭 전용 헤더 (Inventory 컬렉션 기반)
            domesticHeaders: [
                { text: '상품명', value: '상품명', align: 'left', width: 350, isSlot: true },
                { text: '바코드', value: 'barcode', align: 'center', width: 120, isSlot: false },
                { text: '창고', value: '창고', align: 'center', width: 80, isSlot: true },
                { text: '구역', value: '구역', align: 'center', width: 80, isSlot: true },
                { text: '층', value: '층', align: 'center', width: 60, isSlot: true },
                { text: '수량', value: '수량', align: 'center', width: 80, isSlot: false },
                { text: '최종입고일', value: '최종입고일', align: 'center', width: 120, isSlot: true },
            ],
            // 입출고이력 탭 헤더 (Inventory 입출고이력 기반)
            historyHeaders: [
                { text: '제품정보', value: '상품명', align: 'left', width: 350, isSlot: true },
                { text: '날짜', value: 'changeDate', align: 'center', width: 100, isSlot: true },
                { text: '구분', value: '구분', align: 'center', width: 80, isSlot: true },
                { text: '수량', value: 'changeQty', align: 'center', width: 80, isSlot: false },
                { text: '사유', value: '사유', align: 'center', width: 120, isSlot: false },
                { text: '메모', value: '메모', align: 'left', width: 200, isSlot: false },
                { text: '처리자', value: '처리자', align: 'center', width: 100, isSlot: false },
            ],
            // 입출고이력 데이터
            historyList: [],
            historyStartDate: '',
            historyEndDate: '',
            historyLoading: false,
            historySearchKeyword: '',
            historySummary: null,
            tableSelectedItem: [],
            changeindexlist: [],
            changeoption: false,
            change: false,
            일괄변경: '구매취소',
            wholechanges: [{ value: '구매전', text: '구매전' }, { value: '구매취소', text: '구매취소' }, { value: '구매확인', text: '구매확인' }],
            일괄구매취소내용: '',

            // 일괄처리 관련 변수들
            showBatchChange: false,
            batchStatus: '',
            batchProcessing: false,
            statusOptions: [
                { value: '', text: '상태를 선택하세요', disabled: true },
                { value: '중국재고', text: '중국재고' },
                { value: '출고대기', text: '출고대기' },
                { value: '국내창고입고완료', text: '국내창고입고완료' }
            ],

            // 위치 설정 관련 변수들
            showLocationChange: false,
            batchLocationWarehouse: '',
            batchLocationArea: '',
            batchLocationLevel: '',
            batchLocationProcessing: false,


            selectdate: 'today',
            startdate: this.getTodaywith(),
            enddate: this.getTodaywith(),
            selectoption: '요청일',
            SKUID: '',
            상품명: '',
            바코드: '',

            // 탭 관리
            activeTab: 'overseas', // 'overseas' (해외재고) 또는 'domestic' (국내재고)
            // 국내창고 출고 / 입고 (정본 §5 Phase 4)
            showDomesticShipModal: false,
            // 행선지를 여기 안 두면 모달을 열기 전엔 undefined 라 라디오가 비어 보인다.
            // (열 때 객체를 통째로 갈아끼우므로 반응성 자체는 문제없지만, 초기 렌더가 지저분하다)
            domesticShip: { items: [], 비용: [], busy: false, 제출토큰: '', 행선지: '쿠팡센터' },
            showDomesticReceiptModal: false,
            domesticReceipt: { 바코드: '', 상품명: '', 수량: 0, 사유: '회송입고', 매입가: 0, 추가비용: 0, 메모: '', 제출토큰: '', busy: false },
            // 사유는 이력에 남는 라벨이지 분기가 아니다. 늘어도 여기만 늘면 된다
            // 통관반출은 여기 없다 — 중국에서 온 정상 물건은 '입고대기' 목록에서
            // 입고승인을 누르면 발주까지 자동으로 붙는다. 이 창은 그 밖의 경로용.
            국내입고사유: ['회송입고', '반품입고', '국내사입', '기초재고'],
            // 국내창고에서 물건이 빠져나가는 곳. 쿠팡센터만 그 뒤가 있다(선적·입고).
            출고행선지: ['쿠팡센터', '폐기', '기부', '다른마켓', '기타'],
            구매정보없음재고: [],
            searchKeyword: '', // 테이블 검색 (상품명/SKU/바코드)

            // Phase 6-2: Inventory 기반 국내재고
            inventoryList: [],           // Inventory 컬렉션 데이터
            pendingInboundList: [],      // 입고대기 목록 (Reqpurchase 기반)
            showPendingInbound: false,   // 입고대기 섹션 토글
            // 입고승인 모달
            showInboundModal: false,
            inboundEditItem: null,       // 현재 편집중인 입고대기 항목
            inboundEditQty: 0,           // 수정된 수량
            inboundEditName: '',         // 수정된 상품명

            // Phase 6-3: 수동입고 모달
            showManualInboundModal: false,
            manualInbound: { barcode: '', 상품명: '', 수량: 1, 사유: '직접입고', 메모: '' },
            manualInboundMatched: null,    // searchByBarcode 매칭 결과
            manualInboundProcessing: false,
            // Phase 6-3: 출고 모달
            showOutboundModal: false,
            outboundItems: [],             // 출고 대상 [{...item, outQty, 사유, 메모}]
            outboundProcessing: false,
            // Phase 6-3: 재고수정 모달
            showAuditModal: false,
            auditItems: [],                // 수정 대상 [{...item, 실사수량, 메모}]
            auditProcessing: false,

            // 대시보드 상태별 카운트
            statusCounts: {
                배송완료: 0, 입고작업: 0, 출고요청: 0, 출고대기: 0, 중국재고: 0,
                출고완료: 0, 해외입고중: 0, 국내입고중: 0, 국내창고입고중: 0,
                국내창고입고완료: 0
            },

            // 대시보드용 전체 데이터
            allStatusData: [],

            // === 새로운 구조 ===

            // 1단계: 창고 관리 (기본 정보)
            warehouses: [], // 창고 목록 [{ id, name, address, description }]
            currentWarehouseId: null,
            showWarehouseForm: false,
            warehouseForm: {
                name: '',
                address: '',
                description: ''
            },

            // 2단계: 레이아웃 관리 (시각적 배치) - fabric.js 사용
            fabricCanvas: null,
            layoutAreas: [], // 레이아웃 구역들 (시각적 배치용)
            storageAreas: [], // 보관위치들 (실제 보관 공간)
            isLayoutEditMode: false,

            // 선택된 항목 관리
            selectedLayoutArea: null, // 선택된 레이아웃 구역
            selectedStorageArea: null, // 선택된 보관위치

            // 층별 정보 표시
            showLevelTooltip: false,
            levelTooltipPosition: { x: 0, y: 0 },
            hoveredStorageArea: null,
            tooltipHideTimer: null,

            // 선택된 층의 아이템 정보
            selectedStorageInfo: null,

            // 위치별 필터 정보 (테이블 배지 클릭 시)
            selectedLocationFilter: null,

            // 리사이즈 관련 (이동 기능 제거)
            isResizing: false,
            dragStartX: 0,
            dragStartY: 0,
            resizeHandle: null,
            resizeTarget: null, // 'layout' 또는 'storage'

            // 위치 선택 관련
            showLocationDropdown: false,
            currentDropdownArea: null,
            dropdownPosition: { x: 0, y: 0 },
            selectedWarehouseLocation: null,

            // 위치 하이라이트 관련
            pendingHighlightLocation: null,
            highlightTimer: null,

            // 복사/붙여넣기 관련
            clipboardArea: null,

            formData: {
                상품매칭: [],
                옵션1_중국어: '',
                옵션2_중국어: '',
                구매재고: '구매불가',
                등록이미지: '',
                옵션이미지: '',
                매칭상태: '매칭필요',
                요청내역: {}
            },


            업체명: '',
            companyids: [],
            importtext: 'Connect',

            total: 0,
            구매전: 0,
            발송전: 0,
            발송완료: 0,
            입고완료: 0,


            showspinner: false,

            allcheckreqlists: false,
            reqlists: [],
            allreqlists: [], // 전체 데이터 저장용
            reqlistsinit: [],

            title: "구매대행요청",
            desc1: "쿠팡로켓 / 제트배송 / 일반LCL을 선택한 후에 양식을 다운받아 작성하여 업로드 해주세요",
            desc2: "상품DB에 SKU ID/구매링크/옵션1_중국어/옵션2_중국어를 미리 업로드해 놓을 경우 자동으로 상품이 매핑됩니다. (일반LCL제품은 10000000이하의 숫자로 SKU ID를 작성해 주세요)",
            desc3: "",

            showreqlist: false,
            showlist: false,

            checkbarcode: true,
            checktag: false,
            checkstamp: false,
            checksticker: false,

            // reqtype: "로켓배송",
            showreqrocket: false,
            showreqjet: false,
            showreqgeneral: false,
            purchaseno: '',
            payment: '',
            reqcontent: '',

            allchecked: false,
            packageMethod: 'auto',
            lists: [],
            downloadlists: [],
            currentindex: '',

            uploadstatus: 'excel file upload',

            CreatePo_수취인: this.$store.state.settings[0].CreatePo_수취인,
            CreatePo_연락처: this.$store.state.settings[0].CreatePo_연락처,
            CreatePo_주소_성: this.$store.state.settings[0].CreatePo_주소_성,
            CreatePo_주소_시: this.$store.state.settings[0].CreatePo_주소_시,
            CreatePo_주소_구: this.$store.state.settings[0].CreatePo_주소_구,
            CreatePo_상세주소: this.$store.state.settings[0].CreatePo_상세주소,
            CreatePo_주문번호: this.$store.state.settings[0].CreatePo_주문번호,
            CreatePo_발주기준일: this.$store.state.settings[0].CreatePo_발주기준일,

        }
    },
    created() {
        document.addEventListener.call(window, "message", event => {
            if (event.data.res && event.data.res === 'yes') {
                console.log(event.data.res);
                console.log(event.data.result[0].result);
                if (event.data.result[0].result.option1array.length == 0) {
                    this.lists[this.currentindex].상품매칭.옵션1_중국어 = [];
                    this.lists[this.currentindex].옵션1_중국어 = '';
                } else {
                    this.lists[this.currentindex].상품매칭.옵션1_중국어 = event.data.result[0].result.option1array;
                }
                if (event.data.result[0].result.option2array.length == 0) {
                    this.lists[this.currentindex].상품매칭.옵션2_중국어 = [];
                    this.lists[this.currentindex].옵션2_중국어 = '';
                } else {
                    this.lists[this.currentindex].상품매칭.옵션2_중국어 = event.data.result[0].result.option2array;
                }
                this.lists[this.currentindex].showspinner = false;
                this.currentindex = '';
            }
        });
    },
    watch: {
        // tableSelectedItem이 변경될 때 감시
        tableSelectedItem: {
            handler(newVal) {
                // 선택된 항목이 0개가 되면 collapse를 자동으로 닫음
                if (newVal.length === 0) {
                    if (this.showBatchChange) {
                        this.showBatchChange = false;
                        this.batchStatus = '';
                    }
                    if (this.showLocationChange) {
                        this.showLocationChange = false;
                        this.batchLocationWarehouse = '';
                        this.batchLocationArea = '';
                        this.batchLocationLevel = '';
                    }
                }
            },
            deep: true // 배열의 내용 변화도 감지
        },

        // 창고 선택이 변경될 때 하위 선택 초기화
        batchLocationWarehouse() {
            this.batchLocationArea = '';
            this.batchLocationLevel = '';
        },

        // 구역 선택이 변경될 때 층 선택 초기화
        batchLocationArea() {
            this.batchLocationLevel = '';
        }
    },
    computed: {
        // 앞 lot 이 없는 사유만 매입가를 받는다. 나머지는 앞 lot 의 원가를 이어받는다(정본 §4)
        needsPurchasePrice() {
            return ['국내사입', '기초재고'].includes(this.domesticReceipt.사유);
        },
        domesticCostTotal() {
            return (this.domesticShip.비용 || []).reduce((a, c) => a + (parseInt(c.amount) || 0), 0);
        },
        // 쿠팡센터로 갈 때만 그 뒤가 있다 — 선적을 만들고 입고를 기다린다.
        // 폐기·기부·다른 마켓은 재고에서 빼고 거기서 끝이라 입고ID·창고비 칸이 필요 없다.
        쿠팡센터출고() {
            return (this.domesticShip && this.domesticShip.행선지 || '쿠팡센터') === '쿠팡센터';
        },
        // 쿠패스(admin) 여부 판별
        isAdmin() {
            return this.$store.state.user.auth && this.$store.state.user.auth.showadmin === true;
        },
        // 탭별 헤더 반환
        currentHeaders() {
            return this.activeTab === 'overseas' ? this.overseasHeaders : this.domesticHeaders;
        },
        // 검색 필터 적용된 리스트 (domestic → inventoryList, overseas → reqlists)
        filteredReqlists() {
            const source = this.activeTab === 'domestic' ? this.inventoryList : this.reqlists;
            if (!this.searchKeyword || !this.searchKeyword.trim()) return source;
            const kw = this.searchKeyword.trim().toLowerCase();
            return source.filter(e =>
                (e.상품명 && e.상품명.toLowerCase().includes(kw)) ||
                (e.SKUID && e.SKUID.toLowerCase().includes(kw)) ||
                (e.바코드 && e.바코드.toLowerCase().includes(kw)) ||
                (e.barcode && e.barcode.toLowerCase().includes(kw))
            );
        },
        // 입출고이력 검색 필터 (Inventory 기반)
        filteredHistoryList() {
            if (!this.historySearchKeyword || !this.historySearchKeyword.trim()) return this.historyList;
            const kw = this.historySearchKeyword.trim().toLowerCase();
            return this.historyList.filter(e =>
                (e.상품명 && e.상품명.toLowerCase().includes(kw)) ||
                (e.SKUID && e.SKUID.toLowerCase().includes(kw)) ||
                (e.barcode && e.barcode.toLowerCase().includes(kw)) ||
                (e.사유 && e.사유.toLowerCase().includes(kw))
            );
        },
        // 창고 선택 옵션 (페이지 로드 시 자동으로 로드된 창고 정보 사용)
        warehouseOptions() {
            const options = [{ value: '', text: '창고를 선택하세요', disabled: true }];
            if (this.warehouses && this.warehouses.length > 0) {
                this.warehouses.forEach(warehouse => {
                    options.push({
                        value: warehouse.name,
                        text: `${warehouse.name} (${warehouse.address || '주소 없음'})`
                    });
                });
            } else {
                options.push({ value: '', text: '등록된 창고가 없습니다', disabled: true });
            }
            return options;
        },

        // 구역 선택 옵션 (선택된 창고의 보관위치들)
        areaOptions() {
            const options = [{ value: '', text: '구역을 선택하세요', disabled: true }];
            if (this.batchLocationWarehouse && this.storageAreas && this.storageAreas.length > 0) {
                // 중복 제거를 위해 Set 사용
                const uniqueAreas = [...new Set(this.storageAreas.map(area => area.name))];
                uniqueAreas.forEach(areaName => {
                    options.push({ value: areaName, text: areaName });
                });
            }
            return options;
        },

        // 층 선택 옵션 (선택된 구역의 층들)
        levelOptions() {
            const options = [{ value: '', text: '층을 선택하세요', disabled: true }];
            if (this.batchLocationArea && this.storageAreas && this.storageAreas.length > 0) {
                const selectedArea = this.storageAreas.find(area => area.name === this.batchLocationArea);
                if (selectedArea && selectedArea.levels) {
                    selectedArea.levels.forEach(level => {
                        options.push({ value: level, text: level });
                    });
                }
            }
            return options;
        }
    },
    methods: {
        getModalId(item) {
            // item._id가 고유하고 HTML ID로 사용 가능하다고 가정
            return `edit-modal-${item._id}`;
        },

        // 모달이 열리기 직전 호출 (@show 이벤트 핸들러)
        handleModalShow(item) {
            console.log(`모달 열림 준비: ${item._id}`);
            // 취소 시 복원을 위해 원본 데이터 임시 저장 (item 객체에 직접 추가)
            // '_originalData' 같이 충돌 가능성 적은 이름 사용
            this.$set(item, '_originalData', this.deepClone({
                상품명: item.상품명,
                바코드: item.바코드
                // 필요한 다른 필드도 복사
            }));
            console.log("원본 데이터 저장됨:", item._originalData);
        },

        // 모달 '저장(OK)' 버튼 클릭 시 (@ok 이벤트 핸들러)
        async handleModalOk(bvModalEvent, item) {
            console.log(`저장 시도: ${item._id}`);
            // 기본 모달 닫힘 방지
            bvModalEvent.preventDefault();

            // 간단 유효성 검사
            if (!item.상품명 || !item.바코드) {
                alert('상품명과 바코드를 모두 입력해주세요.');
                return; // 저장 중단
            }

            // 원본과 비교하여 변경사항 확인 (선택 사항)
            if (item._originalData &&
                item.상품명 === item._originalData.상품명 &&
                item.바코드 === item._originalData.바코드) {
                console.log("변경 사항 없음, 모달 닫기");
                // 변경 없으면 임시 데이터 제거 후 모달 닫기
                delete item._originalData;
                this.$refs['modalRef-' + item._id]?.hide(); // ref로 특정 모달 닫기
                return;
            }


            try {
                // 서버 업데이트 요청 (item 객체를 배열에 담아 전달)
                await this.updatereqlist([item]); // v-model로 이미 item이 수정된 상태

                // 성공 시: 임시 원본 데이터 제거
                delete item._originalData;
                console.log(`저장 성공 및 임시 데이터 제거: ${item._id}`);
                alert('성공적으로 저장되었습니다.');

                // 명시적으로 모달 닫기 (필수)
                this.$refs['modalRef-' + item._id]?.hide();

                // reqlistsinit 업데이트 (필요 시)
                const initIndex = this.reqlistsinit.findIndex(initItem => initItem._id === item._id);
                if (initIndex !== -1) {
                    this.reqlistsinit.splice(initIndex, 1, this.deepClone(item));
                }


            } catch (error) {
                console.error(`저장 실패: ${item._id}`, error);
                alert(`저장 중 오류가 발생했습니다: ${error.message || '알 수 없는 오류'}`);
                // 실패 시 모달을 닫지 않음 (사용자가 수정하거나 취소할 기회 제공)
            }
        },

        // 모달이 완전히 닫힌 후 호출 (@hidden 이벤트 핸들러)
        handleModalHidden(item) {
            console.log(`모달 닫힘: ${item._id}`);
            // 임시 원본 데이터가 남아있다면 => 저장 실패했거나, '취소' 버튼을 누른 경우
            if (item._originalData) {
                console.log("취소 또는 저장 실패로 인한 데이터 복원 시도");
                // 원본 데이터로 item 객체 복원
                Object.assign(item, item._originalData); // item의 속성을 _originalData의 속성으로 덮어씀
                // 복원 후 임시 데이터 제거
                delete item._originalData;
                console.log("데이터 복원 완료 및 임시 데이터 제거");
            } else {
                console.log("정상 저장 완료 후 닫힘 (복원 불필요)");
            }
        },

        // Form 안에서 Enter키로 제출 시 OK 버튼 누른 것과 동일하게 처리 (선택 사항)
        submitViaOk(item) {
            // 해당 아이템의 모달 참조를 찾아 ok() 메소드를 호출
            this.$refs['modalRef-' + item._id]?.ok();
        },
        updateInspectionResults(group, item, list) {
            // 체크된 항목들만 요청내역에 저장
            const checkedItems = group.items
                .filter(i => i.checked)
                .map(i => i.content);

            if (!list.요청내역.checklist) {
                this.$set(list.요청내역, 'checklist', {
                    groups: this.deepClone(this.checklistGroups)
                });
            }

            // 현재 그룹 찾기
            const targetGroup = list.요청내역.checklist.groups.find(g => g.title === group.title);
            if (targetGroup) {
                // 아이템 업데이트
                const targetItem = targetGroup.items.find(i => i.content === item.content);
                if (targetItem) {
                    targetItem.checked = item.checked;
                }

                // 체크된 항목들을 샘플검사요청내역에 저장
                if (!list.요청내역.샘플검사요청내역) {
                    this.$set(list.요청내역, '샘플검사요청내역', {});
                }

                if (checkedItems.length > 0) {
                    this.$set(list.요청내역.샘플검사요청내역, group.title, checkedItems);
                } else {
                    // 체크된 항목이 없으면 해당 그룹 삭제
                    this.$delete(list.요청내역.샘플검사요청내역, group.title);
                }
            }
        },
        validateQuantity(list) {
            const minQuantity = this.getMinOrderQuantity(list);
            const maxQuantity = this.getAvailableStock(list);
            const currentQuantity = parseInt(list.구매요청수량);

            if (currentQuantity < minQuantity) {
                alert(`최소 주문수량(${minQuantity}개)보다 적습니다.`);
                // list.구매요청수량 = minQuantity;
            } else if (currentQuantity > maxQuantity) {
                alert(`구매 가능한 최대 수량(${maxQuantity}개)을 초과하였습니다.`);
                // list.구매요청수량 = maxQuantity;
            }
        },
        getMinOrderQuantity(list) {
            if (!list.item) return 2;
            return list.item?.minOrderQuantity || 2;
        },
        getAvailableStock(list) {
            // console.log(list)
            if (!list.item || !list.item.productSaleInfo) return 0;

            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어
                )?.amountOnSale || 0);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                )?.amountOnSale || 0);
            }
            return stock;
        },
        async createOrder() {
            // 1. 선택된 아이템 검증
            let arr = [];
            if (this.tableSelectedItem.length == 0) {
                if (this.reqlists.filter(e => e.processStatus == '구매전').length < this.reqlists.length) {
                    alert('구매전 상태인 제품들만 선택해주세요.')
                    return
                }
                arr = this.reqlists
            } else {
                if (this.tableSelectedItem.filter(e => e.processStatus == '구매전').length < this.tableSelectedItem.length) {
                    alert('구매전 상태인 제품들만 선택해주세요.')
                    return
                }
                arr = this.tableSelectedItem
            }

            // 최소 주문수량과 재고 검증
            const orderQuantityByProduct = {};
            arr.forEach(item => {
                if (!item.구매링크) return;
                const supplierId = ((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '';

                // SKU 정보 찾기 및 재고 확인
                let stock = 0;

                // 옵션이 없는 경우
                if (!item.item.props_list || Object.keys(item.item.props_list).length === 0) {
                    stock = parseInt(item.item.num);
                }
                // 옵션이 1개인 경우
                else if (item.item.skus.sku.some(sku => !sku.properties.includes(';'))) {
                    const properties = item.item.skus.sku.find(sku =>
                        sku.properties_name.includes(item.옵션1_중국어)
                    );
                    if (properties) {
                        stock = parseInt(properties.quantity);
                    }
                }
                // 옵션이 2개인 경우
                else {
                    const skuInfo = item.item.productSkuInfos.find(sku =>
                        sku.skuAttributes.some(attr => attr.value === item.옵션1_중국어) &&
                        sku.skuAttributes.some(attr => attr.value === item.옵션2_중국어)
                    );
                    if (skuInfo) {
                        stock = parseInt(skuInfo.amountOnSale);
                    }
                }

                if (!orderQuantityByProduct[supplierId]) {
                    orderQuantityByProduct[supplierId] = {
                        totalQuantity: 0,
                        minOrderQuantity: item.item?.minOrderQuantity || 2,
                        products: []
                    };
                }

                orderQuantityByProduct[supplierId].totalQuantity += parseInt(item.구매요청수량 || 0);
                orderQuantityByProduct[supplierId].products.push({
                    name: item.상품명,
                    quantity: item.구매요청수량,
                    stock: stock,
                    options: item.옵션1_중국어 && item.옵션2_중국어 ?
                        `${item.옵션1_중국어}, ${item.옵션2_중국어}` :
                        item.옵션1_중국어 || ''
                });
            });

            // 검증 실행
            for (const info of Object.values(orderQuantityByProduct)) {
                // 최소 주문수량 체크
                if (info.totalQuantity < info.minOrderQuantity) {
                    const productDetails = info.products
                        .map(p => `${p.name} (옵션: ${p.options}, 수량: ${p.quantity}개)`)
                        .join('\n');

                    alert(`다음 상품들의 총 주문수량(${info.totalQuantity}개)이 최소 주문수량(${info.minOrderQuantity}개)보다 적습니다:\n\n${productDetails}`);
                    return;
                }

                // 재고 수량 체크
                const outOfStockProducts = info.products.filter(p => parseInt(p.quantity) > parseInt(p.stock));
                if (outOfStockProducts.length > 0) {
                    const stockDetails = outOfStockProducts
                        .map(p => `${p.name}\n- 옵션: ${p.options}\n- 주문수량: ${p.quantity}개\n- 가용재고: ${p.stock}개`)
                        .join('\n\n');

                    alert(`다음 상품들의 주문수량이 재고수량을 초과합니다:\n\n${stockDetails}`);
                    return;
                }
            }
            this.showspinner = true;

            try {
                console.log("처리할 전체 items:", arr);
                const allUpdatedItems = []; // 모든 업데이트될 아이템을 담을 배열

                const companyGroups = {};
                arr.forEach(item => {
                    if (!companyGroups[item.companyid]) {
                        companyGroups[item.companyid] = [];
                    }
                    companyGroups[item.companyid].push(item);
                });
                console.log("Company Groups:", companyGroups);

                for (const [companyId, items] of Object.entries(companyGroups)) {
                    console.log(`Processing Company ${companyId} with items:`, items);

                    const supplierGroups = {};
                    items.forEach(item => {
                        const supplierId = ((item.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '';
                        if (!supplierGroups[supplierId]) {
                            supplierGroups[supplierId] = [];
                        }
                        supplierGroups[supplierId].push(item);
                    });
                    console.log(`Supplier Groups for ${companyId}:`, supplierGroups);

                    for (const [supplierId, supplierItems] of Object.entries(supplierGroups)) {
                        console.log(`Processing Supplier ${supplierId} with items:`, supplierItems);

                        const mergedItems = {};
                        supplierItems.forEach(item => {
                            console.log(`Processing item for merging:`, item);
                            // 옵션이 없는 경우
                            if (!item.옵션1_중국어 && !item.옵션2_중국어) {
                                var specId = "";
                            }
                            // 옵션이 1개인 경우
                            else if (item.옵션1_중국어 && !item.옵션2_중국어) {
                                specId = item.item.productSkuInfos.find(f => f.skuAttributes[0].value == item.옵션1_중국어).specId;
                            }
                            // 옵션이 2개인 경우
                            else {
                                specId = item.item.productSkuInfos.find(f => f.skuAttributes[0].value == item.옵션1_중국어 && f.skuAttributes[1].value == item.옵션2_중국어).specId;
                            }

                            console.log(`Found specId:`, specId);

                            // if (!specId) {
                            //     console.log(`No specId found for item:`, item);
                            //     return;
                            // }

                            const key = `${specId}`;
                            if (!mergedItems[key]) {
                                mergedItems[key] = {
                                    offerId: parseInt(supplierId),
                                    specId: specId,
                                    quantity: 0
                                };
                            }
                            mergedItems[key].quantity += parseInt(item.구매요청수량) * parseInt(item.판매구성수량 || 1);
                        });
                        console.log(`Merged items:`, mergedItems);

                        const mergedItemsList = Object.values(mergedItems);
                        console.log(`Merged items list:`, mergedItemsList);

                        const chunks = [];
                        for (let i = 0; i < mergedItemsList.length; i += 50) {
                            chunks.push(mergedItemsList.slice(i, i + 50));
                        }
                        console.log(`Created chunks:`, chunks);

                        for (const chunk of chunks) {
                            console.log(`Processing chunk:`, chunk);
                            let reqtype = 'G ';
                            if (supplierItems[0].reqtype == '로켓배송') {
                                reqtype = 'G ';
                            } else if (supplierItems[0].reqtype == '제트배송') {
                                reqtype = 'Z ';
                            } else if (supplierItems[0].reqtype == '샘플검증') {
                                reqtype = 'Z ';
                            }

                            const orderRequest = {
                                flow: 'general',
                                message: '',
                                addressParam: {
                                    fullName: ('飞运' + reqtype + companyId).slice(0, 24),
                                    mobile: '15650102901',
                                    provinceText: '山东省',
                                    cityText: '威海市',
                                    areaText: '环翠区',
                                    address: '凤林街道海南路9号飞运' + reqtype + companyId +
                                        `(无法自提 不接受到付)`,
                                    postCode: '000000'
                                },
                                cargoParamList: chunk
                            };
                            console.log(`Sending order request:`, orderRequest);

                            const res = await axios.post('/api/reqpurchase/createCrossOrder', orderRequest);
                            console.log(`Order creation response:`, res.data);
                            if (res.data.요청결과 !== '성공') {
                                const errorMessage = res.data.error?.errorMessage ||
                                    res.data.error?.message ||
                                    res.data.error ||
                                    '주문 생성 실패';
                                throw new Error(errorMessage);
                            }
                            if (res.data.요청결과 === '성공') {
                                // chunk에 사용된 specId들을 이용해 해당하는 supplierItems 찾기
                                for (const chunkItem of chunk) {
                                    const items = supplierItems.filter(item => {
                                        let itemSpecId;
                                        // 옵션이 없는 경우
                                        if (!item.옵션1_중국어 && !item.옵션2_중국어) {
                                            itemSpecId = "";
                                        }
                                        // 옵션이 1개인 경우
                                        else if (item.옵션1_중국어 && !item.옵션2_중국어) {
                                            itemSpecId = item.item.productSkuInfos.find(f => f.skuAttributes[0].value === item.옵션1_중국어)?.specId;
                                        }
                                        // 옵션이 2개인 경우
                                        else {
                                            itemSpecId = item.item.productSkuInfos.find(f =>
                                                f.skuAttributes[0].value === item.옵션1_중국어 &&
                                                f.skuAttributes[1].value === item.옵션2_중국어
                                            )?.specId;
                                        }
                                        return itemSpecId === chunkItem.specId;
                                    });

                                    // 찾은 items에 주문 정보 업데이트
                                    items.forEach(item => {
                                        item.주문정보 = {
                                            주문번호: res.data.result.orderResult.result.orderId,
                                            배송비: res.data.result.orderResult.result.postFee / 100,
                                            구매가격: (res.data.result.orderResult.result.totalSuccessAmount - res.data.result.orderResult.result.postFee) / 100,
                                            총금액: res.data.result.orderResult.result.totalSuccessAmount / 100
                                        };
                                        item.processStatus = '구매확인';
                                        allUpdatedItems.push(item); // 전체 배열에 추가
                                    });
                                }
                            }
                        }
                    }
                }

                // 모든 처리가 완료된 후 한번에 업데이트
                if (allUpdatedItems.length > 0) {
                    console.log(allUpdatedItems)
                    await this.updatereqlist(allUpdatedItems);
                }

                alert('모든 주문 생성 완료');
                this.showspinner = false;
            } catch (e) {
                alert('주문 생성 실패: ' + e.message);
                console.error('주문 생성 에러:', e);
                this.showspinner = false;
                return;
            }
        },
        changePackage(list) {
            if (this.packageMethod == 'opp') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'LDPE') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'noPackage') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'auto') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = true;
                return
            }
        },
        confirmBarcode(list) {
            if (list.바코드.includes('no') || list.바코드.includes('NO') || list.바코드.includes('No') || list.바코드.includes('노')) {
                if (list.묶음구성여부) {
                    alert('바코드 정보가 없는 경우 묶음구성 진행이 어렵습니다. 바코드를 먼저 생성해 주세요')
                    return
                }
            }
        },
        async changeoptiondone() {
            if (this.change && !this.changeoption) {
                if (confirm('변경사항을 저장하시겠습니까?')) {
                    this.reqlists.forEach((e, i) => {
                        if (this.changeindexlist.includes(i)) {
                            e.checked = true;
                        } else {
                            e.checked = false;
                        }
                    })
                    var arr = this.reqlists.filter(e => e.checked);
                    if (confirm('구매불가는 구매취소처리하시겠습니까?')) {
                        arr.forEach(e => {
                            e.processStatus = '구매취소';
                            e.구매취소 = true;
                        })
                    }
                    var result = await this.updatereqlist(arr);
                    console.log(result);
                    this.search();
                } else {
                    this.search();
                }
            }
        },
        async allcancelpo() {
            if (this.tableSelectedItem.length == 0) {
                alert('변경할 내역을 선택해 주세요')
                return
            }
            if (this.일괄변경 == '구매취소' && this.tableSelectedItem.filter(e => e.processStatus !== '구매전' && e.processStatus !== '구매취소').length > 0) {
                if (!confirm('이미 구매한 제품이 있습니다. 그래도 구매취소처리하시겠습니까?')) {
                    return
                }
            }
            this.tableSelectedItem.forEach(e => {
                e.processStatus = this.일괄변경;
                if (this.일괄변경 == '구매취소') {
                    e.구매취소 = true;
                    e.구매취소내용 = e.일괄구매취소내용;
                } else {
                    e.구매취소 = false;
                    e.구매취소내용 = '';
                }
            })
            var arr = this.tableSelectedItem
            var result = await this.updatereqlist(arr);
            console.log(result);
            this.search();
        },
        cancelpo(list) {
            if (list.구매취소) {
                list.processStatus = "구매취소"
            } else {
                list.processStatus = "구매전"
            }
            console.log(list)
        },
        productNameWith(list) {
            // if(confirm('변경된 한글표시사항 제품명에 따라 상품명도 변경하시겠습니까?')){
            list.상품명 = list.한글표시사항.제품명;
            // }
        },
        importcompanyinfo() {
            if (this.업체명) {
                if (this.$store.state.purchase.length > 0 && this.업체명.toUpperCase() == this.$store.state.purchase[0].companyid.toUpperCase()) {
                    this.showimportspinner = false;
                    this.importtext = 'Connected'
                    return
                }
                this.showimportspinner = true;
                axios.post('/api/logisaddimport/importcompanyinfo', {
                    companyid: this.업체명
                })
                    .then(result => {
                        if (result.data.요청결과 == 'success') {
                            this.importreqlists()
                            this.$store.commit('dbupdate', result.data.dbs)
                            this.importstock = this.$store.state.stock.length > 0 ? this.$store.state.stock.filter(e => e.site == 'cn') : [];
                            this.showimportspinner = false;
                            this.importtext = 'Connected'
                        } else {
                            alert('업체 Data Import 실패')
                        }
                    }).catch((e) => {
                        console.log(e);
                    })
            } else {
                alert('업체ID를 기입해 주세요')
            }
        },
        polistchange(b, list) {
            list.발주수량 = b.sku수량;
            list.구매요청수량 = b.sku수량;
            list.selectpo = b.발주번호;
        },
        labelling(요청내역) {
            if (요청내역.barcode) {
                요청내역.한글표시사항 = true
            } else {
                요청내역.한글표시사항 = false
            }
        },
        qadefault(요청내역) {
            if (!요청내역.default) {
                if (요청내역.barcode || 요청내역.sticker || 요청내역.stamp || 요청내역.tag) {
                    alert('개별 원산지 작업을 하는 경우 기본검수는 필수항목 입니다.')
                    요청내역.default = true;
                }
            }
        },

        showModal(item) {
            this.formData = item
            // console.log('formData', this.formData)
        },
        async saverequest(item) {
            const selectedIndex = this.reqlists.findIndex(i => i._id === item._id);
            if (item.processStatus === '입고완료') {
                if (!confirm('입고가 완료된 상품은 수정이 불가능 합니다. 그래도 진행하시겠습니까?')) {
                    return
                }
            }
            if (item.processStatus === '구매전') {
                this.reqlistsinit[selectedIndex] = this.deepClone(item)
                await this.updatereqlist([item])
                this.$forceUpdate();
            } else {
                if (item['구매요청수량'] !== this.reqlistsinit[selectedIndex]['구매요청수량']) {
                    if (!confirm('이미 구매 진행된 상품은 구매요청수량을 변경할 수 없습니다. 그래도 진행하시겠습니까?')) {
                        return
                    }
                } else {
                    this.reqlistsinit[selectedIndex] = this.deepClone(item)
                    await this.updatereqlist([item])
                    this.$forceUpdate();
                }
            }
        },
        async updatereqlist(arr) { /* 기존 로직 (에러 throw 필수) */
            if (arr && arr.length > 0) {
                console.log("서버 업데이트 요청:", arr);
                return axios.post('/api/reqpurchase/updatereqpurchase', arr)
                    .then((res) => {
                        if (res.data.요청결과 == '변경완료') {
                            console.log('서버 업데이트 성공');
                        } else {
                            console.error('서버 업데이트 실패:', res.data);
                            throw new Error(res.data.요청결과 || '서버 저장 실패');
                        }
                        return res;
                    })
                    .catch(error => {
                        console.error('updatereqlist Axios 오류:', error);
                        throw error; // 에러를 상위로 전파
                    });
            } else {
                return Promise.resolve();
            }
        },

        showa() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '구매전');
                this.showreqlist = true;
            }, 10);
        },
        showb() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '배송전');
                this.showreqlist = true;
            }, 10);
        },
        showc() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus != '구매전' && e.processStatus != '배송전' && e.processStatus != '발송지연' && e.processStatus != '입고완료' && e.processStatus != '배송지연');
                this.showreqlist = true;
            }, 10);
        },
        showd() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '입고완료');
                this.showreqlist = true;
            }, 10);
        },

        showf() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.구매취소);
                this.showreqlist = true;
            }, 10);
        },
        showg() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '발송지연');
                this.showreqlist = true;
            }, 10);
        },
        showh() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '배송지연');
                this.showreqlist = true;
            }, 10);
        },

        showj() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.processStatus == '구매확인');
                this.showreqlist = true;
            }, 10);
        },
        async poconfirm(arr) {
            arr.forEach(e => {
                if (e.processStatus === '구매전') {
                    e.processStatus = "구매확인"
                }
            })
            var result = await this.updatereqlist(arr);
            console.log(result);
            this.search();
        },
        // 국내재고 입고일: processHistory에서 국내창고입고완료 시점 추출
        getIngoDate(item) {
            if (!item.processHistory || item.processHistory.length === 0) return '-';
            const record = item.processHistory.find(h => h.toStatus === '국내창고입고완료' || h.status === '국내창고입고완료');
            return record ? this.getTimeDate(record.timestamp || record.date).split(' ')[0] : '-';
        },
        getTimeDate(timestamp) {
            let date = new Date(timestamp);
            let year = date.getFullYear();
            let month = ("0" + (1 + date.getMonth())).slice(-2);
            let day = ("0" + date.getDate()).slice(-2);
            let hours = ("0" + date.getHours()).slice(-2);
            let minutes = ("0" + date.getMinutes()).slice(-2);
            let seconds = ("0" + date.getSeconds()).slice(-2);

            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        },
        download() {
            var arr = [];
            var ar = [];
            if (this.tableSelectedItem.length == 0) {
                if (this.reqlists.filter(e => e.processStatus == '구매전' || e.processStatus == '구매확인').length < this.reqlists.length) {
                    alert('구매전이거나 구매확인 제품들만 선택해주세요.')
                    return
                }
                if (this.reqlists.filter(e => e.companyid == this.reqlists[0].companyid).length < this.reqlists.length) {
                    alert('같은 업체명만 선택해주세요')
                    return
                }
                arr = this.reqlists
            } else {
                if (this.tableSelectedItem.filter(e => e.processStatus == '구매전' || e.processStatus == '구매확인').length < this.tableSelectedItem.length) {
                    alert('구매전인 제품들만 선택해주세요.')
                    return
                }
                if (this.tableSelectedItem.filter(e => e.companyid == this.tableSelectedItem[0].companyid).length < this.tableSelectedItem.length) {
                    alert('같은 업체명만 선택해주세요')
                    return
                }
                arr = this.tableSelectedItem
            }
            if (confirm('다운로드 내역을 구매확인으로 변경하시겠습니까?')) {
                this.poconfirm(arr);
            }

            var obj = {};
            console.log(arr)
            arr.forEach(e => {
                if (e.reqtype == '로켓배송') {
                    var reqtype = 'R仓库'
                } else {
                    if (e.reqtype == '제트배송') {
                        reqtype = 'Z仓库'
                    } else {
                        reqtype = 'G仓库'
                    }
                }

                obj = {
                    '订单号': e.companyid + "-" + this.getToday(),
                    '商品名称': e.상품명,
                    '商品数量(件)': e.구매요청수량 * e.판매구성수량,
                    '商品规格1（如：颜色）': e.옵션1_중국어 === undefined ? '' : e.옵션1_중국어,
                    '商品规格2（如：尺码）': e.옵션2_중국어 === undefined ? '' : e.옵션2_중국어,
                    '收件人-姓名': this.CreatePo_수취인,
                    '收件人-手机': '15650102901',
                    '收件人-省': this.CreatePo_주소_성,
                    '收件人-市': this.CreatePo_주소_시,
                    '收件人-区': this.CreatePo_주소_구,
                    '收件人-详细地址': '凤林街道海南路9号飞运' + ' ' + e.companyid.toUpperCase() + `${reqtype}(无法自提 不接受到付)`,
                    '收货地址（省/市/区/详细地址合并的收货地址）': '',
                    '买家留言': e.SKUID,
                    '1688商品链接/1688商品id': ((e.구매링크 || '').match(/offer\/(\d+)/) || [])[1] || '',
                    '分销or现货（默认或者填1走分销，0走现货）': 0,
                }
                ar.push(obj)
            })

            console.log(ar)

            this.downloadpo(ar)
        },
        async onClickLocket(list) {
            if (list.processStatus !== '구매전') {
                alert('구매전인 상품만 변경 가능합니다.');
            } else {
                if (confirm('로켓배송으로 변경 하시겠습니까 ?')) {
                    try {
                        const response = await axios.post('/api/reqpurchase/changeLocket', { list })
                        console.log(response)
                        alert(response.data.요청결과)
                    } catch (error) {
                        alert('알 수 없는 error')
                        console.error(error);
                    }
                } else {
                    return false
                }
            }
        },
        // 아이템 데이터 가공 헬퍼
        processItem(e) {
            var customsType = e.요청내역?.customsType == 'integrated' ? '통합통관' : e.요청내역?.customsType == 'client' ? '화주단독통관' : e.요청내역?.customsType == 'kupass' ? '쿠패스단독통관' : '';
            e.통관방법 = customsType;
            e.요청내역 = e.요청내역 || {};
            e.요청내역.reqcontentPurchase = e.요청내역?.reqcontentPurchase || "";
            e.요청변경 = e.changeHistory && e.changeHistory.length > 0 ? true : false;
            e.processStatus = e.processStatus || '구매전';
            e.구매취소 = e.구매취소 ? e.구매취소 : false;
            e.구매취소내용 = e.구매취소내용 ? e.구매취소내용 : '';
            e.판매구성수량 = e.판매구성수량 == '단품' ? 1 : e.판매구성수량;
            e.주문번호 = e.주문정보 ? e.주문정보.주문번호 : "";
            e.processHistory = e.processHistory || [];
            e.checked = false;
            return this.deepClone(e);
        },
        // 탭별 status 매핑
        getTabStatuses(tab) {
            return tab === 'overseas' ? ['중국재고'] : ['국내창고입고완료'];
        },
        async search() {
            this.showspinner = true;
            this.showreqlist = false;
            this.reqlists = [];
            this.inventoryList = [];
            this.tableSelectedItem = [];

            try {
                if (this.activeTab === 'domestic') {
                    // 국내재고: Inventory API + 대시보드 카운트 + 입고대기 동시 호출
                    const [countsRes, invRes, pendingRes] = await Promise.all([
                        axios.post('/api/reqpurchase/getStockCounts', { companyid: this.업체명 }),
                        axios.post('/api/inventory/getList', { companyid: this.업체명 }),
                        axios.post('/api/inventory/getPendingInbound', { companyid: this.업체명 })
                    ]);
                    if (countsRes.data.요청결과 === 'ok') {
                        this.statusCounts = countsRes.data.counts;
                        this.$store.commit('SET_STOCK_COUNTS', countsRes.data.counts);
                    }
                    if (invRes.data.요청결과 === 'ok') {
                        this.inventoryList = invRes.data.items.map(e => this.processInventoryItem(e));
                        this.total = this.inventoryList.length;
                    }
                    if (pendingRes.data.요청결과 === 'ok') {
                        this.pendingInboundList = pendingRes.data.items || [];
                        this.$store.commit('SET_PENDING_INBOUND', this.pendingInboundList);
                    }
                } else {
                    // 해외재고: 기존 Reqpurchase API
                    const [countsRes, dataRes] = await Promise.all([
                        axios.post('/api/reqpurchase/getStockCounts', { companyid: this.업체명 }),
                        axios.post('/api/reqpurchase/getstockmanagement', { companyid: this.업체명, status: this.getTabStatuses(this.activeTab) })
                    ]);
                    if (countsRes.data.요청결과 === 'ok') {
                        this.statusCounts = countsRes.data.counts;
                        this.$store.commit('SET_STOCK_COUNTS', countsRes.data.counts);
                    }
                    if (dataRes.data.요청결과 === 'ok') {
                        const arr = dataRes.data.reqpurchase.map(e => this.processItem(e));
                        this.reqlists = arr;
                        this.reqlistsinit = [...arr];
                        this.$store.commit('SET_STOCK_DATA', { tab: this.activeTab, data: arr });
                        this.total = arr.length;
                    }
                }
                this.showreqlist = true;
            } catch (e) {
                console.log('err821' + e);
            } finally {
                this.showspinner = false;
            }
        },
        // Inventory 아이템 가공 헬퍼 (Reqpurchase와 필드 통일)
        processInventoryItem(item) {
            return {
                ...item,
                _id: item._id,
                등록이미지: item.이미지 || '',
                바코드: item.barcode || '',
            };
        },
        // 탭 전환 시 데이터 로드
        async loadTabData(tab) {
            if (tab === 'domestic') {
                // 국내재고: Inventory API
                this.showspinner = true;
                this.showreqlist = false;
                try {
                    const [invRes, pendingRes] = await Promise.all([
                        axios.post('/api/inventory/getList', { companyid: this.업체명 }),
                        axios.post('/api/inventory/getPendingInbound', { companyid: this.업체명 })
                    ]);
                    if (invRes.data.요청결과 === 'ok') {
                        this.inventoryList = invRes.data.items.map(e => this.processInventoryItem(e));
                        this.total = this.inventoryList.length;
                    }
                    if (pendingRes.data.요청결과 === 'ok') {
                        this.pendingInboundList = pendingRes.data.items || [];
                        this.$store.commit('SET_PENDING_INBOUND', this.pendingInboundList);
                    }
                    this.showreqlist = true;
                } catch (e) {
                    console.log('err822-inv' + e);
                } finally {
                    this.showspinner = false;
                }
            } else {
                // 해외재고: 기존 Reqpurchase API + Vuex 캐시
                const cached = this.$store.state.stockManagement.overseas;
                if (cached && cached.length > 0) {
                    this.reqlists = cached;
                    this.reqlistsinit = [...cached];
                    this.total = cached.length;
                    this.showreqlist = true;
                    return;
                }
                this.showspinner = true;
                this.showreqlist = false;
                try {
                    const res = await axios.post('/api/reqpurchase/getstockmanagement', { companyid: this.업체명, status: this.getTabStatuses(tab) });
                    if (res.data.요청결과 === 'ok') {
                        const arr = res.data.reqpurchase.map(e => this.processItem(e));
                        this.reqlists = arr;
                        this.reqlistsinit = [...arr];
                        this.$store.commit('SET_STOCK_DATA', { tab: 'overseas', data: arr });
                        this.total = arr.length;
                    }
                    this.showreqlist = true;
                } catch (e) {
                    console.log('err822' + e);
                } finally {
                    this.showspinner = false;
                }
            }
        },
        // 일괄 상태변경 응답을 "실제로 바뀐 것"과 "건너뛴 것"으로 가른다.
        // 서버(updateProcessStatusBulk)는 역행 방지에 걸린 건을 skipped[] 로 정직하게 돌려주는데
        // 화면이 그걸 안 읽고 전부 성공으로 처리하던 탓에, DB 는 그대로인데 목록에서는 사라지는
        // 상태가 있었다. 화주 눈에는 "요청했는데 아무 일도 안 일어남" 으로 보인다.
        splitBulkResult(ids, res) {
            const d = (res && res.data) || {};
            const skipped = Array.isArray(d.skipped) ? d.skipped : [];
            const 건너뛴ids = new Set(skipped.map(s => String(s.id)));
            return {
                반영ids: ids.filter(id => !건너뛴ids.has(String(id))),
                건너뜀: skipped
            };
        },
        // 건너뛴 게 있으면 사유까지 보여준다. 이유를 모르면 화주는 같은 버튼을 계속 누른다.
        notifyBulkResult(반영수, 건너뜀, 덧말) {
            if (건너뜀.length === 0) {
                this.$bvToast.toast(`${반영수}건의 출고요청이 완료되었습니다.${덧말 ? ' ' + 덧말 : ''}`,
                    { title: '완료', variant: 'success', solid: true });
                return;
            }
            const 사유 = [...new Set(건너뜀.map(s => s.reason || `${s.fromStatus} → ${s.toStatus} 불가`))].slice(0, 3).join(' / ');
            if (반영수 === 0) {
                this.$bvToast.toast(`출고요청이 반영되지 않았습니다. (${건너뜀.length}건) ${사유}`,
                    { title: '처리되지 않음', variant: 'danger', solid: true, autoHideDelay: 9000 });
            } else {
                this.$bvToast.toast(`${반영수}건 완료, ${건너뜀.length}건은 반영되지 않았습니다. ${사유}`,
                    { title: '일부만 처리됨', variant: 'warning', solid: true, autoHideDelay: 9000 });
            }
        },
        async requestShipment() {
            if (this.tableSelectedItem.length === 0) {
                this.$bvToast.toast('출고요청할 물건을 선택해주세요.', { title: '알림', variant: 'warning', solid: true });
                return;
            }

            const nonChinaStock = this.tableSelectedItem.filter(e => e.processStatus !== '중국재고');
            if (nonChinaStock.length > 0) {
                this.$bvToast.toast('중국재고 상태인 물건만 출고요청할 수 있습니다.', { title: '알림', variant: 'warning', solid: true });
                return;
            }

            if (!confirm(`선택한 ${this.tableSelectedItem.length}건의 중국재고를 출고요청하시겠습니까?\n(중국재고 → 출고요청)\n\n쿠패스에게 알림이 전송됩니다.`)) {
                return;
            }

            try {
                const ids = this.tableSelectedItem.map(e => e._id);
                const res = await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: ids,
                    toStatus: '출고요청',
                    memo: '화주 출고요청 (stockManagement)'
                });

                // 서버가 건너뛴 건은 DB 가 안 바뀐 것이다. 그걸 화면에서 지우면
                // "요청했는데 아무 일도 안 일어남" 이 된다 — 바뀐 것만 지운다.
                const { 반영ids, 건너뜀 } = this.splitBulkResult(ids, res);
                반영ids.forEach(id => this.$store.commit('REMOVE_STOCK_ITEM', { itemId: id, fromTab: 'overseas' }));
                if (반영ids.length > 0) {
                    const newCounts = { ...this.statusCounts };
                    newCounts['중국재고'] = Math.max(0, (newCounts['중국재고'] || 0) - 반영ids.length);
                    newCounts['출고요청'] = (newCounts['출고요청'] || 0) + 반영ids.length;
                    this.statusCounts = newCounts;
                    this.$store.commit('SET_STOCK_COUNTS', newCounts);
                }

                // UI 즉시 반영 (Vuex 캐시에서 다시 로드)
                this.reqlists = this.$store.state.stockManagement.overseas;
                this.tableSelectedItem = [];

                this.notifyBulkResult(반영ids.length, 건너뜀, '쿠패스에게 알림이 전송되었습니다.');
            } catch (error) {
                console.error('출고요청 오류:', error);
                this.$bvToast.toast('출고요청 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            }
        },
        // 국내재고 출고 — '출고요청'이 아니라 새 선적을 만들고 '국내입고중'으로 간다
        //
        // 정본 §5 Phase 4-10. 화주창고에서 쿠팡센터로 다시 보내는 건 별개의 출고다
        // (입고예정일을 새로 잡아 입고요청을 다시 하므로).
        // 예전에는 '출고요청'(11)으로 보냈는데 현재 상태가 '국내창고입고완료'(23)라
        // 역행 방지에 막혀 아무 일도 안 일어났다 — 화면만 성공으로 보였다.
        //
        // 보관비가 이 시점에 확정되므로 국내창고비도 여기서 받는다.
        openDomesticShipModal() {
            if (this.tableSelectedItem.length === 0) {
                this.$bvToast.toast('출고할 물건을 선택해주세요.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            const invalid = this.tableSelectedItem.filter(e => e.processStatus !== '국내창고입고완료');
            if (invalid.length > 0) {
                this.$bvToast.toast('국내창고입고완료 상태인 물건만 출고할 수 있습니다.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            this.domesticShip = {
                // 이 제출 한 번을 가리키는 토큰. 더블클릭·재전송은 같은 토큰이라 한 번만 반영되고,
                // 다음에 다시 출고하면 모달을 새로 열어 새 토큰이 되므로 정상 반영된다
                제출토큰: 'domestic-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
                행선지: '쿠팡센터',
                items: this.tableSelectedItem.map(e => ({
                    _id: e._id,
                    상품명: e.상품명 || '',
                    바코드: e.바코드 || '',
                    수량: parseInt(e.구매요청수량) || 0,
                    재고: null,              // 원장이 아는 잔량. null = 아직 모른다
                    입고ID: '',
                    입고예정일: '',
                    입고센터: ''
                })),
                // 기본 3항목. 자유 추가 가능하고, 실제 청구 형태에 맞는지는 화주가 판단한다
                비용: [
                    { name: '입고비', amount: 0 },
                    { name: '보관비', amount: 0 },
                    { name: '출고비', amount: 0 }
                ],
                busy: false
            };
            this.showDomesticShipModal = true;
            this.loadDomesticStock();
        },
        // 원장이 아는 국내창고 잔량을 채운다. 모르는 상품은 null 로 둔다 —
        // 원장 도입 전 재고는 원장에 없어서, 모르는 걸 0 으로 보이면 다 부족해 보인다.
        async loadDomesticStock() {
            try {
                // 쿠패스(admin)는 업체명을 골라 남의 재고를 본다 — 자기 companyid 로 물으면
                // 늘 "모름(–)" 이 되어 재고 초과 방어가 안 걸린다. 목록과 같은 기준을 쓴다.
                const res = await axios.post('/api/warehouse/balance', {
                    companyid: this.업체명 || this.$store.state.user.companyid,
                    위치: 'KR_창고'
                });
                if (!res.data || res.data.요청결과 !== '성공') return;
                const map = {};
                (res.data.balance || []).forEach(b => { if (b.바코드) map[b.바코드] = parseInt(b.수량) || 0; });
                this.domesticShip.items.forEach(it => {
                    if (Object.prototype.hasOwnProperty.call(map, it.바코드)) this.$set(it, '재고', map[it.바코드]);
                });

                // 바코드 합계는 같은 바코드에 발주가 여럿이면 모든 줄에 같은 숫자로 뜬다.
                // 그걸 보고 출고하면 실제보다 많이 나간다 — 발주 몫으로 덮어쓴다.
                const r2 = await axios.post('/api/warehouse/domesticQtyByReq', {
                    companyid: this.업체명 || this.$store.state.user.companyid,
                    reqIds: this.domesticShip.items.map(x => x._id).filter(Boolean)
                });
                if (!r2.data || r2.data.요청결과 !== '성공') return;
                const 발주별 = r2.data.발주별 || {};
                this.domesticShip.items.forEach(it => {
                    if (Object.prototype.hasOwnProperty.call(발주별, String(it._id))) {
                        this.$set(it, '재고', 발주별[String(it._id)]);
                    }
                });
                this.구매정보없음재고 = r2.data.구매정보없음 || [];
            } catch (e) {
                console.error('국내창고 잔량 조회 오류:', e);
            }
        },
        addDomesticCostRow() {
            this.domesticShip.비용.push({ name: '', amount: 0 });
        },
        removeDomesticCostRow(idx) {
            this.domesticShip.비용.splice(idx, 1);
        },
        async confirmDomesticShipment() {
            const items = (this.domesticShip.items || []).filter(x => (parseInt(x.수량) || 0) > 0);
            if (!items.length) {
                this.$bvToast.toast('수량이 0보다 큰 행이 없습니다.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            // 재고보다 많이 내보낼 수 없다. 서버도 막지만 여기서 먼저 알려주는 게 낫다
            // (누르고 거부당하는 것보다). 재고를 모르는 상품(null)은 막지 않는다.
            const 초과 = items.filter(x => x.재고 !== null && x.재고 !== undefined && (parseInt(x.수량) || 0) > x.재고);
            if (초과.length) {
                this.$bvToast.toast(
                    초과.map(x => `${x.상품명 || x.바코드}: 요청 ${x.수량}개 / 재고 ${x.재고}개`).join(' · '),
                    { title: '재고가 부족합니다', variant: 'danger', solid: true, autoHideDelay: 8000 });
                return;
            }
            // 쿠팡으로 안 갈 때는 창고비를 안 보낸다 — 얹을 매입가 자리가 없다
            const 비용 = this.쿠팡센터출고
                ? (this.domesticShip.비용 || []).filter(c => c.name && (parseInt(c.amount) || 0) >= 0)
                : [];
            this.domesticShip.busy = true;
            try {
                const res = await axios.post('/api/warehouse/domesticShipment', {
                    업로드id: this.domesticShip.제출토큰,
                    행선지: this.domesticShip.행선지,
                    items: items.map(x => Object.assign({}, x, { 국내창고비: { items: 비용 } }))
                });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '출고에 실패했습니다');

                const 결과 = res.data.results || [];
                // 'partial' 도 반영된 것이다 — 재고는 빠지고 선적도 생겼고, 발주 상태만 안 올렸다.
                // 안 세면 전부 부분출고일 때 "0건을 출고했습니다" 가 뜬다.
                const 반영 = 결과.filter(r => ['shipped', 'ledgerOnly', 'partial'].includes(r.action));
                const 부분 = 결과.filter(r => r.action === 'partial');
                const 건너뜀 = 결과.filter(r => r.action === 'skip');

                반영.forEach(r => this.$store.commit('REMOVE_STOCK_ITEM', { itemId: r._id, fromTab: 'domestic' }));
                if (반영.length > 0) {
                    const newCounts = { ...this.statusCounts };
                    newCounts['국내창고입고완료'] = Math.max(0, (newCounts['국내창고입고완료'] || 0) - 반영.length);
                    newCounts['국내입고중'] = (newCounts['국내입고중'] || 0) + 반영.length;
                    this.statusCounts = newCounts;
                    this.$store.commit('SET_STOCK_COUNTS', newCounts);
                }
                this.reqlists = this.$store.state.stockManagement.domestic;
                this.tableSelectedItem = [];
                this.showDomesticShipModal = false;

                if (건너뜀.length) {
                    const 사유 = [...new Set(건너뜀.map(r => r.reason || '알 수 없음'))].slice(0, 3).join(' / ');
                    this.$bvToast.toast(`${반영.length}건 출고, ${건너뜀.length}건은 반영되지 않았습니다. ${사유}`,
                        { title: '일부만 처리됨', variant: 'warning', solid: true, autoHideDelay: 9000 });
                } else {
                    this.$bvToast.toast(
                        `${반영.length}건을 출고했습니다.` +
                        (부분.length ? ` (${부분.length}건은 남은 수량이 있어 진행현황은 그대로 둡니다)` : ' (국내입고중)'),
                        { title: '완료', variant: 'success', solid: true, autoHideDelay: 7000 });
                }
            } catch (error) {
                console.error('국내창고 출고 오류:', error);
                this.$bvToast.toast(error.message || '출고 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            } finally {
                this.domesticShip.busy = false;
            }
        },

        // 국내창고 입고 — 사유 select 하나로 통관반출·회송·반품·국내사입·기초재고를 다 받는다
        //
        // 정본 §5 Phase 4-18. 로직은 사유별로 나뉘지 않고 딱 두 갈래다:
        //   앞 lot 이 있다 → 그 원가를 이어받고 추가비용만 얹는다
        //   앞 lot 이 없다(국내사입·기초재고) → 입력한 매입가가 그 lot 의 원가다
        openDomesticReceiptModal() {
            this.domesticReceipt = {
                바코드: '', 상품명: '', 수량: 0,
                사유: '회송입고', 매입가: 0, 추가비용: 0, 메모: '',
                // 더블클릭·재전송만 막는 토큰. 모달을 새로 열면 새 토큰이라
                // 같은 상품을 같은 수량으로 또 받아도 정상 반영된다
                제출토큰: 'receipt-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
                busy: false
            };
            this.showDomesticReceiptModal = true;
        },
        async confirmDomesticReceipt() {
            const r = this.domesticReceipt;
            if (!r.바코드 || !(parseInt(r.수량) > 0)) {
                this.$bvToast.toast('바코드와 수량을 입력해주세요.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            if (this.needsPurchasePrice && !(parseInt(r.매입가) > 0)) {
                this.$bvToast.toast('국내사입·기초재고는 앞 lot 이 없어 매입가가 필요합니다.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            r.busy = true;
            try {
                const res = await axios.post('/api/warehouse/domesticReceipt', {
                    바코드: r.바코드, 상품명: r.상품명, 수량: parseInt(r.수량),
                    사유: r.사유, 매입가: parseInt(r.매입가) || 0,
                    추가비용: parseInt(r.추가비용) || 0, 메모: r.메모,
                    제출토큰: r.제출토큰
                });
                if (res.data.요청결과 !== '성공') throw new Error(res.data.error || '입고에 실패했습니다');
                this.showDomesticReceiptModal = false;
                if (res.data.경고) {
                    // 재고는 들어갔지만 매입가(lot)가 안 잡힌 경우 — 성공으로만 말하면 안 된다
                    this.$bvToast.toast(`${r.수량}개 입고됐습니다. ${res.data.경고}`,
                        { title: '일부만 처리됨', variant: 'warning', solid: true, autoHideDelay: 9000 });
                } else {
                    this.$bvToast.toast(
                        res.data.duplicated ? '이미 기록된 입고입니다.' : `${r.수량}개를 국내창고에 입고했습니다. (${r.사유})`,
                        { title: '완료', variant: 'success', solid: true });
                }
                this.search();
            } catch (error) {
                console.error('국내창고 입고 오류:', error);
                this.$bvToast.toast(error.message || '입고 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            } finally {
                r.busy = false;
            }
        },
        // 입고승인 모달 열기
        openInboundModal(item) {
            this.inboundEditItem = item;
            this.inboundEditName = item.상품명 || '';
            this.inboundEditQty = parseInt(item.구매요청수량) || 1;
            this.showInboundModal = true;
        },
        // 입고 승인 처리
        async confirmInbound(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!this.inboundEditItem || this.inboundEditQty < 1) {
                this.$bvToast.toast('수량을 1 이상 입력해주세요.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            try {
                const payload = {
                    items: [{
                        reqpurchaseId: this.inboundEditItem._id,
                        barcode: this.inboundEditItem.바코드 || '',
                        상품명: this.inboundEditName,
                        수량: this.inboundEditQty,
                        SKUID: this.inboundEditItem.SKUID || '',
                        이미지: this.inboundEditItem.등록이미지 || '',
                        companyid: this.inboundEditItem.companyid || this.업체명
                    }]
                };
                const res = await axios.post('/api/inventory/confirmInbound', payload);
                if (res.data.요청결과 === '성공') {
                    // 입고대기 목록에서 제거
                    this.pendingInboundList = this.pendingInboundList.filter(p => p._id !== this.inboundEditItem._id);
                    this.$store.commit('REMOVE_PENDING_INBOUND', this.inboundEditItem._id);
                    // Inventory 목록 갱신
                    const invRes = await axios.post('/api/inventory/getList', { companyid: this.업체명 });
                    if (invRes.data.요청결과 === 'ok') {
                        this.inventoryList = invRes.data.items.map(e => this.processInventoryItem(e));
                        this.total = this.inventoryList.length;
                    }
                    this.showInboundModal = false;
                    this.$bvToast.toast('입고 승인이 완료되었습니다.', { title: '완료', variant: 'success', solid: true });
                } else {
                    this.$bvToast.toast(res.data.error || '입고 승인 실패', { title: '오류', variant: 'danger', solid: true });
                }
            } catch (error) {
                console.error('입고승인 오류:', error);
                this.$bvToast.toast('입고 승인 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            }
        },
        // === Phase 6-3: 수동입고 ===
        async searchBarcode() {
            const bc = (this.manualInbound.barcode || '').trim();
            if (!bc) return;
            try {
                const res = await axios.post('/api/inventory/searchByBarcode', { barcode: bc });
                if (res.data.요청결과 === 'ok' && res.data.product) {
                    this.manualInboundMatched = res.data.product;
                    this.manualInbound.상품명 = res.data.product.상품명 || '';
                } else {
                    this.manualInboundMatched = null;
                    this.$bvToast.toast('매칭되는 상품이 없습니다. 상품명을 직접 입력해주세요.', { title: '알림', variant: 'info', solid: true });
                }
            } catch (e) {
                console.error('바코드 검색 오류:', e);
            }
        },
        resetManualInbound() {
            this.manualInbound = { barcode: '', 상품명: '', 수량: 1, 사유: '직접입고', 메모: '' };
            this.manualInboundMatched = null;
        },
        async submitManualInbound(bvModalEvt) {
            bvModalEvt.preventDefault();
            const m = this.manualInbound;
            if (!m.상품명 || !m.수량 || m.수량 < 1) {
                this.$bvToast.toast('상품명과 수량(1 이상)은 필수입니다.', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            this.manualInboundProcessing = true;
            try {
                const res = await axios.post('/api/inventory/manualInbound', {
                    companyid: this.업체명, barcode: m.barcode, 상품명: m.상품명,
                    수량: m.수량, 사유: m.사유, 메모: m.메모
                });
                if (res.data.요청결과 === '성공') {
                    this.showManualInboundModal = false;
                    this.$bvToast.toast('수동 입고가 완료되었습니다.', { title: '완료', variant: 'success', solid: true });
                    await this.refreshInventoryList();
                } else {
                    this.$bvToast.toast(res.data.error || '입고 실패', { title: '오류', variant: 'danger', solid: true });
                }
            } catch (e) {
                console.error('수동입고 오류:', e);
                this.$bvToast.toast('수동 입고 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            } finally {
                this.manualInboundProcessing = false;
            }
        },
        // === Phase 6-3: 출고 ===
        openOutboundModal() {
            if (this.tableSelectedItem.length === 0) return;
            this.outboundItems = this.tableSelectedItem.map(item => ({
                ...item, outQty: 1, 사유: '직접출고', 메모: ''
            }));
            this.showOutboundModal = true;
        },
        async submitOutbound(bvModalEvt) {
            bvModalEvt.preventDefault();
            const invalid = this.outboundItems.filter(ob => !ob.outQty || ob.outQty < 1 || ob.outQty > ob.수량);
            if (invalid.length > 0) {
                this.$bvToast.toast('출고 수량을 확인해주세요. (1 이상, 현재 재고 이하)', { title: '알림', variant: 'warning', solid: true });
                return;
            }
            this.outboundProcessing = true;
            try {
                const res = await axios.post('/api/inventory/processOutbound', {
                    items: this.outboundItems.map(ob => ({
                        inventoryId: ob._id, 수량: ob.outQty, 사유: ob.사유, 메모: ob.메모
                    }))
                });
                if (res.data.요청결과 === '성공') {
                    this.showOutboundModal = false;
                    this.tableSelectedItem = [];
                    this.$bvToast.toast(`${res.data.successCount}건 출고 완료`, { title: '완료', variant: 'success', solid: true });
                    await this.refreshInventoryList();
                } else {
                    this.$bvToast.toast(res.data.error || '출고 실패', { title: '오류', variant: 'danger', solid: true });
                }
            } catch (e) {
                console.error('출고 오류:', e);
                this.$bvToast.toast('출고 처리 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            } finally {
                this.outboundProcessing = false;
            }
        },
        // === Phase 6-3: 재고수정 ===
        openAuditModal() {
            this.auditItems = this.inventoryList.map(item => ({
                ...item, 실사수량: null, 메모: ''
            }));
            this.showAuditModal = true;
        },
        async submitAudit(bvModalEvt) {
            bvModalEvt.preventDefault();
            const changed = this.auditItems.filter(a => a.실사수량 !== null && a.실사수량 !== a.수량);
            if (changed.length === 0) {
                this.$bvToast.toast('변경된 항목이 없습니다.', { title: '알림', variant: 'info', solid: true });
                return;
            }
            if (!confirm(`${changed.length}건의 재고 차이를 반영하시겠습니까?`)) return;
            this.auditProcessing = true;
            try {
                const res = await axios.post('/api/inventory/submitAudit', {
                    items: changed.map(a => ({ inventoryId: a._id, 실사수량: a.실사수량, 메모: a.메모 || '' }))
                });
                if (res.data.요청결과 === '성공') {
                    this.showAuditModal = false;
                    this.$bvToast.toast(`${res.data.successCount}건 수정 완료`, { title: '완료', variant: 'success', solid: true });
                    await this.refreshInventoryList();
                } else {
                    this.$bvToast.toast(res.data.error || '수정 실패', { title: '오류', variant: 'danger', solid: true });
                }
            } catch (e) {
                console.error('재고수정 오류:', e);
                this.$bvToast.toast('재고 수정 중 오류가 발생했습니다.', { title: '오류', variant: 'danger', solid: true });
            } finally {
                this.auditProcessing = false;
            }
        },
        // Inventory 목록 갱신 헬퍼
        async refreshInventoryList() {
            try {
                const res = await axios.post('/api/inventory/getList', { companyid: this.업체명 });
                if (res.data.요청결과 === 'ok') {
                    this.inventoryList = res.data.items.map(e => this.processInventoryItem(e));
                    this.total = this.inventoryList.length;
                }
            } catch (e) {
                console.error('Inventory 갱신 오류:', e);
            }
        },
        switchTab(tab) {
            this.activeTab = tab;
            this.tableSelectedItem = [];
            this.searchKeyword = '';
            if (tab === 'history') {
                // 입출고이력 탭: 기본 날짜 설정 후 자동 조회
                if (!this.historyStartDate) this.setHistoryRange('month');
                else this.loadHistoryData();
            } else {
                this.loadTabData(tab);
            }
        },
        // 입출고이력 날짜 범위 설정
        setHistoryRange(range) {
            const end = new Date();
            const start = new Date();
            if (range === 'week') start.setDate(start.getDate() - 7);
            else if (range === 'month') start.setMonth(start.getMonth() - 1);
            else if (range === '3month') start.setMonth(start.getMonth() - 3);
            this.historyStartDate = start.toISOString().split('T')[0];
            this.historyEndDate = end.toISOString().split('T')[0];
            this.loadHistoryData();
        },
        // 입출고이력 데이터 조회 (Inventory 기반)
        async loadHistoryData() {
            this.historyLoading = true;
            try {
                const res = await axios.post('/api/inventory/getHistory', {
                    companyid: this.업체명,
                    startDate: this.historyStartDate,
                    endDate: this.historyEndDate
                });
                if (res.data.요청결과 === 'ok') {
                    this.historyList = res.data.history;
                    this.calcHistorySummary();
                }
            } catch (e) {
                console.error('입출고이력 조회 오류:', e);
            } finally {
                this.historyLoading = false;
            }
        },
        // 수불부 요약 계산 (Inventory 입출고이력 기반)
        calcHistorySummary() {
            let incoming = 0;
            let outgoing = 0;
            this.historyList.forEach(h => {
                const qty = parseInt(h.changeQty) || 0;
                if (h.type === '입고') {
                    incoming += qty;
                } else if (h.type === '출고') {
                    outgoing += qty;
                }
                // 실사조정은 양수면 입고, 음수면 출고로 처리
                if (h.type === '실사조정') {
                    if (qty > 0) incoming += qty;
                    else outgoing += Math.abs(qty);
                }
            });
            const currentStock = this.inventoryList.reduce((sum, item) => sum + (parseInt(item.수량) || 0), 0);
            this.historySummary = {
                opening: currentStock - incoming + outgoing,
                incoming,
                outgoing,
                closing: currentStock
            };
        },
        // 입출고 구분 라벨 (Inventory type 기반)
        getHistoryTypeLabel(type) {
            if (type === '입고') return '입고';
            if (type === '출고') return '출고';
            if (type === '실사조정') return '수정';
            return type || '-';
        },
        // 입출고 구분 뱃지 클래스 (Inventory type 기반)
        getHistoryTypeBadge(type) {
            if (type === '입고') return 'badge badge-success';
            if (type === '출고') return 'badge badge-danger';
            if (type === '실사조정') return 'badge badge-warning';
            return 'badge badge-secondary';
        },
        getdate(timestamp) {
            var date = new Date(timestamp);
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        changedate() {
            var now
            var target
            if (this.selectdate == 'today') {
                this.startdate = this.getTodaywith();
                this.enddate = this.getTodaywith();
            } else {
                if (this.selectdate == 'week') {
                    now = new Date(this.getTodaywith());
                    target = now - 1000 * 60 * 60 * 24 * 7

                    this.startdate = this.getdate(target);
                    this.enddate = this.getTodaywith();
                } else {
                    if (this.selectdate == 'month') {
                        now = new Date(this.getTodaywith());
                        target = now - 1000 * 60 * 60 * 24 * 30
                        this.startdate = this.getdate(target);
                        this.enddate = this.getTodaywith();
                    }
                }
            }
        },
        allcheck() {
            if (this.allcheckreqlists) {
                this.reqlists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.reqlists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        confirmlists() {
            var arr = [];
            if (this.lists.filter(e => e.checked).length == 0) {
                arr = this.lists
            } else {
                arr = this.lists.filter(e => e.checked)
            }
            if (arr.filter(e => e.구매링크 === undefined).length > 0) {
                alert('구매링크를 모두 입력해 주세요')
                return
            }
            if (arr.filter(e => e.옵션1_중국어 === undefined || e.옵션2_중국어 === undefined).length > 0) {
                alert('돋보기를 눌러 옵션을 모두 매칭해 주세요.')
                return []
            }
            return arr
        },
        async requestpurchase() {
            var list = await this.confirmlists()
            if (list.length == 0) {
                alert('요청할 목록이 없습니다.')
                return
            }
            var cnt = list.length;
            var arr = [];
            var obj = {};
            var now = Date.now();
            list.forEach(e => {
                obj = {
                    companyid: this.$store.state.user.companyid,
                    요청일: now,
                    SKUID: parseInt(e.SKUID),
                    바코드: e.바코드,
                    상품명: e.상품명,
                    구매링크: e.구매링크,
                    옵션1_중국어: e.옵션1_중국어,
                    옵션2_중국어: e.옵션2_중국어,
                    구매요청수량: e.구매요청수량,
                    등록이미지: e.등록이미지,
                }
                arr.push(obj);
            })
            if (confirm("총 " + cnt + "건을 구매대행 요청하시겠습니까?")) {
                axios.post('/api/reqpurchase/requestpurchase', arr)
                    .then((res) => {
                        this.$store.commit('reqpurchaseupdate', res.data.reqpurchase);
                        alert(res.data.요청결과)
                    })
                    .catch(console.log)
            }
        },
        async saveproductdb() {
            var list = await this.confirmlists()
            if (list.length == 0) {
                alert('업데이트할 목록이 없습니다.')
                return
            }
            console.log(list)
            axios.post('/api/reqpurchase/updateproductdb', list)
                .then((res) => {
                    this.$store.commit('productdbupdate', res.data.productdb);
                    alert(res.data.요청결과)
                })
                .catch(console.log)
        },
        deleteindexfromarray(array, index) {
            return array.slice(0, index).concat(array.slice(index + 1))
        },
        deleteitem(index) {
            if (confirm('삭제된 제품은 복구가 불가능합니다. 삭제하시겠습니까?')) {
                this.showlist = false;
                setTimeout(() => {
                    this.lists = this.deleteindexfromarray(this.lists, index);
                    this.showlist = true;
                }, 1);
            }
        },
        confirmexcelDownFunc() {
            if (this.reqtype == '로켓배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '제트배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '일반LCL') {
                if (confirm('일반LCL에서 SKUID는 10000000 이하의 숫자로 임의로 기입하시면 됩니다.')) {
                    this.excelDownFunc()
                    return
                }
            }
        },
        reset(list) {
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            list.구매링크 = undefined;
        },
        rematching(list) {
            this.change = true;
            const selectedIndex = this.reqlists.findIndex(i => i._id === list._id);
            this.changeindexlist.push(selectedIndex);
            if (!list.구매링크) {
                alert('구매링크를 입력해 주세요')
                return
            }
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            this.matchoption1(selectedIndex, list.구매링크)
        },
        fileupload() {
            this.$refs.pdbupload.value = '';
            this.$refs.pdbupload.click();
        },
        option1matching(a, list) {
            this.change = true;
            // this.showlist = false;
            if (a.imageUrl) {
                if (!list.등록이미지) {
                    list.등록이미지 = a.imageUrl;
                }
                list.옵션이미지 = a.imageUrl;
            }
            list.옵션1_중국어 = a.name;


            // if(this.checkstock){
            if (list.옵션2_중국어 == '') {
                var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1).quantity);
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                }
                list.매칭상태 = '매칭완료';
            } else {
                if (list.옵션2_중국어 !== undefined) {
                    properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                    var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                    list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                    if (list.구매재고 == 0) {
                        alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                    } else {
                        alert('구매 가능한 재고수량 : ' + list.구매재고)
                    }
                    list.매칭상태 = '매칭완료';
                }
            }
            if (list.등록이미지 == '' && list.옵션이미지 == '') {
                list.등록이미지 = list.item.pic_url;
                list.옵션이미지 = list.item.pic_url;
            }
            // this.showlist = true;
            // }
            this.pricechange(list)
        },
        option2matching(a, list) {
            this.change = true;
            // this.showlist = false;
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
            }
            list.옵션2_중국어 = a.name;

            // if(this.checkstock){

            if (list.상품매칭.옵션1_중국어 && list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어)) {
                var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                }
                list.매칭상태 = '매칭완료'
            }

            // }
            if (list.등록이미지 == '' && list.옵션이미지 == '') {
                list.등록이미지 = list.item.pic_url;
                list.옵션이미지 = list.item.pic_url;
            }
            // this.showlist = true;
            this.pricechange(list)
        },
        sendmessage(url) {
            window.postMessage({ greeting: "importproductinfo", url: url }, "*",)
        },
        async matchoption1(index, 구매링크) {
            this.reqlists[index].showspinner = true;
            this.reqlists[index].구매링크 = 구매링크;
            this.currentindex = index;
            console.log(구매링크)
            // setTimeout(() => {this.sendmessage(구매링크);},1)
            var newObj = await this.confirmreq(this.reqlists[index]);
            // console.log(newObj)
            // this.showlist = false
            this.reqlists[index] = newObj;
            console.log(this.reqlists[this.currentindex])
            // this.showlist = true


            // axios.post('/api/reqpurchase/geturlinfo',{
            //     url : 구매링크
            // })
            // .then((res) => {
            //     if(res.data.요청결과 == 'success'){
            //         console.log(res.data.result)
            //         var obj = {}
            //         res.data.result.option1array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })
            //         res.data.result.option2array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })

            //     } else {
            //         alert('error777 :' + res.data.요청결과)
            //     }
            // })
            // .catch(console.log)
        },
        nopo(구매링크) {
            this.reqlists.forEach((obj, i) => {
                if (obj.구매링크 == 구매링크) {
                    obj.상품매칭.옵션1_중국어 = [];
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션1_중국어 = '';
                    obj.옵션2_중국어 = '';
                    obj.구매재고 = '구매불가';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : '';
                    obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : '';
                    obj.매칭상태 = '매칭필요';
                    obj.showspinner = false;
                    this.changeindexlist.push(i)
                }
            })
        },
        async confirmreq(obj) {
            if (!obj.구매링크 || obj.구매링크 == '사입') {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            console.log(item)
            obj.item = item;

            if (item.format_check == 'fail') {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = '구매불가';
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.pic_url;
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.pic_url;
                obj.매칭상태 = '매칭필요';
                obj.showspinner = false;
                if (confirm('해당제품은 구매불가입니다. 같은 링크를 모두 구매불가 처리하시겠습니까?')) {
                    this.nopo(obj.구매링크);
                }
                return obj
            }

            var option1array = [];
            var option2array = [];
            if (item.props_list && Object.keys(item.props_list).length > 0) {
                item.skus.sku.forEach(e => {
                    if (e.properties.includes(";")) {
                        var properties1 = e.properties.split(';')[0];
                        var properties2 = e.properties.split(';')[1];
                        if (!option1array.find(ele => ele.properties == properties1)) {
                            option1array.push({
                                properties: properties1,
                                name: e.properties_name.split(";" + properties2 + ':')[0].replace(properties1 + ":", ""),
                                imageUrl: item.props_img[properties1] ? item.props_img[properties1] : '',
                            })
                        }
                        if (!option2array.find(ele => ele.properties == properties2)) {
                            option2array.push({
                                properties: properties2,
                                name: e.properties_name.split(";" + properties2 + ':')[1],
                                imageUrl: item.props_img[properties2] ? item.props_img[properties2] : '',
                            })
                        }
                    } else {
                        option1array.push({
                            properties: e.properties,
                            name: e.properties_name.replace(e.properties + ":", ""),
                            imageUrl: item.props_img[e.properties] ? item.props_img[e.properties] : '',
                        })
                    }
                })

                // Object.keys(item.props_list).forEach(e => {
                //     if(e[0] == '0'){
                //         option1array.push({
                //             properties : e,
                //             name : item.props_list[e].split(":")[1],
                //             imageUrl : item.props_img[e] ? item.props_img[e] : '',
                //         })
                //     }
                //     if(e[0] == '1'){
                //         option2array.push({
                //             properties : e,
                //             name : item.props_list[e].split(":")[1],
                //             imageUrl : item.props_img[e] ? item.props_img[e] : '',
                //         })
                //     }
                // })
            }

            if (option1array.length == 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = parseInt(item.num);
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.pic_url;
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.pic_url;
                obj.매칭상태 = '매칭완료'
            } else {
                if (option2array.length == 0) {
                    var imgUrl = '';
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                        obj.구매재고 = parseInt(item.skus.sku.find(e => e.properties == option1properties).quantity);
                        if (item.prop_imgs.prop_img.length > 0) {
                            imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option1properties).url;
                        }
                        obj.옵션이미지 = imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    imgUrl = '';
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                        if (item.prop_imgs.prop_img && item.prop_imgs.prop_img.find(e => e.properties == option1properties)) {
                            imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option1properties).url;
                        }
                        obj.옵션이미지 = imgUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                            obj.구매재고 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).quantity);
                            if (item.prop_imgs.prop_img && item.prop_imgs.prop_img.find(e => e.properties == option2properties)) {
                                imgUrl = item.prop_imgs.prop_img.find(e => e.properties == option2properties).url;
                            }
                            obj.옵션이미지 = imgUrl;
                            obj.매칭상태 = '매칭완료'
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }
            }
            if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                obj.등록이미지 = item.pic_url;
            }
            this.pricechange(obj);
            obj.showspinner = false;
            return obj
        },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            console.log(productNo)
            try {
                var res = await axios.post('/api/reqpurchase/getProductInfo', [productNo])
                return res.data.result[0].item
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },
        pricechange(obj) {
            this.change = true;
            if (obj.매칭상태 == '매칭필요') {
                obj.구매가격 = '';
                return
            }
            if (obj.item && obj.구매요청수량) {
                var option1array = [];
                var option2array = [];
                var item = obj.item;
                if (item.props_list && Object.keys(item.props_list).length > 0) {
                    Object.keys(item.props_list).forEach(e => {
                        if (e[0] == '0') {
                            option1array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                        if (e[0] == '1') {
                            option2array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                    })
                }

                if (option1array.length == 0) {
                    if (item.priceRange) {
                        for (var i = 0; i < item.priceRange.length; i++) {
                            obj.구매가격 = parseFloat(item.priceRange[i][1]);
                            if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                break
                            }
                        }
                    } else {
                        obj.구매가격 = parseInt(item.price);
                    }
                } else {
                    if (option2array.length == 0) {
                        if (item.priceRange) {
                            for (i = 0; i < item.priceRange.length; i++) {
                                obj.구매가격 = parseFloat(item.priceRange[i][1]);
                                if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                    break
                                }
                            }
                        } else {
                            obj.구매가격 = parseInt(item.price);
                        }
                    } else {
                        if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                            obj.구매가격 = '';
                        } else {
                            if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                                obj.구매가격 = '';
                            } else {
                                var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                                var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                                obj.구매가격 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).price);
                            }
                        }
                    }
                }
            }
        },
        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        excelDownFunc() {
            var arr = [];
            var myHeader = ["SKUID", "구매요청수량"];

            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '구매대행요청양식');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, '구매대행요청양식.xlsx');
        },
        // uploadfile(event) {
        //     var obj = {};
        //     var ob = {};
        //     var op1 = '';
        //     var op2 = '';
        //     this.showlist = false;
        //     this.lists = [];
        //     // var 주문번호,판매처,배송단가,할인단가,운송장번호,주문날짜,주문상태;
        //     setTimeout(() => {
        //         const file = event.target.files[0];
        //         let reader = new FileReader();
        //         reader.onload = (e) => {
        //             // let data = reader.result;
        //             let data = e.target.result;
        //             let workbook = XLSX.read(data, {type: 'binary'});
        //             workbook.SheetNames.forEach(sheetName => {
        //                 const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        //                 console.log(roa)
        //                 if(this.reqtype == '일반LCL'){
        //                     roa.forEach(e => {
        //                         if(this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))){
        //                             ob = this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))
        //                             // console.log(e)
        //                             // console.log(ob)
        //                             if(ob.옵션1_중국어 || ob.옵션1_중국어 == ''){
        //                                 op1 = ob.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(ob.옵션2_중국어 || ob.옵션2_중국어 == ''){
        //                                 op2 = ob.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : ob.바코드 ? ob.바코드 : '',
        //                                 상품명 : ob.상품명,
        //                                 구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : ob.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : ob.등록이미지
        //                             }
        //                             this.lists.push(obj)
        //                         } else {
        //                             if(e.옵션1_중국어 || e.옵션1_중국어 == ''){
        //                                 op1 = e.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(e.옵션2_중국어 || e.옵션2_중국어 == ''){
        //                                 op2 = e.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : e.바코드 ? e.바코드 : '',
        //                                 상품명 : e.상품명,
        //                                 구매링크 : e.구매링크 ? e.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : e.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : e.등록이미지
        //                             }
        //                             this.lists.push(obj)
        //                         }
        //                     })
        //                 } else {
        //                     roa.forEach(e => {
        //                         if(this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))){
        //                             ob = this.$store.state.productdb.find(ele => parseInt(ele['SKU ID']) == parseInt(e.SKUID))
        //                             // console.log(e)
        //                             // console.log(ob)
        //                             if(ob.옵션1_중국어 || ob.옵션1_중국어 == ''){
        //                                 op1 = ob.옵션1_중국어
        //                             } else {
        //                                 op1 = undefined
        //                             }
        //                             if(ob.옵션2_중국어 || ob.옵션2_중국어 == ''){
        //                                 op2 = ob.옵션2_중국어
        //                             } else {
        //                                 op2 = undefined
        //                             }
        //                             obj = {
        //                                 checked : false,
        //                                 showspinner : false,
        //                                 SKUID : e.SKUID,
        //                                 바코드 : ob.바코드,
        //                                 상품명 : ob.상품명,
        //                                 구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
        //                                 옵션1_중국어 : op1,
        //                                 옵션2_중국어 : op2,
        //                                 매칭상태 : ob.구매링크 !== undefined || op1 !== undefined || op2 !== undefined ? '매칭완료' : '매칭필요',
        //                                 상품매칭 : {
        //                                     옵션1_중국어 : [],
        //                                     옵션2_중국어 : [],
        //                                 },
        //                                 구매요청수량 : e.구매요청수량,
        //                                 등록이미지 : ob.등록이미지
        //                             }
        //                             // console.log(obj)
        //                             this.lists.push(obj)
        //                         } else {
        //                             alert('로켓/제트 상품은 상품DB를 먼저 등록해주세요')
        //                             return
        //                         }
        //                     })
        //                 }
        //                 this.showlist = true;
        //             });
        //         };
        //         reader.readAsBinaryString(file);
        //     }, 10);
        // },
        modalID(index) {
            // console.log(index);
            return 'modal' + index
        },

        deepClone(obj) {
            if (obj === null || typeof obj !== "object") {
                return obj
            }

            const result = Array.isArray(obj) ? [] : {}

            for (let key of Object.keys(obj)) {
                result[key] = this.deepClone(obj[key])
            }

            return result
        },
        deletelist(index) {
            var newarr = [];
            var delarr = [];
            this.reqlists.forEach((e, i) => {
                if (i != index) {
                    newarr.push(this.deepClone(e))
                } else {
                    delarr.push(this.deepClone(e))
                }
            })
            this.reqlists = newarr;
            if (confirm('삭제 후에는 복구가 불가능합니다. 그래도 삭제하시겠습니까?')) {
                this.deletereqlists(delarr);
            }
        },
        async deletereqlists(delarr) {
            axios.post('/api/reqpurchase/deletereqpurchase', delarr)
                .then((res) => {
                    if (res.data.요청결과 == '삭제완료') {
                        alert(res.data.요청결과)
                    } else {
                        alert(res.data.요청결과)
                        console.log(res.data)
                    }
                })
                .catch(console.log)
        },
        deletedetail(발주번호, SKUID) {
            var newarr = [];
            var newobj = {};
            this.lists.forEach(e => {
                if (e.발주번호 != 발주번호) {
                    newarr.push(e);
                } else {
                    newobj = this.deepClone(e);
                    newobj.발주세부내역 = [];
                    e.발주세부내역.forEach(ele => {
                        if (ele.SKUID != SKUID) {
                            newobj.발주세부내역.push(ele);
                        }
                    });
                    newarr.push(newobj);
                }
            })
            this.lists = newarr;
        },
        allchecklist(allchecked) {
            if (allchecked == true) {
                this.lists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.lists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        allcheckdetaillist(allcheckdetail) {
            if (allcheckdetail == true) {
                this.detaillists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.detaillists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        getToday() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + month + day;
        },
        timestamp(date) {
            //inputdate = "yyyy-mm-dd"
            return new Date(date).getTime() / 1000
        },
        gettimestamp(date) {
            return new Date(date).getTime()
        },
        downloadlist() {
            var arr = [];
            this.reqlists.forEach(e => {
                var customsType = e.요청내역.customsType == 'integrated' ? '통합통관' : e.요청내역.customsType == 'client' ? '화주단독통관' : e.요청내역.customsType == 'kupass' ? '쿠패스단독통관' : ''
                arr.push({
                    업체명: e.companyid,
                    요청일: this.getdate(e.요청일),
                    상품명: e.상품명,
                    SKUID: e.SKUID,
                    바코드: e.바코드,
                    구매요청수량: parseInt(e.구매요청수량),
                    판매구성수량: parseInt(e.판매구성수량),
                    구매링크: e.구매링크,
                    옵션1_중국어: e.옵션1_중국어,
                    옵션2_중국어: e.옵션2_중국어,
                    배치발주번호: e.selectpo,
                    출고방법: e.요청내역.exportType,
                    목적지: e.요청내역.destination ? e.요청내역.destination : "coupang",
                    신고영문명: e.신고영문명,
                    신고가격: e.신고가격,
                    HSCODE: e.HSCODE,

                    "기본검수/분류/포장": e.요청내역.default,
                    바코드라벨: e.요청내역.barcode,

                    포장방법위임: e.요청내역.auto ? "O" : "",
                    LDPE: e.요청내역.LDPE ? "O" : "",
                    OPP: e.요청내역.OPP ? "O" : "",
                    재포장생략: (e.요청내역.auto == false && !e.요청내역.LDPE && !e.요청내역.OPP) ? "O" : "",

                    원산지스티커: e.요청내역.sticker ? "O" : "",
                    라벨봉제: e.요청내역.sewing ? "O" : "",
                    도장: e.요청내역.stamp ? "O" : "",
                    택총: e.요청내역.tag ? "O" : "",
                    에어캡포장: e.요청내역.airpacking ? "O" : "",
                    중국어마스킹: e.요청내역.masking ? "O" : "",

                    협의단가: e.협의단가,
                    총금액: e.요청내역.총금액,
                    협의ID: e.협의ID,

                    "기타요청사항(물류)": e.요청내역.reqcontent,
                    "기타요청사항(구매)": e.요청내역?.reqcontentPurchase || "",
                    이미지링크: e.등록이미지,
                    통관방법: customsType
                })
            })
            const workBook = XLSX.utils.book_new()
            const workSheet = XLSX.utils.json_to_sheet(arr)
            XLSX.utils.book_append_sheet(workBook, workSheet, '주문내역')
            XLSX.writeFile(workBook, '주문내역' + '_' + this.getToday() + '.xlsx')
        },
        downloadpo(arr) {
            if (arr.length > 0) {
                var createpo = [];
                var totalpo = arr;
                totalpo.forEach((e, i) => {
                    e.index = i;
                })
                //1688id순으로 정렬 (중국내배송비최소화)
                totalpo.sort(function (a, b) {
                    if (a['商品规格1（如：颜色）'] < b['商品规格1（如：颜色）']) {
                        return -1;
                    }
                    if (a['商品规格1（如：颜色）'] > b['商品规格1（如：颜色）']) {
                        return 1;
                    }
                    return 0;
                })
                totalpo.sort(function (a, b) {
                    if (a['商品规格2（如：尺码）'] < b['商品规格2（如：尺码）']) {
                        return -1;
                    }
                    if (a['商品规格2（如：尺码）'] > b['商品规格2（如：尺码）']) {
                        return 1;
                    }
                    return 0;
                })
                totalpo.sort(function (a, b) {
                    if (a['商品名称'] < b['商品名称']) {
                        return -1;
                    }
                    if (a['商品名称'] > b['商品名称']) {
                        return 1;
                    }
                    return 0;
                })
                totalpo.sort(function (a, b) {
                    if (a['1688商品链接/1688商品id'] < b['1688商品链接/1688商品id']) {
                        return -1;
                    }
                    if (a['1688商品链接/1688商品id'] > b['1688商品链接/1688商品id']) {
                        return 1;
                    }
                    return 0;
                })

                //동일제품 1688주문번호에 구분번호추가 (발주번호 구분)
                var ct = 1;

                for (var i = 1; i < totalpo.length; i++) {
                    if (
                        ((totalpo[i]['商品规格1（如：颜色）'] && totalpo[i - 1]['商品规格1（如：颜色）']) ? (totalpo[i]['商品规格1（如：颜色）'] == totalpo[i - 1]['商品规格1（如：颜色）']) : true) &&
                        ((totalpo[i]['商品规格2（如：尺码）'] && totalpo[i - 1]['商品规格2（如：尺码）']) ? (totalpo[i]['商品规格2（如：尺码）'] == totalpo[i - 1]['商品规格2（如：尺码）']) : true) &&
                        (totalpo[i]['商品名称'] == totalpo[i - 1]['商品名称']) &&
                        (totalpo[i]['1688商品链接/1688商品id'] == totalpo[i - 1]['1688商品链接/1688商品id'])
                    ) {
                        totalpo[i]['订单号'] += ct.toString();
                        ct++
                    } else {
                        ct = 1;
                    }
                }

                totalpo.sort(function (a, b) {
                    if (a.index < b.index) {
                        return -1;
                    }
                    if (a.index > b.index) {
                        return 1;
                    }
                    return 0;
                })

                totalpo.sort(function (a, b) {
                    if (a['1688商品链接/1688商品id'] < b['1688商品链接/1688商品id']) {
                        return -1;
                    }
                    if (a['1688商品链接/1688商品id'] > b['1688商品链接/1688商品id']) {
                        return 1;
                    }
                    return 0;
                })

                totalpo.sort(function (a, b) {
                    if (a['订单号'] < b['订单号']) {
                        return -1;
                    }
                    if (a['订单号'] > b['订单号']) {
                        return 1;
                    }
                    return 0;
                })


                //1688id순으로 정렬 (중국내배송비최소화)
                // totalpo.sort(function(a,b){
                //     if (a.판매처 < b.판매처){
                //         return -1;
                //     }
                //     if (a.판매처 > b.판매처){
                //         return 1;
                //     }
                //     return 0;
                // })


                //1688po를 100개씩 잘라서 createpo array에 저장
                console.log(totalpo)
                var j
                var cnt = totalpo.length;

                for (j = 0; j < cnt; j++) {
                    if (totalpo.length < 100) {
                        createpo.push(totalpo)
                        break
                    }
                    for (i = 100; i > 0; i--) {
                        if (totalpo[i][['1688商品链接/1688商品id']] != totalpo[i - 1][['1688商品链接/1688商品id']]) {
                            console.log(totalpo.slice(0, i))
                            createpo.push(totalpo.slice(0, i))
                            totalpo = totalpo.slice(i, totalpo.length)
                            console.log(totalpo)
                            break
                        } else {
                            if (i == 1) {
                                createpo.push(totalpo.slice(0, 100))
                                totalpo = totalpo.slice(100, totalpo.length)
                            }
                        }
                    }
                }

                //test
                // const workBook = XLSX.utils.book_new()
                // const workSheet1 = XLSX.utils.json_to_sheet(totalpo)
                // const workSheet2 = XLSX.utils.json_to_sheet(matchpo)
                // XLSX.utils.book_append_sheet(workBook, workSheet1, '1688주문서')
                // XLSX.utils.book_append_sheet(workBook, workSheet2, 'matching')
                // XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '.xlsx')


                //다운로드
                for (i = 0; i < createpo.length; i++) {
                    const workBook = XLSX.utils.book_new()
                    const workSheet = XLSX.utils.json_to_sheet(createpo[i])
                    XLSX.utils.book_append_sheet(workBook, workSheet, '1688주문서')
                    XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '_' + i.toString() + '.xlsx')
                }
            } else {
                alert('생성할 주문서가 없습니다.')
            }
        },

        savesetting() {
            var payload = {
                companyid: this.$store.state.user.companyid,
                CreatePo_수취인: this.CreatePo_수취인,
                CreatePo_연락처: this.CreatePo_연락처,
                CreatePo_주소_성: this.CreatePo_주소_성,
                CreatePo_주소_시: this.CreatePo_주소_시,
                CreatePo_주소_구: this.CreatePo_주소_구,
                CreatePo_상세주소: this.CreatePo_상세주소,
                CreatePo_주문번호: this.CreatePo_주문번호,
                CreatePo_발주기준일: this.CreatePo_발주기준일
            };

            this.$store.commit('settingsupdate', payload)
            axios.post('/api/addpurchase/addsettings', payload)
                .then((res) => { alert(res.data.요청결과) })
        },
        importcompanyids() {
            axios.post('/api/getcompanyids', {})
                .then(result => {
                    if (result.data.요청결과 == 'success') {
                        result.data.result.forEach(e => {
                            if (e.auth.showimport) {
                                if (!this.companyids.includes(e.companyid)) {
                                    this.companyids.push(e.companyid);
                                }
                            }
                        })
                        console.log(this.companyids)
                    } else {
                        alert(result.data.사유)
                    }
                }).catch((e) => {
                    alert('companyid 가져오기 실패 (1413)')
                    console.log(e);
                    return true
                })
        },
        getChangeHistoryTooltip(item) {
            if (!item.changeHistory || item.changeHistory.length === 0) return '';

            return item.changeHistory.map(change => {
                const date = new Date(change.changeDate).toLocaleDateString();
                const changesList = Object.entries(change.changes)
                    .map(([key, value]) => {
                        return `${key}: ${value.변경전} → ${value.변경후}`;
                    })
                    .join('<br>');

                return `
                    <div class="p-1">
                        <strong>${date}</strong> (${change.changedBy})<br>
                        ${changesList}
                    </div>
                `;
            }).join('<hr class="my-1">');
        },
        importtextchange(event) {
            this.importtext = 'Connect';
            if (event.keyCode === 13 && this.업체명 != '') {
                this.importcompanyinfo()
            }
        },
        // 단일 요청 로드 메서드 추가
        async loadSingleRequest(requestId) {
            try {
                console.log('loadSingleRequest 시작 - requestId:', requestId);
                this.showspinner = true
                this.showreqlist = false

                // 서버에 단일 요청 조회 API 호출
                console.log('API 호출 전 - /api/reqpurchase/getrequest');
                const response = await axios.post('/api/reqpurchase/getrequest', { requestId })
                console.log('API 응답 받음:', response.data);

                if (response.data.success && response.data.request) {
                    console.log('요청 데이터 찾음');
                    const request = response.data.request

                    // 데이터 가공
                    request.요청내역 = request.요청내역 || {}
                    const customsType = request.요청내역.customsType == 'integrated' ? '통합통관' :
                                       request.요청내역.customsType == 'client' ? '화주단독통관' :
                                       request.요청내역.customsType == 'kupass' ? '쿠패스단독통관' : ''

                    request.통관방법 = customsType
                    request.요청내역.reqcontentPurchase = request.요청내역?.reqcontentPurchase || ""
                    request.요청변경 = request.changeHistory && request.changeHistory.length > 0 ? true : false
                    request.processStatus = request.processStatus || '구매전'
                    request.구매취소 = request.구매취소 ? request.구매취소 : false
                    request.구매취소내용 = request.구매취소내용 ? request.구매취소내용 : ''
                    request.판매구성수량 = request.판매구성수량 == '단품' ? 1 : request.판매구성수량
                    request.주문번호 = request.주문정보 ? request.주문정보.주문번호 : ""
                    request.processHistory = request.processHistory || [];

                    request.checked = false

                    // 리스트에 추가
                    const processed = this.processItem(request);
                    this.reqlists = [processed];
                    this.reqlistsinit = [processed];

                    this.total = 1
                    this.showreqlist = true
                } else {
                    alert('요청을 찾을 수 없습니다.')
                    // 요청을 찾을 수 없으면 일반 검색 실행
                    this.search()
                }
            } catch (error) {
                console.error('단일 요청 로드 오류:', error)
                alert('요청을 로드하는 중 오류가 발생했습니다.')
                this.search()
            } finally {
                this.showspinner = false
            }
        },

        // 일괄처리 관련 메서드들
        async updateBatchStatus() {
            if (!this.batchStatus || this.tableSelectedItem.length === 0) {
                alert('상태를 선택하고 항목을 선택해주세요.');
                return;
            }

            if (!confirm(`선택된 ${this.tableSelectedItem.length}개 항목의 상태를 '${this.batchStatus}'로 변경하시겠습니까?`)) {
                return;
            }

            this.batchProcessing = true;

            try {
                const ids = this.tableSelectedItem.map(item => item._id);
                await axios.post('/api/reqpurchase/updateProcessStatusBulk', {
                    ids: ids,
                    toStatus: this.batchStatus,
                    memo: '재고관리 일괄변경'
                });

                // 선택 해제 및 상태 초기화
                this.tableSelectedItem = [];
                this.batchStatus = '';
                this.showBatchChange = false;

                this.$bvToast.toast(`${ids.length}개 항목의 상태가 변경되었습니다.`, { title: '완료', variant: 'success', solid: true });
                this.search();
            } catch (error) {
                console.error('일괄 상태 변경 오류:', error);
                alert('일괄 상태 변경 중 오류가 발생했습니다.');
            } finally {
                this.batchProcessing = false;
            }
        },

        // 위치 설정 실행
        async executeBatchLocationChange() {
            if (!this.batchLocationWarehouse || !this.batchLocationArea || !this.batchLocationLevel) {
                alert('창고, 구역, 층을 모두 선택해주세요.');
                return;
            }

            if (this.tableSelectedItem.length === 0) {
                alert('위치를 설정할 항목을 선택해주세요.');
                return;
            }

            const confirmMessage = `선택된 ${this.tableSelectedItem.length}개 항목의 위치를 "${this.batchLocationWarehouse} > ${this.batchLocationArea} > ${this.batchLocationLevel}"로 설정하시겠습니까?`;
            if (!confirm(confirmMessage)) {
                return;
            }

            this.batchLocationProcessing = true;
            const selectedCount = this.tableSelectedItem.length;
            const locationInfo = {
                창고: this.batchLocationWarehouse,
                구역: this.batchLocationArea,
                층: this.batchLocationLevel
            };

            try {
                if (this.activeTab === 'domestic') {
                    // 국내재고: Inventory API 사용
                    const inventoryIds = this.tableSelectedItem.map(item => item._id);
                    await axios.post('/api/inventory/updateLocation', { inventoryIds, 위치정보: locationInfo });
                    // 로컬 데이터 즉시 반영
                    this.tableSelectedItem.forEach(item => { item.위치정보 = { ...locationInfo }; });
                } else {
                    // 해외재고: 기존 Reqpurchase 방식
                    const changedBy = this.$store.state.settings[0].userid || 'system';
                    const currentTime = new Date().toISOString();
                    this.tableSelectedItem.forEach(item => { item.위치정보 = { ...locationInfo }; });
                    const historyPromises = this.tableSelectedItem.map(item =>
                        this.updateItemLocationWithHistory(item._id, locationInfo, changedBy, currentTime)
                    );
                    await Promise.all(historyPromises);
                    await this.updatereqlist(this.tableSelectedItem);
                    this.tableSelectedItem.forEach(selectedItem => {
                        const originalItem = this.reqlistsinit.find(item => item._id === selectedItem._id);
                        if (originalItem) originalItem.위치정보 = { ...locationInfo };
                    });
                }

                // 선택 해제 및 상태 초기화
                this.tableSelectedItem = [];
                this.batchLocationWarehouse = '';
                this.batchLocationArea = '';
                this.batchLocationLevel = '';
                this.showLocationChange = false;
                alert(`${selectedCount}개 항목의 위치가 성공적으로 설정되었습니다.`);
                this.search();
            } catch (error) {
                console.error('일괄 위치 설정 오류:', error);
                alert('일괄 위치 설정 중 오류가 발생했습니다.');
            } finally {
                this.batchLocationProcessing = false;
            }
        },

        // 페이지 로드 시 창고 정보 자동 로드
        async loadWarehousesOnMount() {
            try {
                console.log('페이지 로드 시 창고 정보 자동 로드 시작');

                const response = await axios.post('/api/warehouses/load', {
                    companyid: this.$store.state.settings[0].companyid
                });

                if (response.data.success) {
                    this.warehouses = response.data.data.warehouses;
                    console.log('자동 로드된 창고 목록:', this.warehouses);

                    // 창고가 있으면 첫 번째 창고를 기본 선택
                    if (this.warehouses.length > 0 && !this.currentWarehouseId) {
                        this.currentWarehouseId = this.warehouses[0].id;
                        console.log('기본 창고 선택:', this.warehouses[0].name);
                        // H-2: 첫 번째 창고의 레이아웃(storageAreas)도 함께 로드 → 위치설정 드롭다운 정상 작동
                        await this.loadStorageAreasForDropdown(this.warehouses[0].id);
                    }
                } else {
                    console.log('저장된 창고가 없습니다.');
                    this.warehouses = [];
                }
            } catch (error) {
                console.error('창고 정보 자동 로드 오류:', error);
                this.warehouses = [];
            }
        },

        // H-2: 위치설정 드롭다운용 storageAreas 로드 (모달 열지 않아도 동작)
        async loadStorageAreasForDropdown(warehouseId) {
            try {
                const response = await axios.post('/api/warehouse-layout/load', {
                    companyid: this.$store.state.settings[0].companyid,
                    warehouseId: warehouseId
                });
                if (response.data.success && response.data.data) {
                    this.storageAreas = (response.data.data.storageAreas || []).map(area => ({
                        ...area,
                        fabricObject: null,
                        textObject: null,
                        levelTextObject: null
                    }));
                    console.log('드롭다운용 storageAreas 로드 완료:', this.storageAreas.length, '개');
                }
            } catch (error) {
                console.error('storageAreas 로드 오류:', error);
            }
        },

        async updateItemStatusWithHistory(itemId, newStatus, previousStatus, changedBy, changeDate) {
            const response = await axios.post('/api/updateReqPurchaseStatusWithHistory', {
                itemId: itemId,
                newStatus: newStatus,
                previousStatus: previousStatus,
                changedBy: changedBy,
                changeDate: changeDate,
                companyid: this.$store.state.companyid
            });
            return response.data;
        },

        // 위치 설정 히스토리 추가
        async updateItemLocationWithHistory(itemId, locationInfo, changedBy, changeDate) {
            const locationText = `${locationInfo.창고} > ${locationInfo.구역} > ${locationInfo.층}`;

            const response = await axios.post('/api/updateReqPurchaseLocationWithHistory', {
                itemId: itemId,
                locationInfo: locationInfo,
                locationText: locationText,
                changedBy: changedBy,
                changeDate: changeDate,
                companyid: this.$store.state.companyid
            });
            return response.data;
        },

        getStatusHistoryTooltip(item) {
            if (!item.statusHistory || item.statusHistory.length === 0) return '';

            return item.statusHistory.map(history => {
                const date = new Date(history.changeDate).toLocaleString('ko-KR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });

                return `
                    <div class="p-1">
                        <strong>변경일:</strong> ${date}<br>
                        <strong>변경자:</strong> ${history.changedBy}<br>
                        <strong>변경상태:</strong> ${history.previousStatus} → ${history.newStatus}
                    </div>
                `;
            }).join('<hr style="margin: 5px 0;">');
        },




        // === 새로운 구조의 메서드들 ===

        // 1단계: 창고 관리
        async openWarehouseModal() {
            // 창고 정보 확인 (필요시에만 로드)
            await this.loadWarehouses();

            this.$bvModal.show('warehouseModal');

            // 모달이 완전히 열린 후 캔버스 초기화
            setTimeout(async () => {
                this.initWarehouseCanvas();

                // 캔버스 초기화 완료 대기
                await this.$nextTick();

                // 현재 선택된 창고가 있다면 해당 레이아웃 로드
                if (this.currentWarehouseId) {
                    console.log('현재 선택된 창고의 레이아웃 로드:', this.currentWarehouseId);
                    setTimeout(() => {
                        this.loadWarehouseLayout();
                    }, 500);
                } else if (this.warehouses.length > 0) {
                    // 선택된 창고가 없고 창고가 있다면 첫 번째 창고 자동 선택
                    console.log('첫 번째 창고 자동 선택:', this.warehouses[0]);
                    this.currentWarehouseId = this.warehouses[0].id;

                    setTimeout(() => {
                        console.log('자동 선택된 창고의 레이아웃 로드 시작');
                        this.loadWarehouseLayout();
                    }, 500);
                }
            }, 400);
        },

        closeWarehouseModal() {
            this.showLocationDropdown = false;
            this.showWarehouseForm = false;
            this.isLayoutEditMode = false;
            // 키보드 이벤트 리스너 해제
            if (this._canvasKeyHandler) {
                document.removeEventListener('keydown', this._canvasKeyHandler);
                this._canvasKeyHandler = null;
            }
            this.$bvModal.hide('warehouseModal');
        },

        async loadWarehouses() {
            // 이미 로드된 창고가 있으면 다시 로드하지 않음
            if (this.warehouses && this.warehouses.length > 0) {
                console.log('창고 정보가 이미 로드되어 있습니다.');
                return;
            }

            try {
                console.log('창고관리 모달에서 창고 정보 로드');

                const response = await axios.post('/api/warehouses/load', {
                    companyid: this.$store.state.settings[0].companyid
                });

                if (response.data.success) {
                    this.warehouses = response.data.data.warehouses;
                    console.log('로드된 창고 목록:', this.warehouses);
                } else {
                    this.warehouses = [];
                }
            } catch (error) {
                console.error('창고 목록 로드 오류:', error);
                this.warehouses = [];
            }
        },

        selectWarehouse(warehouseId) {
            console.log('selectWarehouse 호출됨:', warehouseId);

            if (!warehouseId) {
                console.log('창고 ID가 없어서 초기화');
                this.currentWarehouseId = null;
                this.layoutAreas = [];
                this.storageAreas = [];
                this.selectedLayoutArea = null;
                this.selectedStorageArea = null;
                if (this.fabricCanvas) {
                    this.clearCanvas();
                    this.loadCanvasObjects();
                }
                return;
            }

            console.log('창고 선택:', warehouseId);
            console.log('캔버스 상태:', !!this.fabricCanvas);

            this.currentWarehouseId = warehouseId;

            // 선택 상태 초기화
            this.selectedLayoutArea = null;
            this.selectedStorageArea = null;

            // 캔버스가 초기화된 후에 레이아웃 로드
            if (this.fabricCanvas) {
                console.log('캔버스가 준비되어 즉시 레이아웃 로드');
                setTimeout(() => {
                    this.loadWarehouseLayout();
                }, 100);
            } else {
                console.log('캔버스가 아직 준비되지 않아 대기 중...');
                // 캔버스가 아직 초기화되지 않았다면 잠시 후 다시 시도
                let retryCount = 0;
                const checkCanvas = () => {
                    retryCount++;
                    if (this.fabricCanvas) {
                        console.log(`캔버스 준비됨 (${retryCount}번째 시도)`);
                        this.loadWarehouseLayout();
                    } else if (retryCount < 10) {
                        console.log(`캔버스 대기 중... (${retryCount}/10)`);
                        setTimeout(checkCanvas, 200);
                    } else {
                        console.error('캔버스 초기화 타임아웃');
                    }
                };
                setTimeout(checkCanvas, 200);
            }
        },

        showAddWarehouseForm() {
            console.log('새 창고 추가 버튼 클릭됨');
            console.log('변경 전 showWarehouseForm:', this.showWarehouseForm);
            this.showWarehouseForm = true;
            console.log('변경 후 showWarehouseForm:', this.showWarehouseForm);

            // Vue의 nextTick을 사용해서 DOM 업데이트 후 확인
            this.$nextTick(() => {
                console.log('nextTick 후 showWarehouseForm:', this.showWarehouseForm);
                const formElement = document.querySelector('.warehouse-form');
                console.log('폼 요소 찾기:', formElement);
            });
        },

        async saveWarehouse() {
            if (!this.warehouseForm.name.trim()) {
                alert('창고명을 입력해주세요.');
                return;
            }

            const newWarehouse = {
                id: 'wh_' + Date.now(),
                name: this.warehouseForm.name.trim(),
                address: this.warehouseForm.address.trim(),
                description: this.warehouseForm.description.trim()
            };

            this.warehouses.push(newWarehouse);

            try {
                // 서버에 창고 목록 저장
                const response = await axios.post('/api/warehouses/save', {
                    companyid: this.$store.state.settings[0].companyid,
                    warehouses: this.warehouses
                });

                if (response.data.success) {
                    this.currentWarehouseId = newWarehouse.id;
                    this.cancelWarehouseForm();
                    this.loadWarehouseLayout();
                } else {
                    alert('창고 저장 중 오류가 발생했습니다.');
                    this.warehouses.pop(); // 실패 시 추가한 창고 제거
                }
            } catch (error) {
                console.error('창고 저장 오류:', error);
                alert('창고 저장 중 오류가 발생했습니다.');
                this.warehouses.pop(); // 실패 시 추가한 창고 제거
            }
        },

        cancelWarehouseForm() {
            this.showWarehouseForm = false;
            this.warehouseForm = { name: '', address: '', description: '' };
        },

        async deleteWarehouse(warehouseId) {
            const warehouse = this.warehouses.find(w => w.id === warehouseId);
            if (!warehouse) return;

            if (confirm(`"${warehouse.name}" 창고를 삭제하시겠습니까?`)) {
                try {
                    this.warehouses = this.warehouses.filter(w => w.id !== warehouseId);

                    // 서버에 창고 목록 저장
                    const response = await axios.post('/api/warehouses/save', {
                        companyid: this.$store.state.settings[0].companyid,
                        warehouses: this.warehouses
                    });

                    if (response.data.success) {
                        // 삭제된 창고가 현재 선택된 창고인 경우
                        if (this.currentWarehouseId === warehouseId) {
                            this.currentWarehouseId = null;
                            this.layoutAreas = [];
                            this.storageAreas = [];
                            this.selectedLayoutArea = null;
                            this.selectedStorageArea = null;
                            if (this.fabricCanvas) {
                                this.clearCanvas();
                                this.loadCanvasObjects();
                            }
                        }
                    } else {
                        alert('창고 삭제 중 오류가 발생했습니다.');
                        // 실패 시 원복
                        this.warehouses.push(warehouse);
                    }
                } catch (error) {
                    console.error('창고 삭제 오류:', error);
                    alert('창고 삭제 중 오류가 발생했습니다.');
                    // 실패 시 원복
                    this.warehouses.push(warehouse);
                }
            }
        },

        getCurrentWarehouseName() {
            const warehouse = this.warehouses.find(w => w.id === this.currentWarehouseId);
            return warehouse ? warehouse.name : '';
        },

        // 2단계: 레이아웃 관리
        async loadWarehouseLayout() {
            console.log('loadWarehouseLayout 호출됨');
            console.log('currentWarehouseId:', this.currentWarehouseId);
            console.log('fabricCanvas 상태:', !!this.fabricCanvas);

            if (!this.currentWarehouseId) {
                console.log('창고 ID가 없어서 빈 상태로 초기화');
                this.layoutAreas = [];
                this.storageAreas = [];

                if (this.fabricCanvas) {
                    this.clearCanvas();
                    this.loadCanvasObjects();
                }
                return;
            }

            if (!this.fabricCanvas) {
                console.log('캔버스가 아직 초기화되지 않음. 잠시 후 재시도...');
                setTimeout(() => {
                    this.loadWarehouseLayout();
                }, 500);
                return;
            }

            try {
                console.log('레이아웃 로드 시작:', this.currentWarehouseId);

                // 서버에서 레이아웃 데이터 로드
                const response = await axios.post('/api/warehouse-layout/load', {
                    companyid: this.$store.state.settings[0].companyid,
                    warehouseId: this.currentWarehouseId
                });

                console.log('서버 응답:', response.data);

                if (response.data.success && response.data.data) {
                    const layoutData = response.data.data;
                    console.log('로드된 레이아웃 데이터:', layoutData);
                    console.log('레이아웃 구역 수:', layoutData.layoutAreas?.length || 0);
                    console.log('보관위치 수:', layoutData.storageAreas?.length || 0);

                    // 기존 데이터 초기화
                    this.layoutAreas = [];
                    this.storageAreas = [];

                    this.clearCanvas();

                    // 레이아웃 구역 복원
                    if (layoutData.layoutAreas && layoutData.layoutAreas.length > 0) {
                        console.log('레이아웃 구역 복원 시작');
                        layoutData.layoutAreas.forEach((areaData, index) => {
                            console.log(`레이아웃 구역 ${index + 1} 복원:`, areaData);
                            this.restoreLayoutArea(areaData);
                        });
                    }

                    // 보관위치 복원
                    if (layoutData.storageAreas && layoutData.storageAreas.length > 0) {
                        console.log('보관위치 복원 시작');
                        layoutData.storageAreas.forEach((areaData, index) => {
                            console.log(`보관위치 ${index + 1} 복원:`, areaData);
                            this.restoreStorageArea(areaData);
                        });
                    }

                    this.fabricCanvas.renderAll();
                    console.log('레이아웃 복원 완료');

                    // 위치 하이라이트 대기 중이면 실행
                    if (this.pendingHighlightLocation) {
                        const loc = this.pendingHighlightLocation;
                        this.pendingHighlightLocation = null;
                        this.$nextTick(() => {
                            this.highlightStorageOnCanvas(loc);
                        });
                    }
                } else {
                    // 저장된 레이아웃이 없는 경우
                    console.log('저장된 레이아웃이 없습니다.');
                    this.layoutAreas = [];
                    this.storageAreas = [];

                    this.clearCanvas();
                    this.loadCanvasObjects();
                }
            } catch (error) {
                console.error('레이아웃 로드 오류:', error);
                // 오류 시 빈 상태로 초기화
                this.layoutAreas = [];
                this.storageAreas = [];

                if (this.fabricCanvas) {
                    this.clearCanvas();
                    this.loadCanvasObjects();
                }
            }
        },

        toggleLayoutEditMode() {
            this.isLayoutEditMode = !this.isLayoutEditMode;
            this.selectedLayoutArea = null;
            this.selectedStorageArea = null;
            this.showLocationDropdown = false;

            // 편집 모드 전환 시 툴팁 숨김
            this.hideStorageLevelTooltip();

            // fabric.js 객체들의 상호작용 설정 업데이트
            this.updateCanvasInteractivity();
        },

        // 저장된 레이아웃 복원 메서드들
        restoreLayoutArea(areaData) {
            console.log('레이아웃 구역 복원:', areaData);

            const layoutRect = new fabric.Rect({
                left: areaData.x,
                top: areaData.y,
                width: areaData.width,
                height: areaData.height,
                rx: 12, ry: 12,
                fill: 'rgba(99, 102, 241, 0.08)',
                stroke: 'rgba(99, 102, 241, 0.5)',
                strokeWidth: 2,
                strokeDashArray: [8, 4],
                strokeUniform: true,
                shadow: new fabric.Shadow({ color: 'rgba(99,102,241,0.15)', blur: 12, offsetX: 0, offsetY: 4 }),
                selectable: this.isLayoutEditMode,
                hasControls: this.isLayoutEditMode,
                hasBorders: this.isLayoutEditMode,
                objectType: 'layout',
                areaId: areaData.id,
                areaName: areaData.name
            });

            const layoutText = new fabric.Text(areaData.name, {
                left: areaData.x + areaData.width - 10,
                top: areaData.y + 8,
                fontSize: 11,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fontWeight: '600',
                fill: 'rgba(99, 102, 241, 0.8)',
                originX: 'right',
                originY: 'top',
                selectable: false,
                objectType: 'layoutText',
                parentId: areaData.id
            });

            // 이벤트 연결
            this.attachLayoutEvents(layoutRect, layoutText);

            this.fabricCanvas.add(layoutRect);
            this.fabricCanvas.add(layoutText);

            const newLayoutArea = {
                id: areaData.id,
                name: areaData.name,
                fabricObject: layoutRect,
                textObject: layoutText,
                type: 'layout'
            };

            this.layoutAreas.push(newLayoutArea);
            console.log('레이아웃 구역 복원 완료:', newLayoutArea.id);
        },

        restoreStorageArea(areaData) {
            console.log('보관위치 복원:', areaData);
            const storageRect = new fabric.Rect({
                left: areaData.x,
                top: areaData.y,
                width: areaData.width,
                height: areaData.height,
                rx: 8, ry: 8,
                fill: 'rgba(16, 185, 129, 0.25)',
                stroke: 'rgba(16, 185, 129, 0.7)',
                strokeWidth: 2,
                strokeUniform: true,
                shadow: new fabric.Shadow({ color: 'rgba(16,185,129,0.2)', blur: 10, offsetX: 0, offsetY: 3 }),
                selectable: this.isLayoutEditMode,
                hasControls: this.isLayoutEditMode,
                hasBorders: this.isLayoutEditMode,
                objectType: 'storage',
                areaId: areaData.id,
                areaName: areaData.name,
                levels: areaData.levels || ['1층', '2층']
            });

            const storageText = new fabric.Text(areaData.name, {
                left: areaData.x + areaData.width / 2,
                top: areaData.y + areaData.height / 2 - 10,
                fontSize: 12,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fontWeight: '700',
                fill: '#e2e8f0',
                originX: 'center',
                originY: 'center',
                selectable: false,
                objectType: 'storageText',
                parentId: areaData.id
            });

            const levelText = new fabric.Text(`${areaData.levels?.length || 2}층`, {
                left: areaData.x + areaData.width / 2,
                top: areaData.y + areaData.height / 2 + 10,
                fontSize: 10,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fill: 'rgba(16, 185, 129, 0.9)',
                originX: 'center',
                originY: 'center',
                selectable: false,
                objectType: 'levelText',
                parentId: areaData.id
            });

            // 이벤트 연결
            this.attachStorageEvents(storageRect, storageText, levelText);

            this.fabricCanvas.add(storageRect);
            this.fabricCanvas.add(storageText);
            this.fabricCanvas.add(levelText);

            const newStorageArea = {
                id: areaData.id,
                name: areaData.name,
                fabricObject: storageRect,
                textObject: storageText,
                levelTextObject: levelText,
                type: 'storage',
                levels: areaData.levels || ['1층', '2층']
            };

            this.storageAreas.push(newStorageArea);
            console.log('보관위치 복원 완료:', newStorageArea.id);
        },

        // 이벤트 연결 헬퍼 메서드들
        // scale을 width/height로 정규화 (rx/ry 비례 확대 방지)
        normalizeScale(rect) {
            const w = rect.width * rect.scaleX;
            const h = rect.height * rect.scaleY;
            rect.set({ width: w, height: h, scaleX: 1, scaleY: 1 });
        },

        attachLayoutEvents(layoutRect, layoutText) {
            const updateTextPos = () => {
                layoutText.set({
                    left: layoutRect.left + layoutRect.width * layoutRect.scaleX - 5,
                    top: layoutRect.top + 5
                });
                this.fabricCanvas.renderAll();
            };

            layoutRect.on('moving', updateTextPos);
            layoutRect.on('scaling', updateTextPos);

            layoutRect.on('modified', () => {
                this.normalizeScale(layoutRect);
                updateTextPos();
            });
        },

        attachStorageEvents(storageRect, storageText, levelText) {
            const updateTextPos = () => {
                const centerX = storageRect.left + (storageRect.width * storageRect.scaleX) / 2;
                const centerY = storageRect.top + (storageRect.height * storageRect.scaleY) / 2;
                storageText.set({ left: centerX, top: centerY - 10 });
                levelText.set({ left: centerX, top: centerY + 10 });
                this.fabricCanvas.renderAll();
            };

            storageRect.on('moving', updateTextPos);
            storageRect.on('scaling', updateTextPos);

            storageRect.on('modified', () => {
                this.normalizeScale(storageRect);
                updateTextPos();
            });

            // 마우스 오버 이벤트 (편집 모드가 아닐 때만)
            storageRect.on('mouseover', (e) => {
                if (!this.isLayoutEditMode) {
                    this.showStorageLevelTooltip(e, storageRect);
                }
            });

            storageRect.on('mouseout', () => {
                if (!this.isLayoutEditMode) {
                    this.hideStorageLevelTooltip();
                }
            });
        },

        // 보관위치 층별 툴팁 관리
        showStorageLevelTooltip(e, storageRect) {
            // 기존 타이머가 있다면 취소
            if (this.tooltipHideTimer) {
                clearTimeout(this.tooltipHideTimer);
                this.tooltipHideTimer = null;
            }

            // 해당 보관위치 찾기
            const storageArea = this.storageAreas.find(area => area.fabricObject === storageRect);
            if (!storageArea) return;

            // 마우스 위치 계산 (툴팁이 보관위치에 더 가깝게)
            const canvasElement = this.fabricCanvas.getElement();
            const rect = canvasElement.getBoundingClientRect();

            this.hoveredStorageArea = storageArea;
            this.levelTooltipPosition = {
                x: e.e.clientX - rect.left + 5,  // 간격 줄임
                y: e.e.clientY - rect.top - 5   // 간격 줄임
            };
            this.showLevelTooltip = true;
        },

        hideStorageLevelTooltip() {
            // 지연 시간을 두고 숨김 (마우스가 툴팁으로 이동할 시간 확보)
            this.tooltipHideTimer = setTimeout(() => {
                this.showLevelTooltip = false;
                this.hoveredStorageArea = null;
                this.tooltipHideTimer = null;
            }, 300); // 300ms 지연
        },

        // 툴팁에 마우스가 들어왔을 때 숨김 취소
        onTooltipMouseEnter() {
            if (this.tooltipHideTimer) {
                clearTimeout(this.tooltipHideTimer);
                this.tooltipHideTimer = null;
            }
        },

        // 툴팁에서 마우스가 나갔을 때 숨김
        onTooltipMouseLeave() {
            this.hideStorageLevelTooltip();
        },

        // 층별 아이템 개수 조회 (실제 데이터)
        getItemCountForLevel(storageId, levelIndex) {
            if (!this.reqlistsinit || !Array.isArray(this.reqlistsinit)) {
                return 0;
            }

            // 해당 보관위치의 층에 있는 아이템 개수 조회
            const storageArea = this.storageAreas.find(area => area.id === storageId);
            if (!storageArea || !storageArea.levels[levelIndex]) {
                return 0;
            }

            const levelName = storageArea.levels[levelIndex];
            const warehouseName = this.getCurrentWarehouseName();

            if (!warehouseName) return 0;

            return this.reqlistsinit.filter(item => {
                return item.위치정보 &&
                       item.위치정보.창고 === warehouseName &&
                       item.위치정보.구역 === storageArea.name &&
                       item.위치정보.층 === levelName;
            }).length;
        },

        // 특정 층 선택 시 처리
        selectStorageLevel(storageArea, levelName, levelIndex) {
            console.log('선택된 보관위치:', storageArea.name, '층:', levelName);

            // 툴팁 숨기기
            this.hideStorageLevelTooltip();

            // 모달 닫기
            this.closeWarehouseModal();

            // 해당 층의 아이템들 로드
            this.loadItemsForStorageLevel(storageArea.id, levelIndex, levelName);
        },

        // 특정 층의 아이템들 로드
        loadItemsForStorageLevel(storageId, levelIndex, levelName) {
            try {
                console.log('아이템 로드:', storageId, levelIndex, levelName);

                // 해당 보관위치 정보 조회
                const storageArea = this.storageAreas.find(area => area.id === storageId);
                if (!storageArea) {
                    alert('보관위치 정보를 찾을 수 없습니다.');
                    return;
                }

                const warehouseName = this.getCurrentWarehouseName();

                if (!warehouseName) {
                    alert('창고 정보를 찾을 수 없습니다.');
                    return;
                }

                // reqlistsinit에서 해당 층의 아이템들 필터링
                const filteredItems = this.reqlistsinit.filter(item => {
                    return item.위치정보 &&
                           item.위치정보.창고 === warehouseName &&
                           item.위치정보.구역 === storageArea.name &&
                           item.위치정보.층 === levelName;
                });

                // reqlists를 필터링된 결과로 교체
                this.reqlists = filteredItems;

                // 선택된 층 정보 저장
                this.selectedStorageInfo = {
                    storageId: storageId,
                    levelIndex: levelIndex,
                    levelName: levelName,
                    itemCount: filteredItems.length,
                    warehouseName: warehouseName,
                    storageName: storageArea.name
                };

                // 사용자에게 알림
                if (filteredItems.length > 0) {
                    alert(`${levelName}의 아이템 ${filteredItems.length}개를 로드했습니다.`);
                } else {
                    alert(`${levelName}에는 아직 배치된 아이템이 없습니다.`);
                }

            } catch (error) {
                console.error('아이템 로드 오류:', error);
                alert('아이템 로드 중 오류가 발생했습니다.');
            }
        },

        // 선택된 층 정보 해제
        clearStorageSelection() {
            this.selectedStorageInfo = null;
            // reqlists를 원본 데이터로 복원
            this.reqlists = [...this.reqlistsinit];
            alert('필터가 해제되었습니다. 전체 아이템 목록을 표시합니다.');
        },

        // 위치 하이라이트: 테이블에서 구역/층 배지 클릭 시 모달 열고 해당 보관위치 강조
        async showLocationOnCanvas(locationInfo) {
            if (!locationInfo || !locationInfo.구역) {
                alert('위치 정보가 없습니다.');
                return;
            }

            // 해당 창고의 warehouse ID 찾기
            const targetWarehouse = this.warehouses.find(w => w.name === locationInfo.창고);
            if (!targetWarehouse) {
                alert(`"${locationInfo.창고}" 창고를 찾을 수 없습니다.`);
                return;
            }

            // 하이라이트 대상 저장 (loadWarehouseLayout 완료 후 실행됨)
            this.pendingHighlightLocation = locationInfo;

            // 해당 창고 선택
            this.currentWarehouseId = targetWarehouse.id;

            // 모달 열기 + 캔버스 초기화 + 레이아웃 로드
            await this.loadWarehouses();
            this.$bvModal.show('warehouseModal');

            setTimeout(async () => {
                this.initWarehouseCanvas();
                await this.$nextTick();

                if (this.currentWarehouseId) {
                    setTimeout(() => {
                        this.loadWarehouseLayout();
                    }, 500);
                }
            }, 400);
        },

        // 캔버스에서 보관위치 하이라이트 효과
        highlightStorageOnCanvas(locationInfo) {
            if (!locationInfo || !locationInfo.구역) return;

            const targetArea = this.storageAreas.find(area => area.name === locationInfo.구역);
            if (!targetArea || !targetArea.fabricObject) {
                console.log('하이라이트 대상 보관위치를 찾을 수 없음:', locationInfo.구역);
                return;
            }

            console.log('보관위치 하이라이트:', targetArea.name);

            // 이전 하이라이트 타이머 클리어
            if (this.highlightTimer) {
                clearTimeout(this.highlightTimer);
                this.highlightTimer = null;
            }

            const rect = targetArea.fabricObject;
            const originalStroke = rect.stroke;
            const originalStrokeWidth = rect.strokeWidth;
            const originalFill = rect.fill;
            const originalShadow = rect.shadow;

            // 하이라이트 스타일 적용
            rect.set({
                stroke: '#f59e0b',
                strokeWidth: 4,
                fill: 'rgba(245, 158, 11, 0.25)',
                shadow: new fabric.Shadow({ color: 'rgba(245,158,11,0.5)', blur: 20, offsetX: 0, offsetY: 0 })
            });
            this.fabricCanvas.renderAll();

            // 3초 후 원래 스타일로 원복
            this.highlightTimer = setTimeout(() => {
                rect.set({
                    stroke: originalStroke,
                    strokeWidth: originalStrokeWidth,
                    fill: originalFill,
                    shadow: originalShadow
                });
                this.fabricCanvas.renderAll();
                this.highlightTimer = null;
            }, 3000);
        },

        // 위치별 필터링 (테이블에서 배지 클릭 시)
        filterByLocation(type, value) {
            if (!value) return;

            console.log(`${type}별 필터링:`, value);

            // 해당 위치의 아이템들만 필터링
            const filteredItems = this.reqlistsinit.filter(item => {
                if (!item.위치정보) return false;

                switch (type) {
                    case '창고':
                        return item.위치정보.창고 === value;
                    case '구역':
                        return item.위치정보.구역 === value;
                    case '층':
                        return item.위치정보.층 === value;
                    default:
                        return false;
                }
            });

            // reqlists를 필터링된 결과로 교체
            this.reqlists = filteredItems;

            // 필터 정보 저장 (위치 설정과 다른 형태)
            this.selectedLocationFilter = {
                type: type,
                value: value,
                itemCount: filteredItems.length
            };

            // 사용자에게 알림
            alert(`${type} "${value}"로 필터링되었습니다. ${filteredItems.length}개 아이템이 표시됩니다.`);
        },

        // 위치 필터 해제
        clearLocationFilter() {
            this.selectedLocationFilter = null;
            this.reqlists = [...this.reqlistsinit];
            alert('위치 필터가 해제되었습니다. 전체 아이템 목록을 표시합니다.');
        },

        // 구역 이름 자동생성 (A1, A2, A3...)
        generateLayoutAreaName() {
            const existing = this.layoutAreas.map(a => a.name);
            let i = 1;
            while (existing.includes(`A${i}`)) i++;
            return `A${i}`;
        },

        // 보관위치 이름 자동생성 (B1, B2, B3...)
        generateStorageAreaName() {
            const existing = this.storageAreas.map(a => a.name);
            let i = 1;
            while (existing.includes(`B${i}`)) i++;
            return `B${i}`;
        },

        // 레이아웃 구역 추가 (시각적 배치용) - 개별 객체로 관리
        addLayoutArea() {
            const areaId = 'layout_' + Date.now();
            const areaName = this.generateLayoutAreaName();
            const left = 100 + (this.layoutAreas.length * 30);
            const top = 100 + (this.layoutAreas.length * 30);

            // 도형 객체 (모던 스타일)
            const layoutRect = new fabric.Rect({
                left: left,
                top: top,
                width: 200,
                height: 150,
                rx: 12, ry: 12,
                fill: 'rgba(99, 102, 241, 0.08)',
                stroke: 'rgba(99, 102, 241, 0.5)',
                strokeWidth: 2,
                strokeDashArray: [8, 4],
                strokeUniform: true,
                shadow: new fabric.Shadow({ color: 'rgba(99,102,241,0.15)', blur: 12, offsetX: 0, offsetY: 4 }),
                selectable: this.isLayoutEditMode,
                hasControls: this.isLayoutEditMode,
                hasBorders: this.isLayoutEditMode,
                objectType: 'layout',
                areaId: areaId,
                areaName: areaName
            });

            // 텍스트 객체 (우측 상단)
            const layoutText = new fabric.Text(areaName, {
                left: left + 200 - 10,
                top: top + 8,
                fontSize: 11,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fontWeight: '600',
                fill: 'rgba(99, 102, 241, 0.8)',
                originX: 'right',
                originY: 'top',
                selectable: false,
                objectType: 'layoutText',
                parentId: areaId
            });

            // 이벤트 연결
            this.attachLayoutEvents(layoutRect, layoutText);

            this.fabricCanvas.add(layoutRect);
            this.fabricCanvas.add(layoutText);

            const newLayoutArea = {
                id: areaId,
                name: areaName,
                fabricObject: layoutRect,
                textObject: layoutText,
                type: 'layout'
            };

            this.layoutAreas.push(newLayoutArea);
            this.selectedLayoutArea = newLayoutArea;
            this.selectedStorageArea = null;

            this.fabricCanvas.setActiveObject(layoutRect);
            this.fabricCanvas.renderAll();
        },

        // 보관위치 추가 (실제 보관 공간) - 개별 객체로 관리
        addStorageArea() {
            const areaId = 'storage_' + Date.now();
            const areaName = this.generateStorageAreaName();
            const levels = ['1층', '2층'];
            const left = 150 + (this.storageAreas.length * 30);
            const top = 150 + (this.storageAreas.length * 30);

            // 도형 객체 (모던 스타일)
            const storageRect = new fabric.Rect({
                left: left,
                top: top,
                width: 120,
                height: 80,
                rx: 8, ry: 8,
                fill: 'rgba(16, 185, 129, 0.25)',
                stroke: 'rgba(16, 185, 129, 0.7)',
                strokeWidth: 2,
                strokeUniform: true,
                shadow: new fabric.Shadow({ color: 'rgba(16,185,129,0.2)', blur: 10, offsetX: 0, offsetY: 3 }),
                selectable: this.isLayoutEditMode,
                hasControls: this.isLayoutEditMode,
                hasBorders: this.isLayoutEditMode,
                objectType: 'storage',
                areaId: areaId,
                areaName: areaName,
                levels: levels
            });

            // 가운데에 보관위치명
            const storageText = new fabric.Text(areaName, {
                left: left + 60,
                top: top + 30,
                fontSize: 12,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fontWeight: '700',
                fill: '#e2e8f0',
                originX: 'center',
                originY: 'center',
                selectable: false,
                objectType: 'storageText',
                parentId: areaId
            });

            // 하단에 층수 정보
            const levelText = new fabric.Text(`${levels.length}층`, {
                left: left + 60,
                top: top + 60,
                fontSize: 10,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fill: 'rgba(16, 185, 129, 0.9)',
                originX: 'center',
                originY: 'center',
                selectable: false,
                objectType: 'levelText',
                parentId: areaId
            });

            // 이벤트 연결
            this.attachStorageEvents(storageRect, storageText, levelText);

            this.fabricCanvas.add(storageRect);
            this.fabricCanvas.add(storageText);
            this.fabricCanvas.add(levelText);

            const newStorageArea = {
                id: areaId,
                name: areaName,
                fabricObject: storageRect,
                textObject: storageText,
                levelTextObject: levelText,
                type: 'storage',
                levels: levels
            };

            this.storageAreas.push(newStorageArea);
            this.selectedStorageArea = newStorageArea;
            this.selectedLayoutArea = null;

            this.fabricCanvas.setActiveObject(storageRect);
            this.fabricCanvas.renderAll();
        },

        // 선택된 구역/보관위치 복사
        copyArea(fabricObject) {
            if (fabricObject.objectType === 'layout') {
                const area = this.layoutAreas.find(a => a.id === fabricObject.areaId);
                if (area) {
                    this.clipboardArea = { type: 'layout', data: area };
                }
            } else if (fabricObject.objectType === 'storage') {
                const area = this.storageAreas.find(a => a.id === fabricObject.areaId);
                if (area) {
                    this.clipboardArea = { type: 'storage', data: area };
                }
            }
        },

        // 복사된 구역/보관위치 붙여넣기 (우측 하단 오프셋)
        pasteArea() {
            if (!this.clipboardArea) return;
            const offset = 30;

            if (this.clipboardArea.type === 'layout') {
                const orig = this.clipboardArea.data;
                const areaId = 'layout_' + Date.now();
                const areaName = this.generateLayoutAreaName();
                const left = orig.fabricObject.left + offset;
                const top = orig.fabricObject.top + offset;
                const w = orig.fabricObject.width * (orig.fabricObject.scaleX || 1);
                const h = orig.fabricObject.height * (orig.fabricObject.scaleY || 1);

                const layoutRect = new fabric.Rect({
                    left, top, width: w, height: h,
                    rx: 12, ry: 12,
                    fill: 'rgba(99, 102, 241, 0.08)',
                    stroke: 'rgba(99, 102, 241, 0.5)',
                    strokeWidth: 2,
                    strokeDashArray: [8, 4],
                    strokeUniform: true,
                    shadow: new fabric.Shadow({ color: 'rgba(99,102,241,0.15)', blur: 12, offsetX: 0, offsetY: 4 }),
                    selectable: this.isLayoutEditMode,
                    hasControls: this.isLayoutEditMode,
                    hasBorders: this.isLayoutEditMode,
                    objectType: 'layout',
                    areaId: areaId,
                    areaName: areaName
                });

                const layoutText = new fabric.Text(areaName, {
                    left: left + w - 10, top: top + 8,
                    fontSize: 11,
                    fontFamily: 'Pretendard, -apple-system, sans-serif',
                    fontWeight: '600',
                    fill: 'rgba(99, 102, 241, 0.8)',
                    originX: 'right', originY: 'top',
                    selectable: false,
                    objectType: 'layoutText',
                    parentId: areaId
                });

                this.attachLayoutEvents(layoutRect, layoutText);
                this.fabricCanvas.add(layoutRect);
                this.fabricCanvas.add(layoutText);

                const newArea = { id: areaId, name: areaName, fabricObject: layoutRect, textObject: layoutText, type: 'layout' };
                this.layoutAreas.push(newArea);
                this.selectedLayoutArea = newArea;
                this.selectedStorageArea = null;
                this.fabricCanvas.setActiveObject(layoutRect);
                this.fabricCanvas.renderAll();

            } else if (this.clipboardArea.type === 'storage') {
                const orig = this.clipboardArea.data;
                const areaId = 'storage_' + Date.now();
                const areaName = this.generateStorageAreaName();
                const levels = [...orig.levels];
                const left = orig.fabricObject.left + offset;
                const top = orig.fabricObject.top + offset;
                const w = orig.fabricObject.width * (orig.fabricObject.scaleX || 1);
                const h = orig.fabricObject.height * (orig.fabricObject.scaleY || 1);

                const storageRect = new fabric.Rect({
                    left, top, width: w, height: h,
                    rx: 8, ry: 8,
                    fill: 'rgba(16, 185, 129, 0.25)',
                    stroke: 'rgba(16, 185, 129, 0.7)',
                    strokeWidth: 2,
                    strokeUniform: true,
                    shadow: new fabric.Shadow({ color: 'rgba(16,185,129,0.2)', blur: 10, offsetX: 0, offsetY: 3 }),
                    selectable: this.isLayoutEditMode,
                    hasControls: this.isLayoutEditMode,
                    hasBorders: this.isLayoutEditMode,
                    objectType: 'storage',
                    areaId: areaId,
                    areaName: areaName,
                    levels: levels
                });

                const storageText = new fabric.Text(areaName, {
                    left: left + w / 2, top: top + h * 0.375,
                    fontSize: 12,
                    fontFamily: 'Pretendard, -apple-system, sans-serif',
                    fontWeight: '700',
                    fill: '#e2e8f0',
                    originX: 'center', originY: 'center',
                    selectable: false,
                    objectType: 'storageText',
                    parentId: areaId
                });

                const levelText = new fabric.Text(`${levels.length}층`, {
                    left: left + w / 2, top: top + h * 0.75,
                    fontSize: 10,
                    fontFamily: 'Pretendard, -apple-system, sans-serif',
                    fill: 'rgba(16, 185, 129, 0.9)',
                    originX: 'center', originY: 'center',
                    selectable: false,
                    objectType: 'levelText',
                    parentId: areaId
                });

                this.attachStorageEvents(storageRect, storageText, levelText);
                this.fabricCanvas.add(storageRect);
                this.fabricCanvas.add(storageText);
                this.fabricCanvas.add(levelText);

                const newArea = { id: areaId, name: areaName, fabricObject: storageRect, textObject: storageText, levelTextObject: levelText, type: 'storage', levels: levels };
                this.storageAreas.push(newArea);
                this.selectedStorageArea = newArea;
                this.selectedLayoutArea = null;
                this.fabricCanvas.setActiveObject(storageRect);
                this.fabricCanvas.renderAll();
            }
        },

        async saveLayout() {
            if (!this.currentWarehouseId) {
                alert('창고를 선택해주세요.');
                return;
            }

            try {
                // 현재 레이아웃 데이터 수집
                const layoutData = {
                    layoutAreas: this.layoutAreas.map(area => ({
                        id: area.id,
                        name: area.name,
                        type: area.type,
                        x: area.fabricObject.left,
                        y: area.fabricObject.top,
                        width: area.fabricObject.width * (area.fabricObject.scaleX || 1),
                        height: area.fabricObject.height * (area.fabricObject.scaleY || 1)
                    })),
                    storageAreas: this.storageAreas.map(area => ({
                        id: area.id,
                        name: area.name,
                        type: area.type,
                        levels: area.levels,
                        x: area.fabricObject.left,
                        y: area.fabricObject.top,
                        width: area.fabricObject.width * (area.fabricObject.scaleX || 1),
                        height: area.fabricObject.height * (area.fabricObject.scaleY || 1)
                    }))
                };

                console.log('저장할 레이아웃 데이터:', layoutData);

                // 서버에 레이아웃 데이터 저장
                const response = await axios.post('/api/warehouse-layout/save', {
                    companyid: this.$store.state.settings[0].companyid,
                    warehouseId: this.currentWarehouseId,
                    ...layoutData
                });

                if (response.data.success) {
                    alert('레이아웃이 저장되었습니다.');
                } else {
                    alert('저장 중 오류가 발생했습니다.');
                }
            } catch (error) {
                console.error('레이아웃 저장 오류:', error);
                alert('저장 중 오류가 발생했습니다.');
            }
        },

        // 레이아웃 구역 편집
        updateLayoutArea() {
            if (!this.selectedLayoutArea) return;

            if (!this.selectedLayoutArea.name.trim()) {
                alert('레이아웃 구역명을 입력해주세요.');
                return;
            }

            // fabric.js 그룹 내의 텍스트 업데이트
            this.updateLayoutAreaDisplay();
            alert('레이아웃 구역이 업데이트되었습니다.');
        },

        updateLayoutAreaDisplay() {
            if (!this.selectedLayoutArea || !this.selectedLayoutArea.textObject) return;

            // 텍스트 객체 직접 업데이트
            this.selectedLayoutArea.textObject.set('text', this.selectedLayoutArea.name);

            // 도형 객체의 areaName도 업데이트
            this.selectedLayoutArea.fabricObject.areaName = this.selectedLayoutArea.name;

            this.fabricCanvas.renderAll();
        },

        deleteLayoutArea() {
            if (!this.selectedLayoutArea) return;

            if (confirm(`"${this.selectedLayoutArea.name}" 레이아웃 구역을 삭제하시겠습니까?`)) {
                // Fabric.js 캔버스에서 객체 제거
                if (this.fabricCanvas && this.selectedLayoutArea.fabricObject) {
                    this.fabricCanvas.remove(this.selectedLayoutArea.fabricObject);
                    if (this.selectedLayoutArea.textObject) {
                        this.fabricCanvas.remove(this.selectedLayoutArea.textObject);
                    }
                }
                this.layoutAreas = this.layoutAreas.filter(area => area.id !== this.selectedLayoutArea.id);
                this.selectedLayoutArea = null;
                if (this.fabricCanvas) this.fabricCanvas.renderAll();
            }
        },

        // 보관위치 편집
        addLevel() {
            if (this.selectedStorageArea) {
                const levelCount = this.selectedStorageArea.levels.length;
                this.selectedStorageArea.levels.push(`${levelCount + 1}층`);
                this.updateStorageAreaDisplay();
            }
        },

        removeLevel() {
            if (this.selectedStorageArea && this.selectedStorageArea.levels.length > 1) {
                this.selectedStorageArea.levels.pop(); // 마지막 층 제거
                this.updateStorageAreaDisplay();
            }
        },

        updateStorageAreaDisplay() {
            if (!this.selectedStorageArea || !this.selectedStorageArea.levelTextObject) return;

            // 층수 텍스트 직접 업데이트 (총 층수만 표시)
            this.selectedStorageArea.levelTextObject.set('text', `${this.selectedStorageArea.levels.length}층`);

            // 도형 객체의 levels도 업데이트
            this.selectedStorageArea.fabricObject.levels = [...this.selectedStorageArea.levels];

            this.fabricCanvas.renderAll();
        },

        updateStorageArea() {
            if (!this.selectedStorageArea) return;

            if (!this.selectedStorageArea.name.trim()) {
                alert('보관위치명을 입력해주세요.');
                return;
            }

            // fabric.js 그룹 내의 텍스트 업데이트
            this.updateStorageAreaNameDisplay();
            alert('보관위치가 업데이트되었습니다.');
        },

        updateStorageAreaNameDisplay() {
            if (!this.selectedStorageArea || !this.selectedStorageArea.textObject) return;

            // 보관위치명 텍스트 직접 업데이트
            this.selectedStorageArea.textObject.set('text', this.selectedStorageArea.name);

            // 도형 객체의 areaName도 업데이트
            this.selectedStorageArea.fabricObject.areaName = this.selectedStorageArea.name;

            this.fabricCanvas.renderAll();
        },

        deleteStorageArea() {
            if (!this.selectedStorageArea) return;

            if (confirm(`"${this.selectedStorageArea.name}" 보관위치를 삭제하시겠습니까?`)) {
                // Fabric.js 캔버스에서 객체 제거
                if (this.fabricCanvas && this.selectedStorageArea.fabricObject) {
                    this.fabricCanvas.remove(this.selectedStorageArea.fabricObject);
                    if (this.selectedStorageArea.textObject) {
                        this.fabricCanvas.remove(this.selectedStorageArea.textObject);
                    }
                    if (this.selectedStorageArea.levelTextObject) {
                        this.fabricCanvas.remove(this.selectedStorageArea.levelTextObject);
                    }
                }
                this.storageAreas = this.storageAreas.filter(area => area.id !== this.selectedStorageArea.id);
                this.selectedStorageArea = null;
                if (this.fabricCanvas) this.fabricCanvas.renderAll();
            }
        },

        // fabric.js 이벤트 핸들러들
        onObjectSelected(e) {
            const activeObject = e.target;
            if (activeObject.objectType === 'layout') {
                this.selectedLayoutArea = this.layoutAreas.find(area => area.id === activeObject.areaId);
                this.selectedStorageArea = null;
            } else if (activeObject.objectType === 'storage') {
                this.selectedStorageArea = this.storageAreas.find(area => area.id === activeObject.areaId);
                this.selectedLayoutArea = null;
            }
        },

        onObjectDeselected() {
            this.selectedLayoutArea = null;
            this.selectedStorageArea = null;
        },

        updateCanvasInteractivity() {
            if (!this.fabricCanvas) return;

            this.fabricCanvas.forEachObject((obj) => {
                if (obj.objectType === 'layout' || obj.objectType === 'storage') {
                    obj.selectable = this.isLayoutEditMode;
                    obj.hasControls = this.isLayoutEditMode;
                    obj.hasBorders = this.isLayoutEditMode;
                }
            });

            this.fabricCanvas.renderAll();
        },

        loadCanvasObjects() {
            // 기존 객체들을 fabric.js 객체로 변환하여 캔버스에 추가
            // 현재는 빈 상태로 시작
            if (!this.currentWarehouseId) {
                this.showEmptyMessage();
            }
        },

        showEmptyMessage() {
            const emptyText = new fabric.Text('창고를 선택해주세요', {
                left: this.fabricCanvas.width / 2,
                top: this.fabricCanvas.height / 2,
                fontSize: 15,
                fontFamily: 'Pretendard, -apple-system, sans-serif',
                fill: 'rgba(255,255,255,0.3)',
                textAlign: 'center',
                originX: 'center',
                originY: 'center',
                selectable: false,
                objectType: 'emptyMessage'
            });

            this.fabricCanvas.add(emptyText);
            this.fabricCanvas.renderAll();
        },

        clearCanvas() {
            this.fabricCanvas.clear();
            this.fabricCanvas.backgroundColor = '#1e1e2e';
        },

        initWarehouseCanvas() {
            console.log('initWarehouseCanvas 호출됨');

            // nextTick을 사용해서 DOM이 완전히 렌더링된 후 초기화
            this.$nextTick(() => {
                try {
                    console.log('캔버스 초기화 시작');

                    // 캔버스 엘리먼트 확인
                    const canvasElement = document.getElementById('warehouseCanvas');
                    if (!canvasElement) {
                        console.error('캔버스 엘리먼트를 찾을 수 없습니다.');
                        return;
                    }
                    console.log('캔버스 엘리먼트 찾음:', canvasElement);

                    // 컨테이너 크기 계산 (.wl-canvas-wrap 기준)
                    const container = this.$refs.canvasWrap;
                    let containerWidth = 700;
                    let canvasHeight = 500;

                    if (container) {
                        containerWidth = container.clientWidth - 2;
                        canvasHeight = container.clientHeight - 2;

                        // 최소 크기 제한
                        if (containerWidth < 400) containerWidth = 400;
                        if (canvasHeight < 300) canvasHeight = 300;
                    }

                    console.log('캔버스 크기:', containerWidth, 'x', canvasHeight);

                    // 기존 캔버스가 있다면 정리
                    if (this.fabricCanvas) {
                        console.log('기존 캔버스 정리');
                        if (this._canvasKeyHandler) {
                            document.removeEventListener('keydown', this._canvasKeyHandler);
                            this._canvasKeyHandler = null;
                        }
                        this.fabricCanvas.dispose();
                        this.fabricCanvas = null;
                    }

                    // fabric.js Canvas 초기화
                    this.fabricCanvas = new fabric.Canvas('warehouseCanvas', {
                        width: containerWidth,
                        height: canvasHeight,
                        backgroundColor: '#1e1e2e',
                        selection: false,
                        fireMiddleClick: true,
                        stopContextMenu: true
                    });

                    // 그리드 배경 그리기
                    const gridSize = 30;
                    for (let x = 0; x <= containerWidth; x += gridSize) {
                        this.fabricCanvas.add(new fabric.Line([x, 0, x, canvasHeight], {
                            stroke: 'rgba(255,255,255,0.04)', strokeWidth: 1,
                            selectable: false, evented: false, objectType: 'grid'
                        }));
                    }
                    for (let y = 0; y <= canvasHeight; y += gridSize) {
                        this.fabricCanvas.add(new fabric.Line([0, y, containerWidth, y], {
                            stroke: 'rgba(255,255,255,0.04)', strokeWidth: 1,
                            selectable: false, evented: false, objectType: 'grid'
                        }));
                    }

                    console.log('fabric.js 캔버스 초기화 완료 (그리드 포함)');
                } catch (error) {
                    console.error('캔버스 초기화 오류:', error);
                }

                // 편집 모드가 아닐 때는 객체 선택 비활성화
                this.updateCanvasInteractivity();

                // 객체 선택 이벤트
                this.fabricCanvas.on('selection:created', this.onObjectSelected);
                this.fabricCanvas.on('selection:updated', this.onObjectSelected);
                this.fabricCanvas.on('selection:cleared', this.onObjectDeselected);

                // Ctrl + 스크롤 줌
                this.fabricCanvas.on('mouse:wheel', (opt) => {
                    if (!opt.e.ctrlKey) return;
                    opt.e.preventDefault();
                    opt.e.stopPropagation();

                    const delta = opt.e.deltaY;
                    let zoom = this.fabricCanvas.getZoom();
                    zoom *= 0.999 ** delta;
                    if (zoom > 5) zoom = 5;
                    if (zoom < 0.3) zoom = 0.3;

                    this.fabricCanvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
                });

                // 마우스 중간 버튼(스크롤 클릭) 드래그로 캔버스 패닝
                let isPanning = false;
                let lastPanX = 0;
                let lastPanY = 0;

                const canvasEl = this.fabricCanvas.upperCanvasEl;

                this.fabricCanvas.on('mouse:down', (opt) => {
                    if (opt.e.button === 1) { // 중간 버튼
                        isPanning = true;
                        lastPanX = opt.e.clientX;
                        lastPanY = opt.e.clientY;
                        canvasEl.style.cursor = 'grabbing';
                        opt.e.preventDefault();
                    }
                });

                this.fabricCanvas.on('mouse:move', (opt) => {
                    if (!isPanning) return;
                    const vpt = this.fabricCanvas.viewportTransform;
                    vpt[4] += opt.e.clientX - lastPanX;
                    vpt[5] += opt.e.clientY - lastPanY;
                    lastPanX = opt.e.clientX;
                    lastPanY = opt.e.clientY;
                    canvasEl.style.cursor = 'grabbing';
                    this.fabricCanvas.requestRenderAll();
                });

                this.fabricCanvas.on('mouse:up', (opt) => {
                    if (opt.e.button === 1) {
                        isPanning = false;
                        canvasEl.style.cursor = 'default';
                    }
                });

                // Ctrl+C / Ctrl+V 복사 붙여넣기 + Delete 삭제
                this._canvasKeyHandler = (e) => {
                    if (!this.fabricCanvas || !this.isLayoutEditMode) return;
                    if (e.ctrlKey && e.key === 'c') {
                        const active = this.fabricCanvas.getActiveObject();
                        if (active && (active.objectType === 'layout' || active.objectType === 'storage')) {
                            this.copyArea(active);
                            e.preventDefault();
                        }
                    }
                    if (e.ctrlKey && e.key === 'v') {
                        if (this.clipboardArea) {
                            this.pasteArea();
                            e.preventDefault();
                        }
                    }
                    if (e.key === 'Delete') {
                        const active = this.fabricCanvas.getActiveObject();
                        if (active && active.objectType === 'layout') {
                            this.deleteLayoutArea();
                            e.preventDefault();
                        } else if (active && active.objectType === 'storage') {
                            this.deleteStorageArea();
                            e.preventDefault();
                        }
                    }
                };
                document.addEventListener('keydown', this._canvasKeyHandler);

                this.loadCanvasObjects();
            });
        },

    },
    mounted() {
        // 화주 로그인 시 자동으로 companyid 설정
        if (!this.isAdmin && this.$store.state.user.companyid) {
            this.업체명 = this.$store.state.user.companyid;
        }

        // 창고 정보 자동 로드
        this.loadWarehousesOnMount();

        // URL 쿼리 파라미터에서 requestId가 있는지 확인
        const requestId = this.$route.query.requestId;
        if (requestId) {
            this.loadSingleRequest(requestId);
        } else {
            // Vuex 캐시 있으면 즉시 표시 후 백그라운드 갱신
            const cache = this.$store.state.stockManagement;
            const vuexTab = this.activeTab === 'overseas' ? 'overseas' : 'domestic';
            if (cache.lastLoaded && cache[vuexTab].length > 0) {
                this.reqlists = cache[vuexTab];
                this.reqlistsinit = [...cache[vuexTab]];
                this.statusCounts = cache.counts;
                this.total = cache[vuexTab].length;
                this.showreqlist = true;
                // 백그라운드 갱신 (스피너 없이)
                this.search();
            } else {
                this.search();
            }
        }
    },
    beforeDestroy() {
        // 타이머 정리
        if (this.tooltipHideTimer) {
            clearTimeout(this.tooltipHideTimer);
            this.tooltipHideTimer = null;
        }
    },
}
</script>
<style>
.my-class .dropdown-menu {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 100px;
    width: 300px;
    z-index: 10000;
    overflow-y: auto;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}

.modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.checklist-group {
    margin-bottom: 25px;
    width: 100%
}

.group-title {
    color: #34495e;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
}

.checklist-items {
    width: 100%;
    /* 최대 너비 사용 */
}

.checklist-items .form-control {
    width: calc(100% - 120px);
    /* 버튼 공간 확보 */
    max-width: none;
    /* auto 너비 제한 해제 */
}

.inspection-checklist ul {
    list-style-type: none;
    padding-left: 20px;
    margin-bottom: 15px;
}

.inspection-checklist li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #596068;
}

.inspection-checklist li:before {
    content: "•";
    color: #3498db;
    position: absolute;
    left: 0;
    font-weight: bold;
}

.inspection-checklist textarea {
    border: 1px solid #e9ecef;
    resize: vertical;
    width: 100%;
}

.inspection-checklist textarea:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 10000;
    overflow-y: auto;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.warning2 {
    font-size: 16px;
    color: #e83e8c;
    font-weight: bold;
}

.status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.status-area {
    width: 30%;
    padding: 20px;
}

.status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.status-tit {
    margin-bottom: 20px;
}

.status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.status-txt a {
    cursor: pointer;
}

.status-txt span {
    font-weight: bold;
}

.purchase-request-form {
    padding: 1rem;
}

.form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    width: 100%;
}

.section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.input-wrapper {
    margin-bottom: 1rem;
}

.stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.info-label {
    color: #495057;
}

.info-value {
    font-weight: 500;
    color: #212529;
}

.separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.custom-radio-card:hover {
    background: #e9ecef;
}

.custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

textarea.form-control {
    min-height: 100px;
}

.text-muted {
    font-size: 0.85rem;
}

.inspection-request {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-header {
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 15px;
}

.section-title {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 5px;
}

.checklist-group {
    margin-bottom: 25px;
    width: 100%
}

.group-title {
    color: #34495e;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
}

.sub-group {
    margin-left: 20px;
    margin-bottom: 15px;
}

.sub-title {
    color: #7f8c8d;
    font-weight: 500;
    margin-bottom: 10px;
    font-size: 1rem;
}

.inspection-checklist ul {
    list-style-type: none;
    padding-left: 20px;
    margin-bottom: 15px;
}

.inspection-checklist li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #596068;
}

.inspection-checklist li:before {
    content: "•";
    color: #3498db;
    position: absolute;
    left: 0;
    font-weight: bold;
}

.request-input {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 6px;
    margin-top: 20px;
}

.request-input label {
    font-weight: 500;
    color: #2c3e50;
    margin-bottom: 10px;
    display: block;
}

.inspection-checklist textarea {
    border: 1px solid #e9ecef;
    resize: vertical;
    width: 100%;
}

.inspection-checklist textarea:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
}

@media (max-width: 768px) {
    .inspection-request {
        padding: 15px;
    }

    .sub-group {
        margin-left: 10px;
    }
}

.checklist-items {
    width: 100%;
    /* 최대 너비 사용 */
}

/* 체크리스트 항목 내 입력 필드 너비 조정 */
.checklist-items .form-control {
    width: calc(100% - 120px);
    /* 버튼 공간 확보 */
    max-width: none;
    /* auto 너비 제한 해제 */
}


.purchase-notice {
    padding: 20px;
    font-size: 14px;
    line-height: 1.6;
}

.notice-title {
    color: #1a73e8;
    font-weight: 600;
    text-align: center;
}

.notice-item {
    display: flex;
    margin-bottom: 15px;
}

.notice-number {
    flex: 0 0 30px;
    font-weight: 600;
    color: #1a73e8;
}

.notice-content {
    flex: 1;
}

.warning-text {
    color: #dc3545;
    font-size: 13px;
    margin-top: 5px;
    padding-left: 30px;
}

/* 중요 사항 강조 */
.notice-content strong {
    color: #dc3545;
    font-weight: 600;
}

::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 9999;
    overflow-y: auto;
}

::v-deep #modal-scrollable .modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.reqpo-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reqpo-status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.reqpo-status-area {
    width: 30%;
    padding: 20px;
}

.reqpo-status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.reqpo-status-tit {
    margin-bottom: 20px;
}

.reqpo-status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.reqpo-status-txt a {
    cursor: pointer;
}

.reqpo-status-txt span {
    font-weight: bold;
}

.reqpo-purchase-request-form {
    padding: 1rem;
}

.reqpo-form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.reqpo-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.reqpo-input-wrapper {
    margin-bottom: 1rem;
}

.reqpo-stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.reqpo-info-label {
    color: #495057;
}

.reqpo-info-value {
    font-weight: 500;
    color: #212529;
}

.reqpo-separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.reqpo-custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reqpo-custom-radio-card:hover {
    background: #e9ecef;
}

.reqpo-custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.reqpo-card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.reqpo-card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.reqpo-warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.reqpo-option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    font-size: 0.85rem;
}
</style>
